export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CustomDate: any;
  CustomDateTime: any;
  Date: any;
  DateTime: any;
  GenericScalar: any;
  JSONString: any;
  UUID: any;
};

export type AccountType = {
  __typename?: 'AccountType';
  amount?: Maybe<Scalars['Int']>;
  amountSum?: Maybe<Scalars['Int']>;
  answer?: Maybe<Array<AnswerType>>;
  answeraccount?: Maybe<Array<AnswerAccountType>>;
  /** competition */
  competition?: Maybe<CompetitionType>;
  competitionSlug?: Maybe<Scalars['String']>;
  countOperations?: Maybe<Scalars['Int']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isGetCache?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  multiplier?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  operationCreatedMax?: Maybe<Scalars['String']>;
  /** participant */
  participant?: Maybe<ParticipantType>;
  promocode?: Maybe<Array<PromoCodeType>>;
  rowNumber?: Maybe<Scalars['Int']>;
  toDate?: Maybe<Scalars['Date']>;
};

export type ActionDivisionInput = {
  divisionAddress: AddressInput;
  divisionEmail: Scalars['String'];
  divisionName: Scalars['String'];
  divisionPhone: Scalars['String'];
  divisionType: Scalars['String'];
  slug: Scalars['String'];
};

export type ActionDivisionType = {
  __typename?: 'ActionDivisionType';
  address?: Maybe<AddressType>;
  /** Согласие */
  agreement?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  confirmation?: Maybe<Scalars['Boolean']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Создавший площадку пользователь */
  createdBy?: Maybe<UserType>;
  /** Приказ */
  decree?: Maybe<Scalars['String']>;
  /** Региональное представительство */
  department?: Maybe<DepartmentType>;
  divisionType?: Maybe<Scalars['String']>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  member?: Maybe<Array<MemberType>>;
  /** Министерство */
  ministry?: Maybe<MinistryType>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Муниципалитет */
  municipality?: Maybe<MunicipalityType>;
  /** Персональный email учреждения */
  personalEmail?: Maybe<Scalars['String']>;
  /** Персональный телефон учреждения */
  personalPhone?: Maybe<Scalars['String']>;
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Фио представителя */
  representative?: Maybe<Scalars['String']>;
  speechDetails?: Maybe<Array<Maybe<SpeechDetailsType>>>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** Тип учреждения */
  type?: Maybe<DivisionTypeType>;
  /** Ссылка на сайт */
  url?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
  venueByDivision?: Maybe<VenueType>;
  /** Ссылка на вк */
  vkUrl?: Maybe<Scalars['String']>;
};

export type ActionParticipationInput = {
  actionSource?: InputMaybe<Scalars['String']>;
  actionSourceDescription?: InputMaybe<Scalars['String']>;
  eventGroupSlug: Scalars['String'];
  participationTopic?: InputMaybe<Scalars['String']>;
};

export enum ActionParticipationStatusEnum {
  /** Принята */
  Approved = 'APPROVED',
  /** Отклонена */
  Declined = 'DECLINED',
  /** В процессе */
  InProgress = 'IN_PROGRESS'
}

export type ActionParticipationType = {
  __typename?: 'ActionParticipationType';
  /** Статус заявки на участие */
  status?: Maybe<ActionParticipationStatusEnum>;
  /** Тема */
  topic?: Maybe<Scalars['String']>;
};

export type ActionSourceType = {
  __typename?: 'ActionSourceType';
  /** Название */
  name?: Maybe<Scalars['String']>;
};

export type ActualQuestionType = {
  __typename?: 'ActualQuestionType';
  answer?: Maybe<Array<AnswerType>>;
  answerTexts?: Maybe<Array<Maybe<AnswerTexts>>>;
  /** Цвет hex(#679f58) */
  colorBackgroundImage?: Maybe<Scalars['String']>;
  /** Цвет hex(#43e220) */
  colorBackgroundQuestion?: Maybe<Scalars['String']>;
  /** competition */
  competition?: Maybe<CompetitionType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Дата и время публикации */
  datetimePublication?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Изображение */
  image?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  multiplier?: Maybe<Scalars['Int']>;
  /** Текст вопроса */
  text?: Maybe<Scalars['String']>;
};

export type AddLikeMutation = {
  __typename?: 'AddLikeMutation';
  nominee?: Maybe<NomineeType>;
};

export type AddSpeakerReportToEventItemMutation = {
  __typename?: 'AddSpeakerReportToEventItemMutation';
  result?: Maybe<Scalars['String']>;
  speechList?: Maybe<Array<Maybe<SpeechDetailsType>>>;
};

export type AddressInput = {
  area?: InputMaybe<Scalars['String']>;
  areaFiasId?: InputMaybe<Scalars['String']>;
  areaKladrId?: InputMaybe<Scalars['String']>;
  areaType?: InputMaybe<Scalars['String']>;
  areaTypeFull?: InputMaybe<Scalars['String']>;
  areaWithType?: InputMaybe<Scalars['String']>;
  block?: InputMaybe<Scalars['String']>;
  blockType?: InputMaybe<Scalars['String']>;
  blockTypeFull?: InputMaybe<Scalars['String']>;
  capitalMarker?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityArea?: InputMaybe<Scalars['String']>;
  cityDistrict?: InputMaybe<Scalars['String']>;
  cityDistrictFiasId?: InputMaybe<Scalars['String']>;
  cityDistrictKladrId?: InputMaybe<Scalars['String']>;
  cityDistrictType?: InputMaybe<Scalars['String']>;
  cityDistrictTypeFull?: InputMaybe<Scalars['String']>;
  cityDistrictWithType?: InputMaybe<Scalars['String']>;
  cityFiasId?: InputMaybe<Scalars['String']>;
  cityKladrId?: InputMaybe<Scalars['String']>;
  cityType?: InputMaybe<Scalars['String']>;
  cityTypeFull?: InputMaybe<Scalars['String']>;
  cityWithType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryIsoCode?: InputMaybe<Scalars['String']>;
  entrance?: InputMaybe<Scalars['String']>;
  federalDistrict?: InputMaybe<Scalars['String']>;
  fiasCode?: InputMaybe<Scalars['String']>;
  fiasId?: InputMaybe<Scalars['String']>;
  fiasLevel?: InputMaybe<Scalars['String']>;
  flat?: InputMaybe<Scalars['String']>;
  flatArea?: InputMaybe<Scalars['String']>;
  flatCadnum?: InputMaybe<Scalars['String']>;
  flatFiasId?: InputMaybe<Scalars['String']>;
  flatType?: InputMaybe<Scalars['String']>;
  flatTypeFull?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  geoLat?: InputMaybe<Scalars['String']>;
  geoLon?: InputMaybe<Scalars['String']>;
  geonameId?: InputMaybe<Scalars['String']>;
  historyValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  house?: InputMaybe<Scalars['String']>;
  houseCadnum?: InputMaybe<Scalars['String']>;
  houseFiasId?: InputMaybe<Scalars['String']>;
  houseKladrId?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<Scalars['String']>;
  houseTypeFull?: InputMaybe<Scalars['String']>;
  kladrId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalBox?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  regionFiasId?: InputMaybe<Scalars['String']>;
  regionIsoCode?: InputMaybe<Scalars['String']>;
  regionKladrId?: InputMaybe<Scalars['String']>;
  regionType?: InputMaybe<Scalars['String']>;
  regionTypeFull?: InputMaybe<Scalars['String']>;
  regionWithType?: InputMaybe<Scalars['String']>;
  settlement?: InputMaybe<Scalars['String']>;
  settlementFiasId?: InputMaybe<Scalars['String']>;
  settlementKladrId?: InputMaybe<Scalars['String']>;
  settlementType?: InputMaybe<Scalars['String']>;
  settlementTypeFull?: InputMaybe<Scalars['String']>;
  settlementWithType?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  streetFiasId?: InputMaybe<Scalars['String']>;
  streetKladrId?: InputMaybe<Scalars['String']>;
  streetType?: InputMaybe<Scalars['String']>;
  streetTypeFull?: InputMaybe<Scalars['String']>;
  streetWithType?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  unparsedParts?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  area?: Maybe<Scalars['String']>;
  areaFiasId?: Maybe<Scalars['String']>;
  areaKladrId?: Maybe<Scalars['String']>;
  areaType?: Maybe<Scalars['String']>;
  areaTypeFull?: Maybe<Scalars['String']>;
  areaWithType?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  blockTypeFull?: Maybe<Scalars['String']>;
  capitalMarker?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityArea?: Maybe<Scalars['String']>;
  cityDistrict?: Maybe<Scalars['String']>;
  cityDistrictFiasId?: Maybe<Scalars['String']>;
  cityDistrictKladrId?: Maybe<Scalars['String']>;
  cityDistrictType?: Maybe<Scalars['String']>;
  cityDistrictTypeFull?: Maybe<Scalars['String']>;
  cityDistrictWithType?: Maybe<Scalars['String']>;
  cityFiasId?: Maybe<Scalars['String']>;
  cityKladrId?: Maybe<Scalars['String']>;
  cityType?: Maybe<Scalars['String']>;
  cityTypeFull?: Maybe<Scalars['String']>;
  cityWithType?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Scalars['String']>;
  entrance?: Maybe<Scalars['String']>;
  federalDistrict?: Maybe<Scalars['String']>;
  fiasCode?: Maybe<Scalars['String']>;
  fiasId?: Maybe<Scalars['String']>;
  fiasLevel?: Maybe<Scalars['String']>;
  flat?: Maybe<Scalars['String']>;
  flatArea?: Maybe<Scalars['String']>;
  flatCadnum?: Maybe<Scalars['String']>;
  flatFiasId?: Maybe<Scalars['String']>;
  flatType?: Maybe<Scalars['String']>;
  flatTypeFull?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  geoLat?: Maybe<Scalars['String']>;
  geoLon?: Maybe<Scalars['String']>;
  geonameId?: Maybe<Scalars['String']>;
  historyValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  house?: Maybe<Scalars['String']>;
  houseCadnum?: Maybe<Scalars['String']>;
  houseFiasId?: Maybe<Scalars['String']>;
  houseKladrId?: Maybe<Scalars['String']>;
  houseType?: Maybe<Scalars['String']>;
  houseTypeFull?: Maybe<Scalars['String']>;
  kladrId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalBox?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  regionFiasId?: Maybe<Scalars['String']>;
  regionIsoCode?: Maybe<Scalars['String']>;
  regionKladrId?: Maybe<Scalars['String']>;
  regionType?: Maybe<Scalars['String']>;
  regionTypeFull?: Maybe<Scalars['String']>;
  regionWithType?: Maybe<Scalars['String']>;
  settlement?: Maybe<Scalars['String']>;
  settlementFiasId?: Maybe<Scalars['String']>;
  settlementKladrId?: Maybe<Scalars['String']>;
  settlementType?: Maybe<Scalars['String']>;
  settlementTypeFull?: Maybe<Scalars['String']>;
  settlementWithType?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetFiasId?: Maybe<Scalars['String']>;
  streetKladrId?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  streetTypeFull?: Maybe<Scalars['String']>;
  streetWithType?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  unparsedParts?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AnswerAccountType = {
  __typename?: 'AnswerAccountType';
  /** account */
  account?: Maybe<AccountType>;
  answer?: Maybe<AnswerType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
};

export type AnswerInput = {
  answer: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  enrollmentId?: InputMaybe<Scalars['ID']>;
  pollSlug: Scalars['String'];
  questionId: Scalars['ID'];
  questionType: Scalars['String'];
};

export type AnswerTexts = {
  __typename?: 'AnswerTexts';
  /** Ответы участников */
  accounts?: Maybe<Array<AccountType>>;
  answeraccount?: Maybe<Array<AnswerAccountType>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isRight?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** question */
  question?: Maybe<ActualQuestionType>;
  /** Текст ответа */
  text?: Maybe<Scalars['String']>;
  /** Текст вывода после ответа */
  textProof?: Maybe<Scalars['String']>;
};

export type AnswerType = {
  __typename?: 'AnswerType';
  /** Ответы участников */
  accounts?: Maybe<Array<AccountType>>;
  answeraccount?: Maybe<Array<AnswerAccountType>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isRight?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** question */
  question?: Maybe<ActualQuestionType>;
  rightAnswer?: Maybe<AnswerType>;
  /** Текст ответа */
  text?: Maybe<Scalars['String']>;
  /** Текст вывода после ответа */
  textProof?: Maybe<Scalars['String']>;
};

export type AnswersToQuestionsByAccountType = {
  __typename?: 'AnswersToQuestionsByAccountType';
  answerAccount?: Maybe<Array<Maybe<AnswerAccountType>>>;
  countAll?: Maybe<Scalars['Int']>;
  countRight?: Maybe<Scalars['Int']>;
  countWrong?: Maybe<Scalars['Int']>;
};

export type ApplyForMemberTicketMutation = {
  __typename?: 'ApplyForMemberTicketMutation';
  memberTicket?: Maybe<MemberTicketType>;
};

export type AwardType = {
  __typename?: 'AwardType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** name */
  name?: Maybe<Scalars['String']>;
  /** nominee */
  nominee?: Maybe<NomineeType>;
};

export type BecomeDivisionCoordinatorInput = {
  division: Scalars['Int'];
  projectSlug: Scalars['String'];
};

export type BecomeDivisionCoordinatorMutation = {
  __typename?: 'BecomeDivisionCoordinatorMutation';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type BroadcastType = {
  __typename?: 'BroadcastType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Встраиваемый код */
  embeddedCode?: Maybe<Scalars['String']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
  eventitem?: Maybe<Array<EventItemType>>;
  /** Время окончания */
  finishTime?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Изображение */
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  /** Время начала */
  startTime?: Maybe<Scalars['CustomDateTime']>;
  /** Название трансляции */
  title?: Maybe<Scalars['String']>;
  /** url */
  url?: Maybe<Scalars['String']>;
  /** Ссылка из Викторинуса */
  victorinusUrl?: Maybe<Scalars['String']>;
};

export enum CategoryTagCategoryTypeChoices {
  /** формат */
  Describe = 'DESCRIBE',
  /** тема */
  Theme = 'THEME'
}

export type CategoryType = {
  __typename?: 'CategoryType';
  contentByCategory?: Maybe<Array<ContentFilterType>>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  enrollmentsByCategory?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  eventGroupsByCategory?: Maybe<Array<EventGroupType>>;
  eventItemsByTrack?: Maybe<Array<EventItemType>>;
  eventsByCategory?: Maybe<Array<EventType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isMainForSpeaker?: Maybe<Scalars['Boolean']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  sliderByCategory?: Maybe<Array<MainSliderType>>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  speakerByCategory?: Maybe<Array<SpeakerType>>;
  speakerRequestsByCategory?: Maybe<Array<SpeakerRequestType>>;
  speakersByCategory?: Maybe<Array<SpeakerType>>;
  track?: Maybe<Scalars['Boolean']>;
  usersByCategory?: Maybe<Array<UserType>>;
};

export type ChatBotCheckType = {
  __typename?: 'ChatBotCheckType';
  chatBot?: Maybe<Scalars['Boolean']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
};

export type CheckAnswerInput = {
  answerId?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
};

/** Проверка ответа */
export type CheckAnswerMutations = {
  __typename?: 'CheckAnswerMutations';
  checkAnswer?: Maybe<CheckAnswerType>;
};

export type CheckAnswerType = {
  __typename?: 'CheckAnswerType';
  /** Ответы участников */
  accounts?: Maybe<Array<AccountType>>;
  answeraccount?: Maybe<Array<AnswerAccountType>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isRight?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  multiplier?: Maybe<Scalars['Int']>;
  /** question */
  question?: Maybe<ActualQuestionType>;
  /** Текст ответа */
  text?: Maybe<Scalars['String']>;
  /** Текст вывода после ответа */
  textProof?: Maybe<Scalars['String']>;
};

export type CheckEmailVerificationMutation = {
  __typename?: 'CheckEmailVerificationMutation';
  user?: Maybe<UserType>;
};

export type CinemaRegisterMutation = {
  __typename?: 'CinemaRegisterMutation';
  result?: Maybe<Scalars['String']>;
};

export type CinemaType = {
  __typename?: 'CinemaType';
  /** Вместимость площадки */
  capacity?: Maybe<Scalars['Int']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  placesLeft?: Maybe<Scalars['Int']>;
  /** Идентификатор события */
  slug?: Maybe<Scalars['String']>;
};

export type CompetitionType = {
  __typename?: 'CompetitionType';
  account?: Maybe<Array<AccountType>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  participant?: Maybe<Array<ParticipantType>>;
  promocode?: Maybe<Array<PromoCodeType>>;
  published?: Maybe<Scalars['Boolean']>;
  question?: Maybe<Array<ActualQuestionType>>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type CompilationType = {
  __typename?: 'CompilationType';
  active?: Maybe<Scalars['Boolean']>;
  automatic?: Maybe<Scalars['Boolean']>;
  /** contents */
  contents?: Maybe<Array<ContentFilterType>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок H1 */
  h1?: Maybe<Scalars['String']>;
  /** Иконка */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isClosedByRegistration?: Maybe<Scalars['Boolean']>;
  likesSort?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название подборки */
  name?: Maybe<Scalars['String']>;
  newSort?: Maybe<Scalars['Boolean']>;
  searchScore?: Maybe<Scalars['Float']>;
  /** SEO описание */
  seoDescription?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  /** Дочерняя коллекция */
  subsidiary?: Maybe<CompilationType>;
  subsidiaryCollections?: Maybe<Array<CompilationType>>;
  /** tags */
  tags?: Maybe<Array<TagType>>;
  viewsSort?: Maybe<Scalars['Boolean']>;
};

export type ContenWithtRelayNode = Node & {
  __typename?: 'ContenWithtRelayNode';
  body: Scalars['String'];
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  contentFavoriteByUsername?: Maybe<Scalars['Boolean']>;
  contentLikeByUsername?: Maybe<Scalars['Boolean']>;
  countFavorites?: Maybe<Scalars['Int']>;
  countLikes?: Maybe<Scalars['Int']>;
  countView?: Maybe<Scalars['Int']>;
  cover?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  describeTags?: Maybe<Array<Maybe<TagType>>>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  event?: Maybe<EventTypeNoChd>;
  /** The ID of the object */
  id: Scalars['ID'];
  isClosedByRegistration?: Maybe<Scalars['Boolean']>;
  isRecommendedByUs?: Maybe<Scalars['Boolean']>;
  mainPage?: Maybe<Scalars['Boolean']>;
  manualScore: Scalars['Int'];
  modified: Scalars['DateTime'];
  podcast?: Maybe<Scalars['String']>;
  podcastLength: Scalars['String'];
  promoted: Scalars['Boolean'];
  searchScore?: Maybe<Scalars['Float']>;
  similarContentByAuthor?: Maybe<Array<Maybe<SimilarContentType>>>;
  similarContentByTags?: Maybe<Array<Maybe<SimilarContentType>>>;
  slug: Scalars['String'];
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  tagscompilation?: Maybe<Array<Maybe<TagsCompilationType>>>;
  tagscompilations: TagCompilationsWithRelayNodeConnection;
  themeTags?: Maybe<Array<Maybe<TagType>>>;
  title: Scalars['String'];
  totalCount?: Maybe<Scalars['Int']>;
  type: ContentContentTypeChoices;
  videoLength: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};


export type ContenWithtRelayNodeSimilarContentByAuthorArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ContenWithtRelayNodeSimilarContentByTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ContenWithtRelayNodeTagscompilationsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  automatic?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags_Slug?: InputMaybe<Scalars['String']>;
  tags_Slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContenWithtRelayNodeConnection = {
  __typename?: 'ContenWithtRelayNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContenWithtRelayNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ContenWithtRelayNode` and its cursor. */
export type ContenWithtRelayNodeEdge = {
  __typename?: 'ContenWithtRelayNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContenWithtRelayNode>;
};

export enum ContentContentTypeChoices {
  /** Статья */
  Article = 'ARTICLE',
  /** Матерьял */
  Material = 'MATERIAL',
  /** Подкаст */
  Podcast = 'PODCAST',
  /** Видео */
  Video = 'VIDEO'
}

export type ContentFilterType = {
  __typename?: 'ContentFilterType';
  /** type */
  type?: Maybe<ContentTypeEnum>;
};

export type ContentNpsMutation = {
  __typename?: 'ContentNpsMutation';
  nps?: Maybe<NpsType>;
};

export type ContentNpsWithoutUserMutation = {
  __typename?: 'ContentNpsWithoutUserMutation';
  nps?: Maybe<NpsType>;
};

export type ContentType = {
  __typename?: 'ContentType';
  /** Тело статьи */
  body?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  contentFavoriteByUsername?: Maybe<Scalars['Boolean']>;
  contentFavorites?: Maybe<Array<FavoritesType>>;
  contentLikeByUsername?: Maybe<Scalars['Boolean']>;
  contentLikes?: Maybe<Array<LikesType>>;
  countFavorites?: Maybe<Scalars['Int']>;
  countLikes?: Maybe<Scalars['Int']>;
  countView?: Maybe<Scalars['Int']>;
  /** Обложка */
  cover?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  describeTags?: Maybe<Array<Maybe<TagType>>>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** PDF/Презентация/Документ */
  document?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  /** Длительность в минутах */
  duration?: Maybe<Scalars['Int']>;
  /** event */
  event?: Maybe<EventType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isClosedByRegistration?: Maybe<Scalars['Boolean']>;
  isRecommendedByUs?: Maybe<Scalars['Boolean']>;
  mainPage?: Maybe<Scalars['Boolean']>;
  /** Ручной скоринг */
  manualScore?: Maybe<Scalars['Int']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  podcast?: Maybe<Scalars['String']>;
  /** Длина подкаста */
  podcastLength?: Maybe<Scalars['String']>;
  promoted?: Maybe<Scalars['Boolean']>;
  ratingByContent?: Maybe<Array<NpsType>>;
  searchScore?: Maybe<Scalars['Float']>;
  similarContentByAuthor?: Maybe<Array<Maybe<SimilarContentType>>>;
  similarContentByTags?: Maybe<Array<Maybe<SimilarContentType>>>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Спец проекты */
  specialProject?: Maybe<Array<SpecialProjectType>>;
  tagscompilation?: Maybe<Array<Maybe<TagsCompilationType>>>;
  tagscompilations?: Maybe<Array<CompilationType>>;
  themeTags?: Maybe<Array<Maybe<TagType>>>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<ContentTypeEnum>;
  /** Длина видео */
  videoLength?: Maybe<Scalars['String']>;
  /** Ссылка на видео */
  videoUrl?: Maybe<Scalars['String']>;
};


export type ContentTypeSimilarContentByAuthorArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeSimilarContentByTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum ContentTypeEnum {
  /** Статья */
  Article = 'ARTICLE',
  /** Матерьял */
  Material = 'MATERIAL',
  /** Подкаст */
  Podcast = 'PODCAST',
  /** Видео */
  Video = 'VIDEO'
}

export type ContentTypeWithMeta = {
  __typename?: 'ContentTypeWithMeta';
  /** Content list, paginated by LimitOffsetPaginator */
  contents?: Maybe<Array<Maybe<ContentType>>>;
  /** Total count of matches elements */
  totalCount?: Maybe<Scalars['Int']>;
};


export type ContentTypeWithMetaContentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
};

export type ContentViewMutation = {
  __typename?: 'ContentViewMutation';
  view?: Maybe<Scalars['String']>;
};

export type ContentWithMetaListType = {
  __typename?: 'ContentWithMetaListType';
  /** Content list, paginated by LimitOffsetPaginator */
  contents?: Maybe<Array<Maybe<ContentType>>>;
  /** Total count of matches elements */
  countContents?: Maybe<Scalars['Int']>;
  coverUrl?: Maybe<Scalars['String']>;
};


export type ContentWithMetaListTypeContentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
};

export type ContentWithMetaType = {
  __typename?: 'ContentWithMetaType';
  contents?: Maybe<Array<Maybe<ContentType>>>;
  countContents?: Maybe<Scalars['Int']>;
};


export type ContentWithMetaTypeContentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CourseNode = Node & {
  __typename?: 'CourseNode';
  coursesectionSet: CourseSectionNodeConnection;
  cover?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  sectionsDescription?: Maybe<Scalars['String']>;
  sectionsQty: Scalars['Int'];
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  teachbaseUrl?: Maybe<Scalars['String']>;
};


export type CourseNodeCoursesectionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CourseNodeConnection = {
  __typename?: 'CourseNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CourseNode` and its cursor. */
export type CourseNodeEdge = {
  __typename?: 'CourseNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CourseNode>;
};

export type CourseSectionNode = Node & {
  __typename?: 'CourseSectionNode';
  course: CourseNode;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  pk?: Maybe<Scalars['Int']>;
};

export type CourseSectionNodeConnection = {
  __typename?: 'CourseSectionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseSectionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CourseSectionNode` and its cursor. */
export type CourseSectionNodeEdge = {
  __typename?: 'CourseSectionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CourseSectionNode>;
};

export type CreateActionParticipationMutation = {
  __typename?: 'CreateActionParticipationMutation';
  result?: Maybe<Scalars['String']>;
};

export type CreateAddressMutation = {
  __typename?: 'CreateAddressMutation';
  address?: Maybe<AddressType>;
};

export type CreateAnswerMutation = {
  __typename?: 'CreateAnswerMutation';
  poll?: Maybe<PollType>;
};

export type CreateAuthorizeMutation = {
  __typename?: 'CreateAuthorizeMutation';
  userExists?: Maybe<Scalars['Boolean']>;
};

export type CreateCapitanInput = {
  capitanId: Scalars['ID'];
};

export type CreateCapitanMutation = {
  __typename?: 'CreateCapitanMutation';
  team?: Maybe<TeamType>;
};

export type CreateIndividualStageMutation = {
  __typename?: 'CreateIndividualStageMutation';
  enrollment?: Maybe<EnrollmentType>;
};

export type CreateLeagueInput = {
  category: Scalars['ID'];
};

export type CreateLeagueMutation = {
  __typename?: 'CreateLeagueMutation';
  user?: Maybe<UserType>;
};

export type CreateMemberTicketInput = {
  additionalInformation?: InputMaybe<Scalars['String']>;
};

export type CreateQuizRegistrationMutation = {
  __typename?: 'CreateQuizRegistrationMutation';
  user?: Maybe<UserType>;
};

export type CreateSpeakerRegistrationToDivisionMutation = {
  __typename?: 'CreateSpeakerRegistrationToDivisionMutation';
  result?: Maybe<Scalars['String']>;
  speechList?: Maybe<Array<Maybe<SpeechDetailsType>>>;
};

export type CreateTelegramUserMutation = {
  __typename?: 'CreateTelegramUserMutation';
  user?: Maybe<UserType>;
};

export type CreateUserQuestion = {
  __typename?: 'CreateUserQuestion';
  userQuestion?: Maybe<UserQuestionType>;
};

export type DailyQuestionUserScoreType = {
  __typename?: 'DailyQuestionUserScoreType';
  amount?: Maybe<Scalars['Int']>;
  countOperations?: Maybe<Scalars['Int']>;
  multiplier?: Maybe<Scalars['Int']>;
};

export type DateListType = {
  __typename?: 'DateListType';
  startTime?: Maybe<Scalars['DateTime']>;
};

export type DeleteJsonWebTokenCookie = {
  __typename?: 'DeleteJSONWebTokenCookie';
  deleted: Scalars['Boolean'];
};

export type DeleteQuizRegistrationMutation = {
  __typename?: 'DeleteQuizRegistrationMutation';
  user?: Maybe<UserType>;
};

export type DeleteRefreshTokenCookie = {
  __typename?: 'DeleteRefreshTokenCookie';
  deleted: Scalars['Boolean'];
};

export type DeleteSpeakerRegistrationToDivisionMutation = {
  __typename?: 'DeleteSpeakerRegistrationToDivisionMutation';
  result?: Maybe<Scalars['String']>;
  speechList?: Maybe<Array<Maybe<SpeechDetailsType>>>;
};

export type DepartmentAccountType = {
  __typename?: 'DepartmentAccountType';
  confirmation?: Maybe<Scalars['Boolean']>;
  divisionCount?: Maybe<Scalars['Int']>;
  divisions?: Maybe<Array<Maybe<DivisionType>>>;
  divisionsByRegion?: Maybe<Array<Maybe<DivisionType>>>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  membersCount?: Maybe<Scalars['Int']>;
  /** Министерство */
  ministry?: Maybe<MinistryType>;
  municipalityByDepartment?: Maybe<Array<MunicipalityType>>;
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Фио представителя */
  representative?: Maybe<Scalars['String']>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
};


export type DepartmentAccountTypeDivisionsByRegionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DepartmentContactsType = {
  __typename?: 'DepartmentContactsType';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type DepartmentDetailsType = {
  __typename?: 'DepartmentDetailsType';
  confirmation?: Maybe<Scalars['Boolean']>;
  contacts?: Maybe<Array<Maybe<DepartmentContactsType>>>;
  division?: Maybe<Array<DivisionSuggestedType>>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** Министерство */
  ministry?: Maybe<MinistryType>;
  municipalityByDepartment?: Maybe<Array<MunicipalityType>>;
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Фио представителя */
  representative?: Maybe<Scalars['String']>;
  statistics?: Maybe<StatisticType>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
};

export type DepartmentType = {
  __typename?: 'DepartmentType';
  childDepartment?: Maybe<Array<Maybe<DepartmentType>>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** номер отображения */
  number?: Maybe<Scalars['Int']>;
  /** родительская группа */
  parentDepartment?: Maybe<DepartmentType>;
  people?: Maybe<Array<PersonType>>;
  persons?: Maybe<Array<Maybe<PersonType>>>;
  published?: Maybe<Scalars['Boolean']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type DivisionSuggestedType = {
  __typename?: 'DivisionSuggestedType';
  address?: Maybe<Scalars['String']>;
  /** Создавший площадку пользователь */
  createdBy?: Maybe<UserType>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Фио представителя */
  representative?: Maybe<Scalars['String']>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** Тип учреждения */
  type?: Maybe<DivisionTypeType>;
  /** Ссылка на сайт */
  url?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
  venueByDivision?: Maybe<VenueType>;
  /** Ссылка на вк */
  vkUrl?: Maybe<Scalars['String']>;
};

export type DivisionType = {
  __typename?: 'DivisionType';
  address?: Maybe<AddressType>;
  /** Согласие */
  agreement?: Maybe<Scalars['String']>;
  confirmation?: Maybe<Scalars['Boolean']>;
  /** Создавший площадку пользователь */
  createdBy?: Maybe<UserType>;
  /** Приказ */
  decree?: Maybe<Scalars['String']>;
  /** Региональное представительство */
  department?: Maybe<DepartmentType>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  members?: Maybe<Array<Maybe<MemberType>>>;
  membersByRegion?: Maybe<Array<Maybe<MemberType>>>;
  /** Министерство */
  ministry?: Maybe<MinistryType>;
  /** Муниципалитет */
  municipality?: Maybe<MunicipalityType>;
  /** Персональный email учреждения */
  personalEmail?: Maybe<Scalars['String']>;
  /** Персональный телефон учреждения */
  personalPhone?: Maybe<Scalars['String']>;
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Фио представителя */
  representative?: Maybe<Scalars['String']>;
  teams?: Maybe<Array<Maybe<TeamType>>>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** Тип учреждения */
  type?: Maybe<DivisionTypeType>;
  /** Ссылка на сайт */
  url?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
  venueByDivision?: Maybe<VenueType>;
  /** Ссылка на вк */
  vkUrl?: Maybe<Scalars['String']>;
};


export type DivisionTypeMembersByRegionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DivisionTypeType = {
  __typename?: 'DivisionTypeType';
  division?: Maybe<Array<DivisionSuggestedType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Название */
  name?: Maybe<Scalars['String']>;
};

export type DivisionsToDepartmentInput = {
  department?: InputMaybe<Scalars['Int']>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type DivisionsToDepartmentMutation = {
  __typename?: 'DivisionsToDepartmentMutation';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type DivisionsToMunicipalityInput = {
  divisions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  municipality?: InputMaybe<Scalars['Int']>;
};

export type DivisionsToMunicipalityMutation = {
  __typename?: 'DivisionsToMunicipalityMutation';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type DocumentGroupType = {
  __typename?: 'DocumentGroupType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** page */
  page?: Maybe<PageType>;
  published?: Maybe<Scalars['Boolean']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Файл */
  file?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  /** group */
  group?: Maybe<DocumentGroupType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Ссылка */
  url?: Maybe<Scalars['String']>;
};

export type EmailInput = {
  email: Scalars['String'];
};

/** Mutation is used for create Enrollment to Event from Event page on site. */
export type EnrollToEventMutation = {
  __typename?: 'EnrollToEventMutation';
  event?: Maybe<EventType>;
  result?: Maybe<Scalars['String']>;
};

export type EnrollmentCheckinMInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Mutation is used for make Enrollment attended (or create and make attended) using qr-code of Enrollment. */
export type EnrollmentCheckinMutation = {
  __typename?: 'EnrollmentCheckinMutation';
  result?: Maybe<Scalars['String']>;
};

/**
 * Mutation is used for make Enrollment attended (or create and make attended) using qr-code of Event.
 * User scans qr-code, authorized on site and mutation is applied.
 */
export type EnrollmentCheckinNoAdminMutation = {
  __typename?: 'EnrollmentCheckinNoAdminMutation';
  result?: Maybe<Scalars['String']>;
};

export enum EnrollmentEnrollmentTypeEnum {
  /** Оффлайн */
  Offline = 'OFFLINE',
  /** Онлайн */
  Online = 'ONLINE'
}

export enum EnrollmentStatusEnum {
  /** отклонен */
  Declined = 'DECLINED',
  /** проверка почты */
  EmailVerification = 'EMAIL_VERIFICATION',
  /** в обработке */
  Inprogress = 'INPROGRESS',
  /** новый */
  New = 'NEW'
}

export enum EnrollmentStatusStageEnum {
  /** Не оценён */
  NotRated = 'NOT_RATED',
  /** Этап НЕ пройден */
  NoPassed = 'NO_PASSED',
  /** Этап пройден */
  Passed = 'PASSED'
}

export type EnrollmentType = {
  __typename?: 'EnrollmentType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** game */
  game?: Maybe<GameType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** quiz id */
  quizId?: Maybe<Scalars['String']>;
  semifinalist?: Maybe<Scalars['Boolean']>;
  /** team */
  team?: Maybe<TeamType>;
  url?: Maybe<Scalars['String']>;
  /** user */
  user?: Maybe<UserType>;
};

export type EventDayType = {
  __typename?: 'EventDayType';
  date?: Maybe<Scalars['Date']>;
  eventItems?: Maybe<Array<Maybe<EventItemType>>>;
};

export type EventEnrollmentType = {
  __typename?: 'EventEnrollmentType';
  attended?: Maybe<Scalars['Boolean']>;
  /** время прохода */
  checkinTime?: Maybe<Scalars['CustomDateTime']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** День записи */
  enrollmentDay?: Maybe<Scalars['CustomDate']>;
  /** Тип посещения */
  enrollmentType?: Maybe<EnrollmentEnrollmentTypeEnum>;
  event?: Maybe<EventType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** qr code */
  qrCode?: Maybe<Scalars['String']>;
  smsIsSending?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserType>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
};

export enum EventFederalDistrictEnum {
  /** Дальневосточный */
  DalNevostochnyi = 'DAL_NEVOSTOCHNYI',
  /** Южный */
  Iuzhnyi = 'IUZHNYI',
  None = 'NONE',
  /** Приволжский */
  Privolzhskii = 'PRIVOLZHSKII',
  /** Северо-Кавказский */
  SeveroKavkazskii = 'SEVERO_KAVKAZSKII',
  /** Северо-Западный */
  SeveroZapadnyi = 'SEVERO_ZAPADNYI',
  /** Сибирский */
  Sibirskii = 'SIBIRSKII',
  /** Центральный */
  TsentralNyi = 'TSENTRAL_NYI',
  /** Уральский */
  UralSkii = 'URAL_SKII'
}

export type EventGroupActionType = {
  __typename?: 'EventGroupActionType';
  /** Согласие */
  agreement?: Maybe<Scalars['String']>;
  agreementUrl?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Дизайнерские заставки (ссылка на диск) */
  designUrl?: Maybe<Scalars['String']>;
  divisions?: Maybe<Array<Maybe<DivisionType>>>;
  enrollFinishDate?: Maybe<Scalars['DateTime']>;
  enrollStartDate?: Maybe<Scalars['DateTime']>;
  eventGroupByAction?: Maybe<EventGroupType>;
  finishDate?: Maybe<Scalars['DateTime']>;
  /** Гайд */
  guide?: Maybe<Scalars['String']>;
  guideUrl?: Maybe<Scalars['String']>;
  /** Телефон горячей линии */
  hotlinePhone?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Пример презентации */
  presentationExample?: Maybe<Scalars['String']>;
  presentationExampleUrl?: Maybe<Scalars['String']>;
  /** Памятка по выступлению */
  speechMemoUrl?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  /** email поддержки */
  supportEmail?: Maybe<Scalars['String']>;
  /** ТГ акции */
  telegramUrl?: Maybe<Scalars['String']>;
  /** Название акции */
  title?: Maybe<Scalars['String']>;
};

export type EventGroupLinkType = {
  __typename?: 'EventGroupLinkType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** группа мероприятий */
  eventGroup?: Maybe<EventGroupType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  name?: Maybe<Scalars['String']>;
  /** order */
  order?: Maybe<Scalars['Int']>;
  /** ссылка */
  url?: Maybe<Scalars['String']>;
};

export type EventGroupType = {
  __typename?: 'EventGroupType';
  /** Акция */
  action?: Maybe<EventGroupActionType>;
  active?: Maybe<Scalars['Boolean']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  /** Изображение */
  cover?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  dateList?: Maybe<Array<Maybe<DateListType>>>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Дата окончания регистрации */
  enrollFinishDate?: Maybe<Scalars['CustomDateTime']>;
  /** Дата начала регистрации */
  enrollStartDate?: Maybe<Scalars['CustomDateTime']>;
  eventGroupLinks?: Maybe<Array<Maybe<EventGroupLinkType>>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  eventsByGroupEvent?: Maybe<Array<EventType>>;
  faqs?: Maybe<Array<Maybe<FaqType>>>;
  /** Дата окончания */
  finishDate?: Maybe<Scalars['CustomDateTime']>;
  headliners?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  infoPartners?: Maybe<Array<Maybe<PartnerType>>>;
  /** Вводный текст */
  intro?: Maybe<Scalars['String']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  learnsByEventGroup?: Maybe<Array<LearnType>>;
  links?: Maybe<Array<EventGroupLinkType>>;
  /** Картинка для мобильной версии */
  mobileImage?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Название (Eng) */
  nameEn?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<OfferType>>>;
  participationGeneric?: Maybe<Array<ActionParticipationType>>;
  partners?: Maybe<Array<Maybe<PartnerType>>>;
  promoted?: Maybe<Scalars['Boolean']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  speakerRequestsByGroupEvent?: Maybe<Array<SpeakerRequestType>>;
  /** Дата старта */
  startDate?: Maybe<Scalars['CustomDateTime']>;
  /** Коррекция часового пояса */
  timezoneCorrection?: Maybe<Scalars['Int']>;
  venue?: Maybe<VenueType>;
};

export enum EventIsBeingHeldByEnum {
  /** Головной офис */
  HeadOffice = 'HEAD_OFFICE',
  /** Региональное */
  Regional = 'REGIONAL'
}

export type EventItemType = {
  __typename?: 'EventItemType';
  active?: Maybe<Scalars['Boolean']>;
  albumCover?: Maybe<EventPhotoType>;
  /** broadcast */
  broadcast?: Maybe<BroadcastType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Краткое описание */
  description?: Maybe<Scalars['String']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
  /** Время окончания */
  finishTime?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** EventPhoto list */
  photos?: Maybe<Array<EventPhotoType>>;
  /** опрос */
  poll?: Maybe<PollType>;
  pollGeneric?: Maybe<Array<PollType>>;
  /** Ссылка на презентацию */
  presentationUrl?: Maybe<Scalars['String']>;
  /** EventPhoto list */
  programPhotos?: Maybe<Array<Maybe<EventPhotoType>>>;
  /** Дата/Время последнего прикрепления отчета */
  reportAttachDate?: Maybe<Scalars['CustomDateTime']>;
  /** Ссылка на отчет */
  reportLinkUrl?: Maybe<Scalars['String']>;
  /** Slug ивента */
  slug?: Maybe<Scalars['String']>;
  speakerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Время начала */
  startTime?: Maybe<Scalars['CustomDateTime']>;
  /** Макротеги типа 'тема' */
  themeTagCategories?: Maybe<Array<TagCategoryType>>;
  /** Заголовок лекции/события */
  title?: Maybe<Scalars['String']>;
  /** трек */
  track?: Maybe<Array<CategoryType>>;
};


export type EventItemTypePhotosArgs = {
  created?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
};


export type EventItemTypeProgramPhotosArgs = {
  created?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type EventLinkType = {
  __typename?: 'EventLinkType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** мероприятие */
  event?: Maybe<EventType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  name?: Maybe<Scalars['String']>;
  /** order */
  order?: Maybe<Scalars['Int']>;
  /** ссылка */
  url?: Maybe<Scalars['String']>;
};

export type EventNewType = {
  __typename?: 'EventNewType';
  countEvents?: Maybe<Scalars['Int']>;
  events?: Maybe<Array<Maybe<EventType>>>;
};


export type EventNewTypeEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EventNpsInput = {
  comment?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  uuid: Scalars['UUID'];
};

export type EventNpsMutation = {
  __typename?: 'EventNpsMutation';
  result?: Maybe<Scalars['String']>;
};

export type EventPhotoAlbumType = {
  __typename?: 'EventPhotoAlbumType';
  /** event */
  event?: Maybe<EventType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** name */
  name?: Maybe<Scalars['String']>;
  /** EventPhoto list */
  photos?: Maybe<Array<EventPhotoType>>;
};


export type EventPhotoAlbumTypePhotosArgs = {
  created?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
};

export type EventPhotoType = {
  __typename?: 'EventPhotoType';
  album?: Maybe<EventPhotoAlbumType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** event item */
  eventItem?: Maybe<EventItemType>;
  /** file */
  file?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isCover?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
};

export type EventType = {
  __typename?: 'EventType';
  active?: Maybe<Scalars['Boolean']>;
  /** Информационный текст */
  afterEnrollInfo?: Maybe<Scalars['String']>;
  /** Заголовок Ссылки */
  afterEnrollLinkLabel?: Maybe<Scalars['String']>;
  /** Ссылка */
  afterEnrollLinkUrl?: Maybe<Scalars['String']>;
  album?: Maybe<EventPhotoAlbumType>;
  /** Альтернативный адрес */
  alternativeAddress?: Maybe<Scalars['String']>;
  autoRedirect?: Maybe<Scalars['Boolean']>;
  /** base color */
  baseColor?: Maybe<Scalars['String']>;
  broadcasts?: Maybe<Array<Maybe<BroadcastType>>>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  /** Город проведения */
  city?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Maybe<ContentType>>>;
  /** Изображение */
  cover?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  currentEventItem?: Maybe<EventItemType>;
  /** Департамент */
  department?: Maybe<DepartmentType>;
  /** Теги типа 'формат' */
  describeTags?: Maybe<Array<TagType>>;
  /** Описание ивента */
  description?: Maybe<Scalars['String']>;
  disableNps?: Maybe<Scalars['Boolean']>;
  /** Дата окончания регистрации */
  enrollFinishDate?: Maybe<Scalars['CustomDateTime']>;
  enrollmentQrcode?: Maybe<Scalars['String']>;
  enrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  eventAlbums?: Maybe<EventPhotoAlbumType>;
  eventDays?: Maybe<Array<Maybe<EventDayType>>>;
  eventItems?: Maybe<Array<EventItemType>>;
  eventLinks?: Maybe<Array<Maybe<EventLinkType>>>;
  events?: Maybe<Array<EventType>>;
  eventsBySlider?: Maybe<Array<MainSliderType>>;
  eventsGroupSlug?: Maybe<Scalars['String']>;
  faqs?: Maybe<Array<Maybe<FaqType>>>;
  /** Федеральный округ */
  federalDistrict?: Maybe<EventFederalDistrictEnum>;
  /** Дата окончания */
  finishDate?: Maybe<Scalars['CustomDateTime']>;
  /** Орган власти */
  government?: Maybe<GovernmentType>;
  /** Группа Мероприятий */
  groupEvent?: Maybe<EventGroupType>;
  headliners?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  infoPartners?: Maybe<Array<Maybe<PartnerType>>>;
  /** Вводный текст */
  intro?: Maybe<Scalars['String']>;
  /** Мероприятие проводит */
  isBeingHeldBy?: Maybe<EventIsBeingHeldByEnum>;
  isHideDateTime?: Maybe<Scalars['Boolean']>;
  isHideWeekDays?: Maybe<Scalars['Boolean']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  isPartnerEvent?: Maybe<Scalars['Boolean']>;
  isRepeatedPollAnswersAllowed?: Maybe<Scalars['Boolean']>;
  isUserAttended?: Maybe<Scalars['Boolean']>;
  isUserEnrolled?: Maybe<Scalars['Boolean']>;
  learns?: Maybe<Array<Maybe<LearnType>>>;
  learnsByEvent?: Maybe<Array<LearnType>>;
  links?: Maybe<Array<EventLinkType>>;
  /** Картинка для мобильной версии */
  mobileImage?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название ивента */
  name?: Maybe<Scalars['String']>;
  /** Название ивента (Eng) */
  nameEn?: Maybe<Scalars['String']>;
  offRegistration?: Maybe<Scalars['Boolean']>;
  offers?: Maybe<Array<Maybe<OfferType>>>;
  /** order */
  order?: Maybe<Scalars['Int']>;
  partners?: Maybe<Array<Maybe<PartnerType>>>;
  /** Место проведения */
  place?: Maybe<Scalars['String']>;
  placesLeft?: Maybe<Scalars['Int']>;
  poll?: Maybe<Array<Maybe<PollType>>>;
  pollGeneric?: Maybe<Array<PollType>>;
  promoted?: Maybe<Scalars['Boolean']>;
  /** qr code */
  qrCode?: Maybe<Scalars['String']>;
  /** qr code registration */
  qrCodeRegistration?: Maybe<Scalars['String']>;
  recommendedUserFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Регион */
  region?: Maybe<RegionType>;
  /** Связанное событие */
  relatedEvent?: Maybe<EventType>;
  requiredUserFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Ответственный */
  responsibleUser?: Maybe<UserType>;
  searchScore?: Maybe<Scalars['Float']>;
  showAnyway?: Maybe<Scalars['Boolean']>;
  /** Slug ивента */
  slug?: Maybe<Scalars['String']>;
  smsSendPollOn?: Maybe<Scalars['Boolean']>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Спец проект */
  specialProject?: Maybe<SpecialProjectType>;
  /** Дата старта */
  startDate?: Maybe<Scalars['CustomDateTime']>;
  /** Подзаголовок */
  subtitle?: Maybe<Scalars['String']>;
  /** Теги типа 'тема' */
  themeTags?: Maybe<Array<TagType>>;
  /** Коррекция часового пояса */
  timezoneCorrection?: Maybe<Scalars['Int']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<TranslationItemType>>;
  universities?: Maybe<Array<Maybe<UniversitiesRealType>>>;
  users?: Maybe<Array<UserType>>;
  /** uuid */
  uuid?: Maybe<Scalars['String']>;
  venue?: Maybe<VenueType>;
  /** Видео */
  video?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  /** хук для хакатона */
  webhookUrl?: Maybe<Scalars['String']>;
};


export type EventTypeEventDaysArgs = {
  categoryThemeSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** класс который используется в event_by_slug_no_chd, чтобы не кешировались */
export type EventTypeNoChd = {
  __typename?: 'EventTypeNoChd';
  active: Scalars['Boolean'];
  afterEnrollInfo: Scalars['String'];
  afterEnrollLinkLabel: Scalars['String'];
  afterEnrollLinkUrl: Scalars['String'];
  alternativeAddress?: Maybe<Scalars['String']>;
  autoRedirect: Scalars['Boolean'];
  baseColor?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  content: ContenWithtRelayNodeConnection;
  cover?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  description: Scalars['String'];
  disableNps: Scalars['Boolean'];
  enrollFinishDate?: Maybe<Scalars['DateTime']>;
  enrollmentQrcode?: Maybe<Scalars['String']>;
  events: Array<EventTypeNoChd>;
  federalDistrict?: Maybe<EventsEventFederalDistrictChoices>;
  finishDate: Scalars['DateTime'];
  id: Scalars['ID'];
  intro?: Maybe<Scalars['String']>;
  isBeingHeldBy?: Maybe<EventsEventIsBeingHeldByChoices>;
  isHideDateTime: Scalars['Boolean'];
  isHideWeekDays: Scalars['Boolean'];
  isOffline: Scalars['Boolean'];
  isPartnerEvent?: Maybe<Scalars['Boolean']>;
  isRepeatedPollAnswersAllowed?: Maybe<Scalars['Boolean']>;
  isUserAttended?: Maybe<Scalars['Boolean']>;
  isUserEnrolled?: Maybe<Scalars['Boolean']>;
  mobileImage?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  nameEn?: Maybe<Scalars['String']>;
  offRegistration: Scalars['Boolean'];
  order: Scalars['Int'];
  place: Scalars['String'];
  promoted: Scalars['Boolean'];
  qrCode?: Maybe<Scalars['String']>;
  qrCodeRegistration?: Maybe<Scalars['String']>;
  recommendedUserFields?: Maybe<EventsEventRecommendedUserFieldsChoices>;
  relatedEvent?: Maybe<EventTypeNoChd>;
  requiredUserFields: EventsEventRequiredUserFieldsChoices;
  showAnyway?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  smsSendPollOn: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
  subtitle?: Maybe<Scalars['String']>;
  timezoneCorrection: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  video?: Maybe<Scalars['String']>;
  webhookUrl?: Maybe<Scalars['String']>;
};


/** класс который используется в event_by_slug_no_chd, чтобы не кешировались */
export type EventTypeNoChdContentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  describeTags_Slug?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  event?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Float']>;
  isClosedByRegistration?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  manualScore?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  podcastLength?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  themeTags_Slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  videoLength?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type EventWithMetaType = {
  __typename?: 'EventWithMetaType';
  countEvents?: Maybe<Scalars['Int']>;
  events?: Maybe<Array<Maybe<EventType>>>;
};


export type EventWithMetaTypeEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum EventsEventFederalDistrictChoices {
  /** Дальневосточный */
  DalNevostochnyi = 'DAL_NEVOSTOCHNYI',
  /** Южный */
  Iuzhnyi = 'IUZHNYI',
  None = 'NONE',
  /** Приволжский */
  Privolzhskii = 'PRIVOLZHSKII',
  /** Северо-Кавказский */
  SeveroKavkazskii = 'SEVERO_KAVKAZSKII',
  /** Северо-Западный */
  SeveroZapadnyi = 'SEVERO_ZAPADNYI',
  /** Сибирский */
  Sibirskii = 'SIBIRSKII',
  /** Центральный */
  TsentralNyi = 'TSENTRAL_NYI',
  /** Уральский */
  UralSkii = 'URAL_SKII'
}

export enum EventsEventIsBeingHeldByChoices {
  /** Головной офис */
  HeadOffice = 'HEAD_OFFICE',
  /** Региональное */
  Regional = 'REGIONAL'
}

export enum EventsEventRecommendedUserFieldsChoices {
  /** Орган власти */
  Government = 'GOVERNMENT'
}

export enum EventsEventRequiredUserFieldsChoices {
  /** Учёная степень/звание */
  AcademicDegree = 'ACADEMIC_DEGREE',
  /** address */
  Address = 'ADDRESS',
  /** Адрес проживания */
  AddressDetail = 'ADDRESS_DETAIL',
  /** Дата рождения */
  BirthDate = 'BIRTH_DATE',
  /** Образование */
  Education = 'EDUCATION',
  /** Email */
  Email = 'EMAIL',
  /** facebook account */
  FacebookAccount = 'FACEBOOK_ACCOUNT',
  /** Имя */
  FirstName = 'FIRST_NAME',
  /** Орган власти */
  Government = 'GOVERNMENT',
  /** Год окончания университета */
  GraduationYear = 'GRADUATION_YEAR',
  /** instagram account */
  InstagramAccount = 'INSTAGRAM_ACCOUNT',
  /** Почта проверена ? */
  IsEmailVerificated = 'IS_EMAIL_VERIFICATED',
  /** Фамилия */
  LastName = 'LAST_NAME',
  /** Отчество */
  MiddleName = 'MIDDLE_NAME',
  /** псевдоним */
  Nickname = 'NICKNAME',
  /** ok account */
  OkAccount = 'OK_ACCOUNT',
  /** ограничение по здоровью/инвалидность */
  Ovz = 'OVZ',
  /** Участвовали ли вы в проектах РОЗ? */
  ParticipantRoz = 'PARTICIPANT_ROZ',
  /** Номер паспорта */
  PassportNumber = 'PASSPORT_NUMBER',
  /** Дата выдачи */
  PassportReleaseDate = 'PASSPORT_RELEASE_DATE',
  /** Серия паспорта */
  PassportSeries = 'PASSPORT_SERIES',
  /** Номер телефона */
  Phone = 'PHONE',
  /** Должность */
  Position = 'POSITION',
  /** Регалии */
  Regalia = 'REGALIA',
  /** Место регистрации */
  RegistrationPlace = 'REGISTRATION_PLACE',
  /** Номер подразделения */
  ReleaseDptCode = 'RELEASE_DPT_CODE',
  /** Кем выдан */
  ReleaseDptName = 'RELEASE_DPT_NAME',
  /** Специальность */
  Speciality = 'SPECIALITY',
  /** ID лэйбла в Teachbase */
  TeachbaseLabelIds = 'TEACHBASE_LABEL_IDS',
  /** telegram account */
  TelegramAccount = 'TELEGRAM_ACCOUNT',
  /** uuid */
  Uuid = 'UUID',
  /** vk account */
  VkAccount = 'VK_ACCOUNT',
  /** vk avatar */
  VkAvatar = 'VK_AVATAR',
  /** Откуда прошла регистрация */
  WhereRegistration = 'WHERE_REGISTRATION',
  /** Из какого ВУЗа вы пришли */
  WhichUniversityUserCome = 'WHICH_UNIVERSITY_USER_COME',
  /** Место работы */
  WorkPlace = 'WORK_PLACE',
  /** youtube account */
  YoutubeAccount = 'YOUTUBE_ACCOUNT'
}

export type ExperimentGroupType = {
  __typename?: 'ExperimentGroupType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Эксперимент */
  experiment?: Maybe<ExperimentType>;
  /** Вес группы */
  groupWeight?: Maybe<Scalars['Int']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isWinner?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  /** Название группы */
  title?: Maybe<Scalars['String']>;
};

export enum ExperimentStatusEnum {
  /** активный */
  Active = 'ACTIVE',
  /** отменен */
  Canceled = 'CANCELED',
  /** закончен */
  Finished = 'FINISHED',
  /** в ожидании */
  Pending = 'PENDING'
}

export type ExperimentType = {
  __typename?: 'ExperimentType';
  authorizedOnly?: Maybe<Scalars['Boolean']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** дата окончания */
  finishedAt?: Maybe<Scalars['CustomDateTime']>;
  groups?: Maybe<Array<Maybe<ExperimentGroupType>>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  /** status */
  status?: Maybe<ExperimentStatusEnum>;
  /** Название эксперимента */
  title?: Maybe<Scalars['String']>;
};

/**
 * Delete token by token str
 * expoPushTokenDelete(token: "%(token)s")
 * {
 *     message
 * }
 */
export type ExpoPushTokenDeleteMutation = {
  __typename?: 'ExpoPushTokenDeleteMutation';
  message?: Maybe<Scalars['String']>;
};

/**
 * Save new token
 * expoPushTokenSave(token: "%(token)s", isActive: %(is_active)s)
 * {
 *     expoPushToken {
 *         token
 *         isActive
 *     }
 * }
 */
export type ExpoPushTokenSaveMutation = {
  __typename?: 'ExpoPushTokenSaveMutation';
  expoPushToken?: Maybe<ExpoPushTokenType>;
};

export type ExpoPushTokenType = {
  __typename?: 'ExpoPushTokenType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  expopushtokennotification?: Maybe<Array<ExpoPushTokenTypeNotifiactionType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Expo Push Token */
  token?: Maybe<Scalars['String']>;
  /** Пользователь ROZ */
  user?: Maybe<UserType>;
};

export type ExpoPushTokenTypeNotifiactionType = {
  __typename?: 'ExpoPushTokenTypeNotifiactionType';
  /** Тело уведомления */
  body?: Maybe<Scalars['String']>;
  /** Имя канала Андройд */
  channelId?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** expiration */
  expiration?: Maybe<Scalars['CustomDateTime']>;
  /** Экспо пуш токен */
  expoPushToken?: Maybe<ExpoPushTokenType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Сообщение json */
  message?: Maybe<Scalars['JSONString']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Id ответа */
  responseId?: Maybe<Scalars['String']>;
  /** Статус ответа */
  responseStatus?: Maybe<Scalars['String']>;
  /** Дата и время отпраки уведомления */
  sendingTime?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Время жизни */
  ttl?: Maybe<Scalars['Int']>;
};

export type FaqType = {
  __typename?: 'FaqType';
  /** Ответ */
  answer?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  eventGroupsByFaq?: Maybe<Array<EventGroupType>>;
  eventsByFaqs?: Maybe<Array<EventType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Вопрос */
  question?: Maybe<Scalars['String']>;
};

export type FavoriteContentMutation = {
  __typename?: 'FavoriteContentMutation';
  favorite?: Maybe<Scalars['String']>;
};

export type FavoriteInput = {
  content: Scalars['Int'];
  favoriteOrNot: Scalars['Boolean'];
};

export type FavoritesType = {
  __typename?: 'FavoritesType';
  content?: Maybe<ContentType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  favoriteOrNot?: Maybe<Scalars['Boolean']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  user?: Maybe<UserType>;
};

export type GameScoreEntryType = {
  __typename?: 'GameScoreEntryType';
  classNumber?: Maybe<Scalars['Int']>;
  games?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  place?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type GameScoreType = {
  __typename?: 'GameScoreType';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  my?: Maybe<GameScoreEntryType>;
  topTen?: Maybe<Array<Maybe<GameScoreEntryType>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GameType = {
  __typename?: 'GameType';
  /** Ссылка на трансляцию */
  broadcast?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['CustomDateTime']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['CustomDateTime']>;
  enrollments?: Maybe<Array<Maybe<EnrollmentType>>>;
  enrollmentsByGame?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  /** Id игры GO сервиса */
  externalId?: Maybe<Scalars['String']>;
  federalDistrict?: Maybe<Scalars['String']>;
  hasPlayed?: Maybe<Scalars['Boolean']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  personalScore?: Maybe<Scalars['Int']>;
  /** ID игры из api quiz */
  quizGameId?: Maybe<Scalars['String']>;
  ratingByGame?: Maybe<Array<QuizRatingType>>;
  ratings?: Maybe<Array<Maybe<QuizRatingType>>>;
  /** Время окончания регистрации */
  registerOffDate?: Maybe<Scalars['CustomDateTime']>;
  registered?: Maybe<Scalars['Boolean']>;
  /** тур */
  round?: Maybe<RoundType>;
  timezone?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  type: Type;
};

/**  Auto generated Type for a model's GenericForeignKey field  */
export type GenericForeignKeyType = {
  __typename?: 'GenericForeignKeyType';
  appLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  modelName?: Maybe<Scalars['String']>;
};

export type GovernmentType = {
  __typename?: 'GovernmentType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  events?: Maybe<Array<EventType>>;
  /** Название органа власти */
  governmentName?: Maybe<Scalars['String']>;
  governmentUser?: Maybe<Array<UserType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
};

export type InvitationDataByTokenType = {
  __typename?: 'InvitationDataByTokenType';
  inviteeRole?: Maybe<Scalars['String']>;
  inviterRole?: Maybe<Scalars['String']>;
  /** UUID приглашающего */
  inviterUuid?: Maybe<Scalars['UUID']>;
  /** Приглашает в проект */
  project?: Maybe<ProjectType>;
  qrCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Токен */
  token?: Maybe<Scalars['String']>;
};

export type InvitationTokenByAccountDataType = {
  __typename?: 'InvitationTokenByAccountDataType';
  qrCode?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export enum InviterRoleChoices {
  Department = 'DEPARTMENT',
  Division = 'DIVISION',
  Ministry = 'MINISTRY',
  Municipality = 'MUNICIPALITY'
}

export type LeadInput = {
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['Date']>;
  city: Scalars['String'];
  email: Scalars['String'];
  extra1?: InputMaybe<Scalars['String']>;
  extra2?: InputMaybe<Scalars['String']>;
  extra3?: InputMaybe<Scalars['String']>;
  extra4?: InputMaybe<Scalars['String']>;
  extra5?: InputMaybe<Scalars['String']>;
  extra6?: InputMaybe<Scalars['String']>;
  extra7?: InputMaybe<Scalars['String']>;
  extra8?: InputMaybe<Scalars['String']>;
  extra9?: InputMaybe<Scalars['String']>;
  extra10?: InputMaybe<Scalars['String']>;
  extra11?: InputMaybe<Scalars['String']>;
  extra12?: InputMaybe<Scalars['String']>;
  extra13?: InputMaybe<Scalars['String']>;
  extra14?: InputMaybe<Scalars['String']>;
  extra15?: InputMaybe<Scalars['String']>;
  extra16?: InputMaybe<Scalars['String']>;
  fullname: Scalars['String'];
  phone: Scalars['String'];
  projectLink: Scalars['String'];
  user?: InputMaybe<UserInput>;
  uuid?: InputMaybe<Scalars['UUID']>;
};

export type LeadMutation = {
  __typename?: 'LeadMutation';
  lead?: Maybe<LeadType>;
};

export enum LeadStatusEnum {
  /** Одобрено */
  Approved = 'APPROVED',
  /** Отказано */
  Declined = 'DECLINED',
  /** На рассмотрении */
  InProgress = 'IN_PROGRESS'
}

export type LeadType = {
  __typename?: 'LeadType';
  address?: Maybe<AddressType>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['CustomDate']>;
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** Текстовое поле 1 */
  extra1?: Maybe<Scalars['String']>;
  /** Текстовое поле 2 */
  extra2?: Maybe<Scalars['String']>;
  /** Текстовое поле 3 */
  extra3?: Maybe<Scalars['String']>;
  /** Текстовое поле 4 */
  extra4?: Maybe<Scalars['String']>;
  /** Текстовое поле 5 */
  extra5?: Maybe<Scalars['String']>;
  /** Текстовое поле 6 */
  extra6?: Maybe<Scalars['String']>;
  /** Текстовое поле 7 */
  extra7?: Maybe<Scalars['String']>;
  /** Текстовое поле 8 */
  extra8?: Maybe<Scalars['String']>;
  /** Текстовое поле 9 */
  extra9?: Maybe<Scalars['String']>;
  /** Текстовое поле 10 */
  extra10?: Maybe<Scalars['String']>;
  /** Текстовое поле 11 */
  extra11?: Maybe<Scalars['String']>;
  /** Текстовое поле 12 */
  extra12?: Maybe<Scalars['String']>;
  /** Текстовое поле 13 */
  extra13?: Maybe<Scalars['String']>;
  /** Текстовое поле 14 */
  extra14?: Maybe<Scalars['String']>;
  /** Текстовое поле 15 */
  extra15?: Maybe<Scalars['String']>;
  /** Текстовое поле 16 */
  extra16?: Maybe<Scalars['String']>;
  /** ФИО */
  fullname?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']>;
  /** Метка проекта */
  projectLink?: Maybe<Scalars['String']>;
  /** Статус заявки */
  status?: Maybe<LeadStatusEnum>;
  user?: Maybe<UserType>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
};

export type LeagueOfLecturersEnrollmentType = {
  __typename?: 'LeagueOfLecturersEnrollmentType';
  /** Документ о согласии ч.1 (закрытая ссылка) */
  agreementFile?: Maybe<Scalars['String']>;
  /** Документ о согласии ч.2 (закрытая ссылка) */
  agreementFilePart2?: Maybe<Scalars['String']>;
  /** Документ о согласии ч.3 (закрытая ссылка) */
  agreementFilePart3?: Maybe<Scalars['String']>;
  category?: Maybe<CategoryType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Первая тема выступления(4 этап) */
  firstThemeOfSpeech?: Maybe<Scalars['String']>;
  /** Четвертая тема выступления(7 этап) */
  fourthThemeOfSpeech?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Название лекции */
  lectureName?: Maybe<Scalars['String']>;
  /** Краткое описание лекции */
  lectureShortDescription?: Maybe<Scalars['String']>;
  /** Видеолекция */
  lectureVideo?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Тема выступления */
  performanceTheme?: Maybe<Scalars['String']>;
  pollByEnrollmentLl?: Maybe<Array<PollType>>;
  season?: Maybe<LeagueOfLecturersSeasonType>;
  /** Вторая тема выступления(5 этап) */
  secondThemeOfSpeech?: Maybe<Scalars['String']>;
  /** Этап */
  stage?: Maybe<Scalars['Int']>;
  /** Статус */
  status?: Maybe<EnrollmentStatusEnum>;
  /** Статус на данном этапе */
  statusStage?: Maybe<EnrollmentStatusStageEnum>;
  /** Третья тема выступления(6 этап) */
  thirdThemeOfSpeech?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['Int']>;
  user?: Maybe<UserType>;
  /** Видеовизитка */
  videocard?: Maybe<Scalars['String']>;
};

export type LeagueOfLecturersSeasonType = {
  __typename?: 'LeagueOfLecturersSeasonType';
  /** application finishes at */
  applicationFinishesAt?: Maybe<Scalars['CustomDate']>;
  /** application starts at */
  applicationStartsAt?: Maybe<Scalars['CustomDate']>;
  enrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** season end date */
  seasonEndDate?: Maybe<Scalars['CustomDate']>;
  speakersBySeason?: Maybe<Array<SpeakerType>>;
  /** Имя сезона */
  title?: Maybe<Scalars['String']>;
};

export type LearnType = {
  __typename?: 'LearnType';
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
  /** Группы мероприятий */
  eventsGroups?: Maybe<EventGroupType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  /** order */
  order?: Maybe<Scalars['Int']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type LeaveEventMutation = {
  __typename?: 'LeaveEventMutation';
  event?: Maybe<EventType>;
  result?: Maybe<Scalars['String']>;
};

export type LikeContentMutation = {
  __typename?: 'LikeContentMutation';
  like?: Maybe<Scalars['String']>;
};

export type LikeInput = {
  content: Scalars['Int'];
  likeOrNot: Scalars['Boolean'];
};

export type LikesType = {
  __typename?: 'LikesType';
  content?: Maybe<ContentType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  likeOrNot?: Maybe<Scalars['Boolean']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  user?: Maybe<UserType>;
};

export type MailingListMutation = {
  __typename?: 'MailingListMutation';
  email?: Maybe<MailingListType>;
};

export type MailingListType = {
  __typename?: 'MailingListType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
};

export type MainSliderType = {
  __typename?: 'MainSliderType';
  active?: Maybe<Scalars['Boolean']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  /** category */
  category?: Maybe<Array<CategoryType>>;
  /** Дата */
  date?: Maybe<Scalars['CustomDate']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Дата окончания */
  endDate?: Maybe<Scalars['CustomDate']>;
  events?: Maybe<Array<Maybe<EventType>>>;
  eventsWithMeta?: Maybe<EventNewType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Картинка */
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  mobileImage?: Maybe<Scalars['String']>;
  /** Заголовок */
  name?: Maybe<Scalars['String']>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  /** Ссылка для перехода */
  url?: Maybe<Scalars['String']>;
  /** Место проведения */
  venue?: Maybe<VenueType>;
  /** Видео */
  video?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type MatchMemberTicketInput = {
  birthDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  ticketNumber?: InputMaybe<Scalars['String']>;
};

export type MatchMemberTicketMutation = {
  __typename?: 'MatchMemberTicketMutation';
  memberTicket?: Maybe<MemberTicketType>;
};

export enum MatchType {
  BestFields = 'best_fields',
  BoolPrefix = 'bool_prefix',
  CrossFields = 'cross_fields',
  MostFields = 'most_fields',
  Phrase = 'phrase',
  PhrasePrefix = 'phrase_prefix'
}

export enum MemberProgrammeEnum {
  /** Бакалавриат */
  Bachelor = 'BACHELOR',
  /** Магистратура */
  Master = 'MASTER',
  /** Аспирантура */
  Postgraduate = 'POSTGRADUATE',
  /** Школьник */
  Scholar = 'SCHOLAR',
  /** Специалитет */
  Specialist = 'SPECIALIST'
}

export enum MemberTicketDiscountCardEnum {
  /** Нет */
  Empty = 'EMPTY',
  /** Пенсионер */
  Retiree = 'RETIREE',
  /** Учащиеся СПО */
  SpoStudent = 'SPO_STUDENT',
  /** Студенты и аспиранты ВУЗов */
  UniStudent = 'UNI_STUDENT'
}

export enum MemberTicketEducationalExperienceEnum {
  /** Отсутствует */
  Absent = 'ABSENT',
  /** Более 5 лет */
  ManyYears = 'MANY_YEARS',
  /** 1-5 лет */
  SeveralYears = 'SEVERAL_YEARS',
  /** До 1 года */
  Year = 'YEAR'
}

export enum MemberTicketStatusEnum {
  /** Одобрена */
  Approved = 'APPROVED',
  /** Ожидает оплаты */
  AwaitingPayment = 'AWAITING_PAYMENT',
  /** Отклонена */
  Declined = 'DECLINED',
  /** На рассмотрении */
  InProgress = 'IN_PROGRESS'
}

/** Членский билет */
export type MemberTicketType = {
  __typename?: 'MemberTicketType';
  /** Дополнительная информация */
  additionalInformation?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Комментарий в случае отклонения заявки. */
  denialComment?: Maybe<Scalars['String']>;
  /** Дата отклонения */
  denialDate?: Maybe<Scalars['CustomDate']>;
  /** Льготная карта */
  discountCard?: Maybe<MemberTicketDiscountCardEnum>;
  /** Файл-подтверждение льготной категории (закрытая ссылка) */
  discountCardFile?: Maybe<Scalars['String']>;
  /** Опыт (стаж) просветительской работы в обществах “Знание” СССР или России */
  educationalExperience?: Maybe<MemberTicketEducationalExperienceEnum>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Дата рождения, из членского билета */
  oldBirthDate?: Maybe<Scalars['CustomDate']>;
  /** Имя, из членского билета */
  oldFirstName?: Maybe<Scalars['String']>;
  /** Фамилия, из членского билета */
  oldLastName?: Maybe<Scalars['String']>;
  /** Отчество, из членского билета */
  oldMiddleName?: Maybe<Scalars['String']>;
  /** Статус */
  status?: Maybe<MemberTicketStatusEnum>;
  /** Номер билета */
  ticketNumber?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

export type MemberType = {
  __typename?: 'MemberType';
  /** Буква класса */
  classLetter?: Maybe<Scalars['String']>;
  /** Номер класса/курса */
  classNumber?: Maybe<Scalars['Int']>;
  confirmation?: Maybe<Scalars['Boolean']>;
  /** Школа/Университет/и другое */
  division?: Maybe<DivisionSuggestedType>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Направление подготовки */
  programme?: Maybe<MemberProgrammeEnum>;
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Специальность */
  speciality?: Maybe<Scalars['String']>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
};

export type MembersToDivisionInput = {
  division?: InputMaybe<Scalars['Int']>;
  members?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type MembersToDivisionMutation = {
  __typename?: 'MembersToDivisionMutation';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type MinistryType = {
  __typename?: 'MinistryType';
  confirmation?: Maybe<Scalars['Boolean']>;
  departments?: Maybe<Array<Maybe<DepartmentAccountType>>>;
  divisionsByMinistry?: Maybe<Array<DivisionSuggestedType>>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Фио представителя */
  representative?: Maybe<Scalars['String']>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
};

export type MunicipalityType = {
  __typename?: 'MunicipalityType';
  confirmation?: Maybe<Scalars['Boolean']>;
  divisions?: Maybe<Array<Maybe<DivisionType>>>;
  divisionsByMunicipality?: Maybe<Array<DivisionSuggestedType>>;
  divisionsByRegion?: Maybe<Array<Maybe<DivisionType>>>;
  /** Аватар */
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Проекты */
  projects?: Maybe<Array<ProjectType>>;
  /** Фио представителя */
  representative?: Maybe<Scalars['String']>;
  /** Название */
  title?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
};


export type MunicipalityTypeDivisionsByRegionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addLike?: Maybe<AddLikeMutation>;
  addSpeakerReportToEventItem?: Maybe<AddSpeakerReportToEventItemMutation>;
  applyForMemberTicket?: Maybe<ApplyForMemberTicketMutation>;
  becomeDivisionCoordinator?: Maybe<BecomeDivisionCoordinatorMutation>;
  /** Проверка ответа */
  checkAnswer?: Maybe<CheckAnswerMutations>;
  checkEmailVerification?: Maybe<CheckEmailVerificationMutation>;
  cinemaRegister?: Maybe<CinemaRegisterMutation>;
  createActionParticipation?: Maybe<CreateActionParticipationMutation>;
  createAddress?: Maybe<CreateAddressMutation>;
  createAnswer?: Maybe<CreateAnswerMutation>;
  createCapitan?: Maybe<CreateCapitanMutation>;
  createEnrollmentSchool?: Maybe<SchoolCreateMutation>;
  createEnrollmentScientistSchool?: Maybe<SchoolScientistCreateMutation>;
  createEnrollmentScientistSchoolVisit?: Maybe<SchoolScientistVisitCreateMutation>;
  createEventNps?: Maybe<EventNpsMutation>;
  createIndividualStage?: Maybe<CreateIndividualStageMutation>;
  createLead?: Maybe<LeadMutation>;
  createLeagueEnrollment?: Maybe<CreateLeagueMutation>;
  createMailingList?: Maybe<MailingListMutation>;
  createNps?: Maybe<ContentNpsMutation>;
  createNpsWithoutUser?: Maybe<ContentNpsWithoutUserMutation>;
  createQuizRegistration?: Maybe<CreateQuizRegistrationMutation>;
  createScan?: Maybe<ScanMutation>;
  createScanUniversity?: Maybe<ScanUniversityMutation>;
  createSmsAuthorize?: Maybe<CreateAuthorizeMutation>;
  createSpeakerRegistrationToDivision?: Maybe<CreateSpeakerRegistrationToDivisionMutation>;
  createSpeakerRequest?: Maybe<SpeakerRequestMutation>;
  createTelegramUser?: Maybe<CreateTelegramUserMutation>;
  createUserQuestion?: Maybe<CreateUserQuestion>;
  deleteEnrollmentScientistSchoolVisit?: Maybe<SchoolScientistVisitDeleteMutation>;
  deleteQuizRegistration?: Maybe<DeleteQuizRegistrationMutation>;
  deleteRefreshTokenCookie?: Maybe<DeleteRefreshTokenCookie>;
  deleteSpeakerRegistrationToDivision?: Maybe<DeleteSpeakerRegistrationToDivisionMutation>;
  deleteTokenCookie?: Maybe<DeleteJsonWebTokenCookie>;
  divisionsToDepartment?: Maybe<DivisionsToDepartmentMutation>;
  divisionsToMunicipality?: Maybe<DivisionsToMunicipalityMutation>;
  /** Mutation is used for create Enrollment to Event from Event page on site. */
  enrollToEvent?: Maybe<EnrollToEventMutation>;
  /** Mutation is used for make Enrollment attended (or create and make attended) using qr-code of Enrollment. */
  enrollmentCheckin?: Maybe<EnrollmentCheckinMutation>;
  /**
   * Mutation is used for make Enrollment attended (or create and make attended) using qr-code of Event.
   * User scans qr-code, authorized on site and mutation is applied.
   */
  enrollmentCheckinNoAdmin?: Maybe<EnrollmentCheckinNoAdminMutation>;
  /**
   * Delete token by token str
   * expoPushTokenDelete(token: "%(token)s")
   * {
   *     message
   * }
   */
  expoPushTokenDelete?: Maybe<ExpoPushTokenDeleteMutation>;
  /**
   * Save new token
   * expoPushTokenSave(token: "%(token)s", isActive: %(is_active)s)
   * {
   *     expoPushToken {
   *         token
   *         isActive
   *     }
   * }
   */
  expoPushTokenSave?: Maybe<ExpoPushTokenSaveMutation>;
  leaveEvent?: Maybe<LeaveEventMutation>;
  matchMemberTicket?: Maybe<MatchMemberTicketMutation>;
  membersToDivision?: Maybe<MembersToDivisionMutation>;
  /** Регистрация участника на конкурс */
  participantRegistration?: Maybe<ParticipantRegistrationMutations>;
  /** Погашение промокода. Начисляется количество баллов по промокоду, который привязан к конкурсу на счет участника. */
  promoCodeRedemption?: Maybe<PromoCodeRedemption>;
  refreshToken?: Maybe<Refresh>;
  registerActionDivision?: Maybe<RegisterActionDivisionMutation>;
  registerDivision?: Maybe<RegisterDivisionMutation>;
  registerMember?: Maybe<RegisterMemberMutation>;
  registerParticipation?: Maybe<RegisterParticipationMutation>;
  registerUser?: Maybe<RegisterUserMutation>;
  resetPassword?: Maybe<ResetPasswordMutation>;
  revokeToken?: Maybe<Revoke>;
  sendResetToken?: Maybe<ResetPasswordTokenMutation>;
  tokenAuth?: Maybe<TokenAuthMutation>;
  updateCapitan?: Maybe<UpdateCapitanMutation>;
  updateDivisionAddress?: Maybe<UpdateDivisionAddressMutation>;
  updateEnrollmentSchool?: Maybe<SchoolUpdateMutation>;
  updateEnrollmentScientistSchool?: Maybe<SchoolScientistUpdateMutation>;
  updateFavorite?: Maybe<FavoriteContentMutation>;
  updateLeagueEnrollment?: Maybe<UpdateLeagueMutation>;
  updateLike?: Maybe<LikeContentMutation>;
  updateMemberTicket?: Maybe<UpdateMemberTicketMutation>;
  updateQuizRegistration?: Maybe<UpdateQuizRegistrationMutation>;
  updateSpeakerRegistrationToDivision?: Maybe<UpdateSpeakerRegistrationToDivisionMutation>;
  updateUser?: Maybe<UpdateUserMutation>;
  updateView?: Maybe<ContentViewMutation>;
  verificationLeagueEnrollment?: Maybe<VerificationLeagueEnrollmentMutation>;
  verifyToken?: Maybe<Verify>;
};


export type MutationAddLikeArgs = {
  nomineeSlug: Scalars['String'];
};


export type MutationAddSpeakerReportToEventItemArgs = {
  input?: InputMaybe<SpeakerReportToDivisionInput>;
};


export type MutationApplyForMemberTicketArgs = {
  input?: InputMaybe<CreateMemberTicketInput>;
};


export type MutationBecomeDivisionCoordinatorArgs = {
  input?: InputMaybe<BecomeDivisionCoordinatorInput>;
};


export type MutationCheckAnswerArgs = {
  input?: InputMaybe<CheckAnswerInput>;
};


export type MutationCheckEmailVerificationArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationCinemaRegisterArgs = {
  cinemaSlug?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fio?: InputMaybe<Scalars['String']>;
};


export type MutationCreateActionParticipationArgs = {
  input?: InputMaybe<ActionParticipationInput>;
};


export type MutationCreateAddressArgs = {
  input?: InputMaybe<AddressInput>;
};


export type MutationCreateAnswerArgs = {
  input?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
};


export type MutationCreateCapitanArgs = {
  input?: InputMaybe<CreateCapitanInput>;
};


export type MutationCreateEnrollmentSchoolArgs = {
  input?: InputMaybe<SchoolCreateInput>;
};


export type MutationCreateEnrollmentScientistSchoolVisitArgs = {
  input?: InputMaybe<SchoolScientistVisitInput>;
};


export type MutationCreateEventNpsArgs = {
  input?: InputMaybe<EventNpsInput>;
};


export type MutationCreateIndividualStageArgs = {
  gameId: Scalars['ID'];
};


export type MutationCreateLeadArgs = {
  input?: InputMaybe<LeadInput>;
};


export type MutationCreateLeagueEnrollmentArgs = {
  input?: InputMaybe<CreateLeagueInput>;
};


export type MutationCreateMailingListArgs = {
  input?: InputMaybe<EmailInput>;
};


export type MutationCreateNpsArgs = {
  input?: InputMaybe<RatingInput>;
};


export type MutationCreateNpsWithoutUserArgs = {
  input?: InputMaybe<RatingInput>;
};


export type MutationCreateQuizRegistrationArgs = {
  comment?: InputMaybe<Scalars['String']>;
  firstGame: Scalars['Boolean'];
  gameId: Scalars['ID'];
  teamCity?: InputMaybe<Scalars['String']>;
  teamMembers?: InputMaybe<Scalars['Int']>;
  teamName?: InputMaybe<Scalars['String']>;
};


export type MutationCreateScanArgs = {
  input?: InputMaybe<ScanInput>;
};


export type MutationCreateScanUniversityArgs = {
  input?: InputMaybe<ScanUniversityInput>;
};


export type MutationCreateSmsAuthorizeArgs = {
  phone: Scalars['String'];
};


export type MutationCreateSpeakerRegistrationToDivisionArgs = {
  input?: InputMaybe<SpeakerRegistrationToDivisionInput>;
};


export type MutationCreateSpeakerRequestArgs = {
  input?: InputMaybe<SpeakerRequestInput>;
};


export type MutationCreateTelegramUserArgs = {
  input?: InputMaybe<TelegramUserInput>;
};


export type MutationCreateUserQuestionArgs = {
  input?: InputMaybe<QuestionInput>;
};


export type MutationDeleteEnrollmentScientistSchoolVisitArgs = {
  input?: InputMaybe<SchoolScientistVisitInput>;
};


export type MutationDeleteQuizRegistrationArgs = {
  enrollmentId: Scalars['ID'];
};


export type MutationDeleteSpeakerRegistrationToDivisionArgs = {
  input?: InputMaybe<SpeakerLeaveDivisionInput>;
};


export type MutationDivisionsToDepartmentArgs = {
  input?: InputMaybe<DivisionsToDepartmentInput>;
};


export type MutationDivisionsToMunicipalityArgs = {
  input?: InputMaybe<DivisionsToMunicipalityInput>;
};


export type MutationEnrollToEventArgs = {
  eventSlug?: InputMaybe<Scalars['String']>;
};


export type MutationEnrollmentCheckinArgs = {
  input?: InputMaybe<EnrollmentCheckinMInput>;
};


export type MutationEnrollmentCheckinNoAdminArgs = {
  eventUuid?: InputMaybe<Scalars['String']>;
};


export type MutationExpoPushTokenDeleteArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationExpoPushTokenSaveArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationLeaveEventArgs = {
  eventSlug?: InputMaybe<Scalars['String']>;
};


export type MutationMatchMemberTicketArgs = {
  input?: InputMaybe<MatchMemberTicketInput>;
};


export type MutationMembersToDivisionArgs = {
  input?: InputMaybe<MembersToDivisionInput>;
};


export type MutationParticipantRegistrationArgs = {
  input?: InputMaybe<ParticipantRegistrationInput>;
};


export type MutationPromoCodeRedemptionArgs = {
  input?: InputMaybe<PromoCodeRedemptionInput>;
};


export type MutationRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterActionDivisionArgs = {
  input?: InputMaybe<ActionDivisionInput>;
};


export type MutationRegisterDivisionArgs = {
  input?: InputMaybe<RegisterDivisionInput>;
};


export type MutationRegisterMemberArgs = {
  input?: InputMaybe<RegisterMemberInput>;
};


export type MutationRegisterParticipationArgs = {
  input?: InputMaybe<RegisterParticipationInput>;
};


export type MutationRegisterUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationResetPasswordArgs = {
  password1: Scalars['String'];
  password2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRevokeTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type MutationSendResetTokenArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationTokenAuthArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationUpdateCapitanArgs = {
  input?: InputMaybe<UpdateCapitanInput>;
};


export type MutationUpdateDivisionAddressArgs = {
  input?: InputMaybe<UpdateDivisionAddressInput>;
};


export type MutationUpdateEnrollmentSchoolArgs = {
  input?: InputMaybe<SchoolUpdateInput>;
};


export type MutationUpdateEnrollmentScientistSchoolArgs = {
  input?: InputMaybe<SchoolScientistUpdateInput>;
};


export type MutationUpdateFavoriteArgs = {
  input?: InputMaybe<FavoriteInput>;
};


export type MutationUpdateLeagueEnrollmentArgs = {
  input?: InputMaybe<UpdateLeagueInput>;
};


export type MutationUpdateLikeArgs = {
  input?: InputMaybe<LikeInput>;
};


export type MutationUpdateMemberTicketArgs = {
  input?: InputMaybe<UpdateMemberTicketInput>;
};


export type MutationUpdateQuizRegistrationArgs = {
  teamId: Scalars['ID'];
  teamMembers: Scalars['Int'];
};


export type MutationUpdateSpeakerRegistrationToDivisionArgs = {
  input?: InputMaybe<UpdateSpeakerRegistrationToDivisionInput>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateViewArgs = {
  input?: InputMaybe<ViewInput>;
};


export type MutationVerificationLeagueEnrollmentArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationVerifyTokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export type NomineeType = {
  __typename?: 'NomineeType';
  awards?: Maybe<Array<Maybe<AwardType>>>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Изображение */
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  liked?: Maybe<Scalars['Boolean']>;
  likesByNominee?: Maybe<Array<LikesType>>;
  /** Номинация */
  nomination?: Maybe<Scalars['String']>;
  /** Загрузить презентацию */
  presentation?: Maybe<Scalars['String']>;
  presentationUrl?: Maybe<Scalars['String']>;
  /** Краткое описание */
  preview?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  speaker?: Maybe<SpeakerType>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<NomineeTypeEnum>;
  /** Загрузить видео */
  video?: Maybe<Scalars['String']>;
  /** Ссылка на видео питчинг */
  videoLink?: Maybe<Scalars['String']>;
  /** Ссылка на видео интервью */
  videoLinkInterview?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  /** Год номинации */
  year?: Maybe<Scalars['Int']>;
};

export enum NomineeTypeEnum {
  /** Компания */
  Company = 'COMPANY',
  /** Проект */
  Project = 'PROJECT',
  /** Спикер */
  Speaker = 'SPEAKER'
}

export type NpsType = {
  __typename?: 'NpsType';
  /** Комментарий */
  comment?: Maybe<Scalars['String']>;
  /** Контент */
  content?: Maybe<ContentFilterType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Оценка */
  rating?: Maybe<Scalars['Int']>;
  /** Пользователь */
  user?: Maybe<UserType>;
};

export type OfferType = {
  __typename?: 'OfferType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  offersByEvent?: Maybe<Array<EventType>>;
  offersByEventGroup?: Maybe<Array<EventGroupType>>;
};

export type PageGroupType = {
  __typename?: 'PageGroupType';
  childGroups?: Maybe<Array<Maybe<PageGroupType>>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  pages?: Maybe<Array<Maybe<PageType>>>;
  /** родительская группа */
  parentGroup?: Maybe<PageGroupType>;
  published?: Maybe<Scalars['Boolean']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PageType = {
  __typename?: 'PageType';
  /** Тело страницы */
  body?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Дата */
  date?: Maybe<Scalars['CustomDate']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  documentGroups?: Maybe<Array<Maybe<DocumentGroupType>>>;
  /** group */
  group?: Maybe<PageGroupType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type ParticipantRegistrationInput = {
  slug?: InputMaybe<Scalars['String']>;
};

/** Регистрация участника на конкурс */
export type ParticipantRegistrationMutations = {
  __typename?: 'ParticipantRegistrationMutations';
  participant?: Maybe<ParticipantType>;
};

export type ParticipantType = {
  __typename?: 'ParticipantType';
  account?: Maybe<Array<AccountType>>;
  /** competitions */
  competitions?: Maybe<Array<CompetitionType>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** user */
  user?: Maybe<UserType>;
};

export type PartnerType = {
  __typename?: 'PartnerType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  eventGroupsByInfoPartner?: Maybe<Array<EventGroupType>>;
  eventGroupsByPartner?: Maybe<Array<EventGroupType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  infoPartnersByEvent?: Maybe<Array<EventType>>;
  /** logo */
  logo?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название партнера */
  name?: Maybe<Scalars['String']>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  partnersByEvent?: Maybe<Array<EventType>>;
  /** Метка партнера (slug) */
  slug?: Maybe<Scalars['String']>;
  /** url */
  url?: Maybe<Scalars['String']>;
};

export type PersonType = {
  __typename?: 'PersonType';
  /** Бейдж */
  badge?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** department */
  department?: Maybe<DepartmentType>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** Имя */
  firstName?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Фамилия */
  lastName?: Maybe<Scalars['String']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  photo?: Maybe<Scalars['String']>;
  /** Должность */
  position?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Ссылка */
  url?: Maybe<Scalars['String']>;
};

export enum PollProjectTypeEnum {
  /** Акции */
  EventActions = 'EVENT_ACTIONS',
  /** Мероприятия cо спикерами */
  EventWithSpeakers = 'EVENT_WITH_SPEAKERS',
  /** Лига лекторов */
  LeagueOfLectors = 'LEAGUE_OF_LECTORS',
  /** Ученый в школах */
  SchoolScientist = 'SCHOOL_SCIENTIST'
}

export type PollType = {
  __typename?: 'PollType';
  /** Type for a GenericForeignKey field */
  contentObject?: Maybe<GenericForeignKeyType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Заявка на ЛЛ */
  enrollmentLl?: Maybe<LeagueOfLecturersEnrollmentType>;
  eventItemsByPollGeneric?: Maybe<Array<EventItemType>>;
  eventsByPollGeneric?: Maybe<Array<EventType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isTemplate?: Maybe<Scalars['Boolean']>;
  isTemplateForAction?: Maybe<Scalars['Boolean']>;
  isTemplateForEvents?: Maybe<Scalars['Boolean']>;
  /** Номер этапа ЛЛ */
  leagueOfLecturersStage?: Maybe<Scalars['Int']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Опрос */
  name?: Maybe<Scalars['String']>;
  /** object id */
  objectId?: Maybe<Scalars['Int']>;
  pollByEvent?: Maybe<EventType>;
  pollByEventItem?: Maybe<Array<EventItemType>>;
  pollBySpeakers?: Maybe<Array<SpeakerType>>;
  /** Итоговый балл по опросу */
  pollResultScore?: Maybe<Scalars['Int']>;
  /** Опросы связанные с главным опросом */
  polls?: Maybe<Array<PollType>>;
  /** Место блоков со спикерами на фронте */
  pollsPosition?: Maybe<Scalars['Int']>;
  /** Тип проекта */
  projectType?: Maybe<PollProjectTypeEnum>;
  /** qr code */
  qrCode?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<QuestionType>>>;
  questionsByPoll?: Maybe<Array<ActualQuestionType>>;
  schoolScientistPoll?: Maybe<SchoolScientistType>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  speaker?: Maybe<SpeakerType>;
  speakersByPollGeneric?: Maybe<Array<SpeakerType>>;
};

export type PostType = {
  __typename?: 'PostType';
  /** Тело новости */
  body?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Изображение */
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  mark?: Maybe<Scalars['Boolean']>;
  /** Изображение для моб. версии */
  mobileImage?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  /** Время новости */
  publishedAt?: Maybe<Scalars['CustomDateTime']>;
  searchScore?: Maybe<Scalars['Float']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Спец проекты */
  specialProject?: Maybe<Array<SpecialProjectType>>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type PostTypeNode = Node & {
  __typename?: 'PostTypeNode';
  body?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  mark: Scalars['Boolean'];
  mobileImageUrl?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  publishedAt: Scalars['DateTime'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type PostTypeNodeConnection = {
  __typename?: 'PostTypeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PostTypeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PostTypeNode` and its cursor. */
export type PostTypeNodeEdge = {
  __typename?: 'PostTypeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PostTypeNode>;
};

export type PostTypeWithMeta = {
  __typename?: 'PostTypeWithMeta';
  imageUrl?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  /** Post list, paginated by LimitOffsetPaginator */
  results?: Maybe<Array<Maybe<PostType>>>;
  /** Total count of matches elements */
  totalCount?: Maybe<Scalars['Int']>;
};


export type PostTypeWithMetaResultsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
};

export enum PreparationChoices {
  Bachelor = 'BACHELOR',
  Master = 'MASTER',
  Postgraduate = 'POSTGRADUATE',
  Scholar = 'SCHOLAR',
  Specialist = 'SPECIALIST'
}

export enum ProcurementStateEnum {
  /** Активная */
  Active = 'ACTIVE',
  /** Завершенная */
  Finished = 'FINISHED',
  /** Предстоящая */
  Pending = 'PENDING'
}

export type ProcurementType = {
  __typename?: 'ProcurementType';
  /** Итоги */
  act?: Maybe<Scalars['String']>;
  actUrl?: Maybe<Scalars['String']>;
  /** Дата окончания приема заявок */
  closingDate?: Maybe<Scalars['CustomDate']>;
  /** Контактный емэйл */
  contactsEmail?: Maybe<Scalars['String']>;
  /** Контактное лицо */
  contactsName?: Maybe<Scalars['String']>;
  /** Контактный телефон */
  contactsPhone?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Документация */
  documentation?: Maybe<Scalars['String']>;
  documentationUrl?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Электронная площадка */
  platformUrl?: Maybe<Scalars['String']>;
  /** Дата публикации */
  publishingDate?: Maybe<Scalars['CustomDate']>;
  /** Номер закупки */
  regId?: Maybe<Scalars['String']>;
  /** Начальная цена */
  startPrice?: Maybe<Scalars['Float']>;
  /** Статус закупки */
  state?: Maybe<ProcurementStateEnum>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Тип закупки */
  type?: Maybe<Scalars['String']>;
};

export type ProjectStageType = {
  __typename?: 'ProjectStageType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Дата конца */
  dateEnd?: Maybe<Scalars['CustomDateTime']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['CustomDateTime']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Проект */
  project?: Maybe<ProjectType>;
  /** Стадия проекта */
  title?: Maybe<Scalars['String']>;
};

export type ProjectType = {
  __typename?: 'ProjectType';
  accountType?: Maybe<Scalars['String']>;
  department?: Maybe<DepartmentAccountType>;
  departmentsByProjects?: Maybe<Array<DepartmentType>>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  division?: Maybe<DivisionType>;
  divisionsByProjects?: Maybe<Array<DivisionSuggestedType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  membersByProjects?: Maybe<Array<MemberType>>;
  ministriesByProjects?: Maybe<Array<MinistryType>>;
  ministry?: Maybe<MinistryType>;
  municipalitiesByProjects?: Maybe<Array<MunicipalityType>>;
  municipality?: Maybe<MunicipalityType>;
  slug?: Maybe<Scalars['String']>;
  /** special project */
  specialProject?: Maybe<SpecialProjectType>;
  stages?: Maybe<Array<Maybe<ProjectStageType>>>;
  statistics?: Maybe<StatisticType>;
  title?: Maybe<Scalars['String']>;
  /** Ссылка */
  url?: Maybe<Scalars['String']>;
};

/** Погашение промокода. Начисляется количество баллов по промокоду, который привязан к конкурсу на счет участника. */
export type PromoCodeRedemption = {
  __typename?: 'PromoCodeRedemption';
  account?: Maybe<AccountType>;
};

export type PromoCodeRedemptionInput = {
  code?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type PromoCodeType = {
  __typename?: 'PromoCodeType';
  /** accounts */
  accounts?: Maybe<Array<AccountType>>;
  /** Промокод */
  code?: Maybe<Scalars['String']>;
  /** competition */
  competition?: Maybe<CompetitionType>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** redemption datetime */
  redemptionDatetime?: Maybe<Scalars['CustomDateTime']>;
  /** Балл */
  score?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  accounts?: Maybe<Array<Maybe<AccountType>>>;
  actionDivisions?: Maybe<Array<Maybe<ActionDivisionType>>>;
  actionParticipation?: Maybe<ActionParticipationType>;
  actionSources?: Maybe<Array<Maybe<ActionSourceType>>>;
  activeSpeakers?: Maybe<Array<Maybe<SpeakerType>>>;
  actualQuestion?: Maybe<ActualQuestionType>;
  addressNameByFiasId?: Maybe<Scalars['String']>;
  allCourseSections?: Maybe<CourseSectionNodeConnection>;
  allCourses?: Maybe<CourseNodeConnection>;
  answersToQuestionsByAccount?: Maybe<AnswersToQuestionsByAccountType>;
  articleBySlug?: Maybe<ContentType>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  chatBot?: Maybe<ChatBotCheckType>;
  cinemas?: Maybe<Array<Maybe<CinemaType>>>;
  /** Competition list */
  competitions?: Maybe<Array<CompetitionType>>;
  contentBySlug?: Maybe<ContentType>;
  /** Content list */
  contents?: Maybe<Array<ContentType>>;
  /** Content list */
  contentsByDescribeTag?: Maybe<Array<ContentType>>;
  /** Content list */
  contentsByMacroTag?: Maybe<Array<ContentType>>;
  /** Content list */
  contentsByMacroTagWithMeta?: Maybe<ContentTypeWithMeta>;
  /** Content list */
  contentsByMicroTags?: Maybe<Array<ContentType>>;
  /** Content list */
  contentsByMicroTagsWithMeta?: Maybe<ContentWithMetaListType>;
  /** Content list */
  contentsByThemeTag?: Maybe<Array<ContentType>>;
  /** Content list */
  contentsListObjects?: Maybe<ContentTypeWithMeta>;
  contentsWithMeta?: Maybe<ContentWithMetaType>;
  countPosts?: Maybe<Scalars['Int']>;
  course?: Maybe<CourseNode>;
  courseSection?: Maybe<CourseSectionNode>;
  currentGames?: Maybe<Array<Maybe<GameType>>>;
  currentGamesByUser?: Maybe<Array<Maybe<GameType>>>;
  currentRound?: Maybe<Array<Maybe<RoundType>>>;
  currentSeason?: Maybe<Array<Maybe<SeasonType>>>;
  dailyQuestionUserScore?: Maybe<DailyQuestionUserScoreType>;
  departmentBySlug?: Maybe<DepartmentType>;
  departmentDetails?: Maybe<DepartmentDetailsType>;
  departments?: Maybe<Array<Maybe<DepartmentType>>>;
  divisionTypes?: Maybe<Array<Maybe<DivisionTypeType>>>;
  divisionsAutocomplete?: Maybe<Array<Maybe<DivisionSuggestedType>>>;
  documentBySlug?: Maybe<DocumentType>;
  documentGroupBySlug?: Maybe<DocumentGroupType>;
  documentGroups?: Maybe<Array<Maybe<DocumentGroupType>>>;
  enrollmentByUuid?: Maybe<EventEnrollmentType>;
  eventBySlug?: Maybe<EventType>;
  eventBySlugNoChd?: Maybe<EventTypeNoChd>;
  eventGroupAction?: Maybe<EventGroupActionType>;
  eventGroupBySlug?: Maybe<EventGroupType>;
  eventGroups?: Maybe<Array<Maybe<EventGroupType>>>;
  eventItemById?: Maybe<EventItemType>;
  /** Event list */
  events?: Maybe<Array<EventType>>;
  /** Event list */
  eventsByMacroTags?: Maybe<Array<EventType>>;
  /** Event list */
  eventsByMicroTags?: Maybe<Array<EventType>>;
  eventsBySlugs?: Maybe<Array<Maybe<EventType>>>;
  eventsWithMeta?: Maybe<EventWithMetaType>;
  expoPushToken?: Maybe<ExpoPushTokenType>;
  expoPushTokenNotification?: Maybe<Array<Maybe<ExpoPushTokenTypeNotifiactionType>>>;
  gameById?: Maybe<GameType>;
  games?: Maybe<Array<Maybe<GameType>>>;
  getCurrentExperiments?: Maybe<Array<Maybe<ExperimentType>>>;
  getEnrollments?: Maybe<Array<Maybe<EventEnrollmentType>>>;
  /** Government list */
  governments?: Maybe<Array<GovernmentType>>;
  invitationDataByToken?: Maybe<InvitationDataByTokenType>;
  invitationTokenByInviterData?: Maybe<InvitationTokenByAccountDataType>;
  leagueTopics?: Maybe<Array<Maybe<TopicType>>>;
  mainSlider?: Maybe<Array<Maybe<MainSliderType>>>;
  materialBySlug?: Maybe<ContentType>;
  me?: Maybe<UserType>;
  microTagBySlug?: Maybe<TagType>;
  microTags?: Maybe<Array<Maybe<TagType>>>;
  nomineeBySlug?: Maybe<NomineeType>;
  /** Nominee list */
  nominees?: Maybe<Array<Maybe<NomineeType>>>;
  pageBySlug?: Maybe<PageType>;
  pageGroupBySlug?: Maybe<PageGroupType>;
  pageGroups?: Maybe<Array<Maybe<PageGroupType>>>;
  /** Participant list */
  participants?: Maybe<Array<ParticipantType>>;
  personBySlug?: Maybe<PersonType>;
  podcastBySlug?: Maybe<ContentType>;
  pollBySlug?: Maybe<PollType>;
  polls?: Maybe<Array<Maybe<PollType>>>;
  post?: Maybe<PostTypeNode>;
  postBySlug?: Maybe<PostType>;
  postBySlugSpecialProjects?: Maybe<Array<Maybe<PostType>>>;
  /** Post list */
  posts?: Maybe<Array<PostType>>;
  /** Post list */
  postsWithMeta?: Maybe<PostTypeWithMeta>;
  postsWithRelay?: Maybe<PostTypeNodeConnection>;
  /** Procurement list */
  procurements?: Maybe<Array<ProcurementType>>;
  questionCategories?: Maybe<Array<Maybe<QuestionCategoryType>>>;
  randomArticles?: Maybe<Array<Maybe<ContentType>>>;
  regions?: Maybe<Array<Maybe<RegionType>>>;
  scorePersonal?: Maybe<GameScoreType>;
  scoreTeam?: Maybe<GameScoreType>;
  search?: Maybe<SearchType>;
  /** School list */
  searchSchoolEnrollment?: Maybe<Array<SchoolType>>;
  searchSchoolEnrollmentScientist?: Maybe<Array<Maybe<SchoolScientistType>>>;
  searchSchoolEnrollmentScientistVisits?: Maybe<Array<Maybe<ScientistVisitType>>>;
  /** University list */
  searchUniversities?: Maybe<Array<UniversitiesRealType>>;
  seasonBySlug?: Maybe<SeasonType>;
  seasons?: Maybe<Array<Maybe<SeasonType>>>;
  seasonsLeagueOfLecturers?: Maybe<Array<Maybe<LeagueOfLecturersSeasonType>>>;
  speakerById?: Maybe<SpeakerType>;
  /** Speaker list */
  speakers?: Maybe<Array<SpeakerType>>;
  speakersByAlphabet?: Maybe<Array<Maybe<SpeakerAlphabet>>>;
  speakersByThemeTag?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Speaker list */
  speakersWithMeta?: Maybe<SpeakerTypeWithMeta>;
  specialProjects?: Maybe<Array<Maybe<SpecialProjectType>>>;
  statisticsAttractingSpeakers?: Maybe<StatisticsType>;
  suggestAddress?: Maybe<Array<Maybe<AddressType>>>;
  suggestCity?: Maybe<Array<Maybe<AddressType>>>;
  tagCategoriesByMicroTag?: Maybe<TagCategoriesByMicroTagType>;
  tagCategory?: Maybe<Array<Maybe<TagCategoryType>>>;
  tagCategoryBySlug?: Maybe<TagCategoryType>;
  tagCompilation?: Maybe<TagCompilationsWithRelayNode>;
  /** Content list */
  tagCompilationBySlug?: Maybe<Array<ContentType>>;
  /** Content list */
  tagCompilationBySlugListObject?: Maybe<TagCompilationBySlugListType>;
  tagCompilationBySlugWithMeta?: Maybe<TagCompilationBySlagWithMetaType>;
  /** TagsCompilation list */
  tagCompilations?: Maybe<Array<TagsCompilationType>>;
  tagCompilationsWithMeta?: Maybe<TagsCompilationWithMetaType>;
  tagCompilationsWithRelay?: Maybe<TagCompilationsWithRelayNodeConnection>;
  testSentryError?: Maybe<PostType>;
  themeTagCategoriesOfEventGroup?: Maybe<TagCategoryNodeConnection>;
  totalAnweredUsers?: Maybe<TotalAnweredUsersType>;
  videoBySlug?: Maybe<ContentType>;
};


export type QueryAccountsArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  competitionSlug?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  isGetCache?: InputMaybe<Scalars['Boolean']>;
  isUserAccount?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  opType?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Date']>;
};


export type QueryActionDivisionsArgs = {
  eventGroupSlug: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  regionFias?: InputMaybe<Scalars['String']>;
};


export type QueryActionParticipationArgs = {
  eventGroupSlug?: InputMaybe<Scalars['String']>;
};


export type QueryActionSourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryActualQuestionArgs = {
  competitionSlug?: InputMaybe<Scalars['String']>;
};


export type QueryAddressNameByFiasIdArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  cityId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
  settlementId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllCourseSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryAllCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryAnswersToQuestionsByAccountArgs = {
  competitionSlug?: InputMaybe<Scalars['String']>;
};


export type QueryArticleBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCompetitionsArgs = {
  created?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  modified?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryContentBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryContentsArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsByDescribeTagArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsByMacroTagArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsByMacroTagWithMetaArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsByMicroTagsArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsByMicroTagsWithMetaArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contentType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tagCategorySlugsDescribe?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagCategorySlugsTheme?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  themeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsByThemeTagArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsListObjectsArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContentsWithMetaArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  event?: InputMaybe<Scalars['String']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
};


export type QueryCourseSectionArgs = {
  id: Scalars['ID'];
};


export type QueryCurrentGamesArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCurrentGamesByUserArgs = {
  projectId?: InputMaybe<Scalars['ID']>;
};


export type QueryCurrentRoundArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCurrentSeasonArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type QueryDailyQuestionUserScoreArgs = {
  competitionSlug?: InputMaybe<Scalars['String']>;
};


export type QueryDepartmentBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryDepartmentDetailsArgs = {
  uuid: Scalars['UUID'];
};


export type QueryDivisionsAutocompleteArgs = {
  fullText?: InputMaybe<Scalars['Boolean']>;
  projectSlug: Scalars['String'];
  queryString: Scalars['String'];
};


export type QueryDocumentBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryDocumentGroupBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryEnrollmentByUuidArgs = {
  uuid: Scalars['String'];
};


export type QueryEventBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryEventBySlugNoChdArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryEventGroupActionArgs = {
  eventGroupSlug?: InputMaybe<Scalars['String']>;
};


export type QueryEventGroupBySlugArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryEventItemByIdArgs = {
  eventItemId?: InputMaybe<Scalars['ID']>;
};


export type QueryEventsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cityId?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  settlementId?: InputMaybe<Scalars['String']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  specialProjectSlug?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryEventsByMacroTagsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cityId?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  settlementId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  specialProjectSlug?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryEventsByMicroTagsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cityId?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  settlementId?: InputMaybe<Scalars['String']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  specialProjectSlug?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryEventsBySlugsArgs = {
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEventsWithMetaArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  alternativeAddressFilter?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  macroTag?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  settlementId?: InputMaybe<Scalars['String']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  specialProjectSlug?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  tagCategorySlugsDescribe?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagCategorySlugsTheme?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryExpoPushTokenArgs = {
  token: Scalars['String'];
};


export type QueryExpoPushTokenNotificationArgs = {
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  token: Scalars['String'];
};


export type QueryGameByIdArgs = {
  gameId?: InputMaybe<Scalars['ID']>;
};


export type QueryGamesArgs = {
  dateEnd?: InputMaybe<Scalars['DateTime']>;
  dateStart?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGovernmentsArgs = {
  created?: InputMaybe<Scalars['DateTime']>;
  governmentName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  modified?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryInvitationDataByTokenArgs = {
  token: Scalars['String'];
};


export type QueryInvitationTokenByInviterDataArgs = {
  inviterRole?: InputMaybe<InviterRoleChoices>;
  inviterUuid: Scalars['UUID'];
  projectId: Scalars['Int'];
};


export type QueryMainSliderArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryMaterialBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryMicroTagBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryNomineeBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryNomineesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryPageBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPageGroupBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryParticipantsArgs = {
  competitions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  created?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  modified?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type QueryPersonBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPodcastBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPollBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPostArgs = {
  id: Scalars['ID'];
};


export type QueryPostBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPostBySlugSpecialProjectsArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  slugSpecialProject?: InputMaybe<Scalars['String']>;
};


export type QueryPostsWithMetaArgs = {
  id?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAt_Gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_Lt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  specialProject_Slug?: InputMaybe<Scalars['String']>;
};


export type QueryPostsWithRelayArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_Gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_Lt?: InputMaybe<Scalars['DateTime']>;
  published_Icontains?: InputMaybe<Scalars['Boolean']>;
  published_Istartswith?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProcurementsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryRandomArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryScorePersonalArgs = {
  gameId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryScoreTeamArgs = {
  gameId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  regionalStage?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchArgs = {
  fuzziness?: InputMaybe<Scalars['String']>;
  matchType?: InputMaybe<MatchType>;
  outputType?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  weights?: InputMaybe<Scalars['String']>;
};


export type QuerySearchSchoolEnrollmentArgs = {
  address?: InputMaybe<Scalars['ID']>;
  allSchools?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  regionFias?: InputMaybe<Scalars['String']>;
  schoolMask?: InputMaybe<Scalars['String']>;
  schoolName?: InputMaybe<Scalars['String']>;
  schoolPhone?: InputMaybe<Scalars['String']>;
  schoolUrl?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type QuerySearchSchoolEnrollmentScientistVisitsArgs = {
  regionFias?: InputMaybe<Scalars['String']>;
};


export type QuerySearchUniversitiesArgs = {
  address?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QuerySeasonBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QuerySeasonsLeagueOfLecturersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySpeakerByIdArgs = {
  speakerId: Scalars['ID'];
};


export type QuerySpeakersArgs = {
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  leagueOfLecturersWinner?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<Scalars['ID']>;
  showOnMainPage?: InputMaybe<Scalars['Boolean']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QuerySpeakersByThemeTagArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QuerySpeakersWithMetaArgs = {
  id?: InputMaybe<Scalars['Float']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  season?: InputMaybe<Scalars['ID']>;
  user_Position?: InputMaybe<Scalars['String']>;
};


export type QuerySpecialProjectsArgs = {
  header?: InputMaybe<Scalars['Boolean']>;
  isShownInFilter?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySuggestAddressArgs = {
  dnr?: InputMaybe<Scalars['Boolean']>;
  fromBound?: InputMaybe<Scalars['String']>;
  lnr?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  toBound?: InputMaybe<Scalars['String']>;
};


export type QuerySuggestCityArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTagCategoriesByMicroTagArgs = {
  slug?: InputMaybe<Scalars['String']>;
  typeTagCategory: Scalars['String'];
};


export type QueryTagCategoryArgs = {
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBlankedTags?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyWithContent?: InputMaybe<Scalars['Boolean']>;
  randomize?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTagCategoryBySlugArgs = {
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBlankedTags?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryTagCompilationArgs = {
  id: Scalars['ID'];
};


export type QueryTagCompilationBySlugArgs = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  countFavorites?: InputMaybe<Scalars['Int']>;
  countLikes?: InputMaybe<Scalars['Int']>;
  countView?: InputMaybe<Scalars['Int']>;
  cover?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  event?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isClosedByRegistration?: InputMaybe<Scalars['Boolean']>;
  isRecommendedByUs?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  manualScore?: InputMaybe<Scalars['Int']>;
  modified?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  podcast?: InputMaybe<Scalars['String']>;
  podcastLength?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slugTag?: InputMaybe<Scalars['String']>;
  speakers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  specialProject?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  themeTags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeTag?: InputMaybe<Scalars['String']>;
  videoLength?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};


export type QueryTagCompilationBySlugListObjectArgs = {
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Float']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slugTag: Scalars['String'];
  slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  typeTag?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTagCompilationBySlugWithMetaArgs = {
  cover?: InputMaybe<Scalars['String']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  document?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Scalars['String']>;
  podcast?: InputMaybe<Scalars['String']>;
  slugTag?: InputMaybe<Scalars['String']>;
  typeTag?: InputMaybe<Scalars['String']>;
};


export type QueryTagCompilationsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  automatic?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  randomize?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryTagCompilationsWithMetaArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  automatic?: InputMaybe<Scalars['Boolean']>;
  contentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Scalars['String']>;
  randomize?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryTagCompilationsWithRelayArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  automatic?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  randomize?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags_Slug?: InputMaybe<Scalars['String']>;
  tags_Slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryThemeTagCategoriesOfEventGroupArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  slug: Scalars['String'];
};


export type QueryTotalAnweredUsersArgs = {
  competitionSlug?: InputMaybe<Scalars['String']>;
};


export type QueryVideoBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};

export type QuestionCategoryType = {
  __typename?: 'QuestionCategoryType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  questionsByCategory?: Maybe<Array<UserQuestionType>>;
};

export type QuestionInput = {
  question: Scalars['String'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  allowMultiply?: Maybe<Scalars['Boolean']>;
  body?: Maybe<Scalars['String']>;
  choices?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['ID']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  otherInput?: Maybe<Scalars['Boolean']>;
  textType?: Maybe<Scalars['String']>;
  textarea?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type QuizRatingType = {
  __typename?: 'QuizRatingType';
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** Игра */
  game?: Maybe<GameType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** ID */
  idQuiz?: Maybe<Scalars['Int']>;
  /** Место */
  place?: Maybe<Scalars['Int']>;
  /** Пятый раунд */
  roundFive?: Maybe<Scalars['Int']>;
  /** Четвертый раунд */
  roundFour?: Maybe<Scalars['Int']>;
  /** Первый раунд */
  roundOne?: Maybe<Scalars['Int']>;
  /** Седьмой раунд */
  roundSeven?: Maybe<Scalars['Int']>;
  /** Шестой раунд */
  roundSix?: Maybe<Scalars['Int']>;
  /** Третий раунд */
  roundThree?: Maybe<Scalars['Int']>;
  /** Второй раунд */
  roundTwo?: Maybe<Scalars['Int']>;
  /** Название команды */
  teamName?: Maybe<Scalars['String']>;
  /** Время */
  time?: Maybe<Scalars['String']>;
  /** Итого */
  total?: Maybe<Scalars['Int']>;
};

export type RatingInput = {
  comment?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  slug: Scalars['String'];
};

export type RatingType = {
  __typename?: 'RatingType';
  divisionCount?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  memberCount?: Maybe<Scalars['Int']>;
  representative?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type RatingsType = {
  __typename?: 'RatingsType';
  avatar?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  games?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type Refresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export type RegionType = {
  __typename?: 'RegionType';
  /** country */
  country?: Maybe<Scalars['String']>;
  /** country iso code */
  countryIsoCode?: Maybe<Scalars['String']>;
  event?: Maybe<Array<EventType>>;
  /** federal district */
  federalDistrict?: Maybe<Scalars['String']>;
  /** fias id */
  fiasId?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** iso code */
  isoCode?: Maybe<Scalars['String']>;
  /** kladr id */
  kladrId?: Maybe<Scalars['String']>;
  /** name */
  name?: Maybe<Scalars['String']>;
  /** region number */
  regionNumber?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<Scalars['String']>;
  /** type full */
  typeFull?: Maybe<Scalars['String']>;
};

export type RegisterActionDivisionMutation = {
  __typename?: 'RegisterActionDivisionMutation';
  isAddressCreated?: Maybe<Scalars['Boolean']>;
  isDivisionCreated?: Maybe<Scalars['Boolean']>;
  isEventCreated?: Maybe<Scalars['Boolean']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
  isVenueCreated?: Maybe<Scalars['Boolean']>;
  resultMessage?: Maybe<Scalars['String']>;
};

export type RegisterDivisionInput = {
  address: Scalars['String'];
  agreement?: InputMaybe<Scalars['String']>;
  confirmation?: InputMaybe<Scalars['Boolean']>;
  decree?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  personalEmail?: InputMaybe<Scalars['String']>;
  personalPhone?: InputMaybe<Scalars['String']>;
  projectSlug: Scalars['String'];
  registerBlank?: InputMaybe<Scalars['Boolean']>;
  representative?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  typeId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  vkUrl?: InputMaybe<Scalars['String']>;
};

export type RegisterDivisionMutation = {
  __typename?: 'RegisterDivisionMutation';
  divisionTitle?: Maybe<Scalars['String']>;
  divisionUuid?: Maybe<Scalars['UUID']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type RegisterMemberInput = {
  address?: InputMaybe<Scalars['String']>;
  classLetter?: InputMaybe<Scalars['String']>;
  classNumber?: InputMaybe<Scalars['Int']>;
  confirmation?: InputMaybe<Scalars['Boolean']>;
  divisionUuid: Scalars['UUID'];
  icon?: InputMaybe<Scalars['String']>;
  programme?: InputMaybe<PreparationChoices>;
  projectSlug: Scalars['String'];
  speciality?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type RegisterMemberMutation = {
  __typename?: 'RegisterMemberMutation';
  isSuccess?: Maybe<Scalars['Boolean']>;
  memberUuid?: Maybe<Scalars['UUID']>;
};

export type RegisterParticipationInput = {
  address?: InputMaybe<Scalars['String']>;
  agreement?: InputMaybe<Scalars['String']>;
  classLetter?: InputMaybe<Scalars['String']>;
  classNumber?: InputMaybe<Scalars['Int']>;
  confirmation?: InputMaybe<Scalars['Boolean']>;
  decree?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  personalEmail?: InputMaybe<Scalars['String']>;
  personalPhone?: InputMaybe<Scalars['String']>;
  programme?: InputMaybe<PreparationChoices>;
  representative?: InputMaybe<Scalars['String']>;
  speciality?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  typeId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  vkUrl?: InputMaybe<Scalars['String']>;
};

export type RegisterParticipationMutation = {
  __typename?: 'RegisterParticipationMutation';
  accountRole?: Maybe<Scalars['String']>;
  accountUuid?: Maybe<Scalars['UUID']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type RegisterUserMutation = {
  __typename?: 'RegisterUserMutation';
  user?: Maybe<UserType>;
};

export type ResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  user?: Maybe<UserType>;
};

export type ResetPasswordTokenMutation = {
  __typename?: 'ResetPasswordTokenMutation';
  user?: Maybe<UserType>;
};

export type Revoke = {
  __typename?: 'Revoke';
  revoked: Scalars['Int'];
};

export type RoundType = {
  __typename?: 'RoundType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['CustomDateTime']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['CustomDateTime']>;
  games?: Maybe<Array<Maybe<GameType>>>;
  gamesByRound?: Maybe<Array<GameType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  ratings?: Maybe<Array<Maybe<RatingsType>>>;
  /** Сезон */
  season?: Maybe<LeagueOfLecturersSeasonType>;
  semiFinals?: Maybe<Array<SemiFinalsType>>;
  semifinals?: Maybe<Array<Maybe<SemiFinalsType>>>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type ScanInput = {
  expire: Scalars['Date'];
  file: Scalars['String'];
  title: Scalars['String'];
};

export type ScanMutation = {
  __typename?: 'ScanMutation';
  user?: Maybe<UserType>;
};

export type ScanUniversityInput = {
  fileCharter?: InputMaybe<Scalars['String']>;
  fileLettersOfHonor?: InputMaybe<Scalars['String']>;
  professionalDevelopment?: InputMaybe<Scalars['String']>;
  publishedAt: Scalars['Date'];
  regalia?: InputMaybe<Scalars['String']>;
  university: Scalars['String'];
};

export type ScanUniversityMutation = {
  __typename?: 'ScanUniversityMutation';
  user?: Maybe<UserType>;
};

export type SchoolCreateInput = {
  address: Scalars['String'];
  schoolMask: Scalars['String'];
  schoolName: Scalars['String'];
  schoolPhone: Scalars['String'];
};

export type SchoolCreateMutation = {
  __typename?: 'SchoolCreateMutation';
  school?: Maybe<SchoolType>;
};

export type SchoolScientistCreateMutation = {
  __typename?: 'SchoolScientistCreateMutation';
  schoolScientist?: Maybe<SchoolScientistType>;
};

export enum SchoolScientistEnrollmentStatusEnum {
  /** Принята */
  Accepted = 'ACCEPTED',
  /** Новая */
  New = 'NEW',
  /** Отклонена */
  Rejected = 'REJECTED',
  /** На рассмотрении */
  UnderConsideration = 'UNDER_CONSIDERATION'
}

export type SchoolScientistType = {
  __typename?: 'SchoolScientistType';
  hasReport?: Maybe<Scalars['Boolean']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  poll?: Maybe<PollType>;
  /** Статус заявки ученого */
  status?: Maybe<SchoolScientistEnrollmentStatusEnum>;
  user?: Maybe<UserType>;
};

export type SchoolScientistUpdateInput = {
  reportUrl?: InputMaybe<Scalars['String']>;
  scientistEnrollmentStatus: Scalars['String'];
};

export type SchoolScientistUpdateMutation = {
  __typename?: 'SchoolScientistUpdateMutation';
  schoolScientist?: Maybe<SchoolScientistType>;
};

export type SchoolScientistVisitCreateMutation = {
  __typename?: 'SchoolScientistVisitCreateMutation';
  scientistVisit?: Maybe<ScientistVisitType>;
};

export type SchoolScientistVisitDeleteMutation = {
  __typename?: 'SchoolScientistVisitDeleteMutation';
  deleteStatus?: Maybe<Scalars['Boolean']>;
};

export type SchoolScientistVisitInput = {
  dateVisiting: Scalars['Date'];
  schoolId: Scalars['Int'];
};

export type SchoolType = {
  __typename?: 'SchoolType';
  address?: Maybe<AddressType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** маска с символом "+" и скобками */
  schoolMask?: Maybe<Scalars['String']>;
  /** Наименование школы */
  schoolName?: Maybe<Scalars['String']>;
  /** Пример - 9002002525 */
  schoolPhone?: Maybe<Scalars['String']>;
  schoolPhoneWithMask?: Maybe<Scalars['String']>;
  /** Ссылка на отчёт о выступлении */
  schoolUrl?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
  visitsSchoolScientist?: Maybe<Array<ScientistVisitType>>;
};

export type SchoolUpdateInput = {
  schoolUrl: Scalars['String'];
};

export type SchoolUpdateMutation = {
  __typename?: 'SchoolUpdateMutation';
  school?: Maybe<SchoolType>;
};

export type ScientistVisitType = {
  __typename?: 'ScientistVisitType';
  /** Дата посещения школы */
  dateVisiting?: Maybe<Scalars['CustomDate']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  school?: Maybe<SchoolType>;
  schoolScientistEnrollment?: Maybe<SchoolScientistType>;
};

export type SearchType = {
  __typename?: 'SearchType';
  compilations?: Maybe<Array<Maybe<CompilationType>>>;
  content?: Maybe<Array<Maybe<ContentType>>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  news?: Maybe<Array<Maybe<PostType>>>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
};

export type SeasonType = {
  __typename?: 'SeasonType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['CustomDateTime']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  ratings?: Maybe<Array<Maybe<RatingsType>>>;
  rounds?: Maybe<Array<Maybe<RoundType>>>;
  roundsBySeason?: Maybe<Array<RoundType>>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
};

export type SemiFinalsType = {
  __typename?: 'SemiFinalsType';
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Тур */
  round?: Maybe<RoundType>;
  /** Название команды */
  teamName?: Maybe<Scalars['String']>;
};

export type SimilarContentType = {
  __typename?: 'SimilarContentType';
  /** Тело статьи */
  body?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  contentFavoriteByUsername?: Maybe<Scalars['Boolean']>;
  contentFavorites?: Maybe<Array<FavoritesType>>;
  contentLikeByUsername?: Maybe<Scalars['Boolean']>;
  contentLikes?: Maybe<Array<LikesType>>;
  countFavorites?: Maybe<Scalars['Int']>;
  countLikes?: Maybe<Scalars['Int']>;
  countView?: Maybe<Scalars['Int']>;
  /** Обложка */
  cover?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  describeTags?: Maybe<Array<Maybe<TagType>>>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** PDF/Презентация/Документ */
  document?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  /** Длительность в минутах */
  duration?: Maybe<Scalars['Int']>;
  /** event */
  event?: Maybe<EventType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isClosedByRegistration?: Maybe<Scalars['Boolean']>;
  isRecommendedByUs?: Maybe<Scalars['Boolean']>;
  mainPage?: Maybe<Scalars['Boolean']>;
  /** Ручной скоринг */
  manualScore?: Maybe<Scalars['Int']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  podcast?: Maybe<Scalars['String']>;
  /** Длина подкаста */
  podcastLength?: Maybe<Scalars['String']>;
  promoted?: Maybe<Scalars['Boolean']>;
  ratingByContent?: Maybe<Array<NpsType>>;
  searchScore?: Maybe<Scalars['Float']>;
  similarContentByAuthor?: Maybe<Array<Maybe<SimilarContentType>>>;
  similarContentByTags?: Maybe<Array<Maybe<SimilarContentType>>>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Спец проекты */
  specialProject?: Maybe<Array<SpecialProjectType>>;
  tagscompilation?: Maybe<Array<Maybe<TagsCompilationType>>>;
  tagscompilations?: Maybe<Array<CompilationType>>;
  themeTags?: Maybe<Array<Maybe<TagType>>>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<ContentTypeEnum>;
  /** Длина видео */
  videoLength?: Maybe<Scalars['String']>;
  /** Ссылка на видео */
  videoUrl?: Maybe<Scalars['String']>;
};


export type SimilarContentTypeSimilarContentByAuthorArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SimilarContentTypeSimilarContentByTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SpeakerAlphabet = {
  __typename?: 'SpeakerAlphabet';
  count?: Maybe<Scalars['Int']>;
  letter?: Maybe<Scalars['String']>;
};

export enum SpeakerFromComeEnum {
  /** Вручную */
  ByHand = 'BY_HAND',
  /** Лига Лекторов */
  League = 'LEAGUE',
  /** Партнеры */
  Partners = 'PARTNERS',
  /** Акция */
  Promotion = 'PROMOTION',
  /** Протокол */
  Protocol = 'PROTOCOL',
  /** Сайт */
  Site = 'SITE'
}

export type SpeakerLeaveDivisionInput = {
  eventItemId: Scalars['Int'];
};

export type SpeakerRegistrationToDivisionInput = {
  divisionId: Scalars['Int'];
  presentationUrl?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  speechDateFinish: Scalars['DateTime'];
  speechDateStart: Scalars['DateTime'];
  speechTheme: Scalars['String'];
};

export type SpeakerReportToDivisionInput = {
  eventItemId: Scalars['Int'];
  reportLink: Scalars['String'];
};

export type SpeakerRequestInput = {
  activity?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  comments?: InputMaybe<Scalars['String']>;
  enrollToLeagueOfLecturers?: InputMaybe<Scalars['Boolean']>;
  eventGroupSlug?: InputMaybe<Scalars['String']>;
  fileCharter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileLettersOfHonor?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  officialPhoto?: InputMaybe<Scalars['String']>;
  performanceUrl?: InputMaybe<Scalars['String']>;
  professionalDevelopment?: InputMaybe<Scalars['String']>;
  regalia?: InputMaybe<Scalars['String']>;
  university?: InputMaybe<Scalars['String']>;
};

export type SpeakerRequestMutation = {
  __typename?: 'SpeakerRequestMutation';
  speakerRequest?: Maybe<SpeakerRequestType>;
};

export enum SpeakerRequestStatusEnum {
  /** approved */
  Approved = 'APPROVED',
  /** declined */
  Declined = 'DECLINED',
  /** inprogress */
  Inprogress = 'INPROGRESS',
  /** pending */
  Pending = 'PENDING'
}

export type SpeakerRequestType = {
  __typename?: 'SpeakerRequestType';
  /** Сфера деятельности */
  activity?: Maybe<Scalars['String']>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['CustomDate']>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  /** Город проживания */
  city?: Maybe<Scalars['String']>;
  /** Комментарии/Темы выступления */
  comments?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Комментарий в случае отклонения заявки. */
  denialComment?: Maybe<Scalars['String']>;
  /** Дата отклонения */
  denialDate?: Maybe<Scalars['CustomDate']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** facebook account */
  facebookAccount?: Maybe<Scalars['String']>;
  /** Имя */
  firstName?: Maybe<Scalars['String']>;
  /** Групповое мероприятие Акции */
  groupEvent?: Maybe<EventGroupType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** instagram account */
  instagramAccount?: Maybe<Scalars['String']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['String']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Фотография в деловом стиле */
  officialPhoto?: Maybe<Scalars['String']>;
  /** Ссылка на пример выступления */
  performanceUrl?: Maybe<Scalars['String']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']>;
  /** Должность */
  position?: Maybe<Scalars['String']>;
  /** Повышение квалификации */
  professionalDevelopment?: Maybe<Scalars['String']>;
  /** Доп. регалии */
  regalia?: Maybe<Scalars['String']>;
  /** Спикер и его заявка */
  speakerRequestDocuments?: Maybe<SpeakerType>;
  /** Статус заявки */
  status?: Maybe<SpeakerRequestStatusEnum>;
  /** telegram account */
  telegramAccount?: Maybe<Scalars['String']>;
  /** Для ручного ввода университета */
  university?: Maybe<Scalars['String']>;
  /** user */
  user?: Maybe<UserType>;
  /** vk account */
  vkAccount?: Maybe<Scalars['String']>;
  /** Место работы */
  workPlace?: Maybe<Scalars['String']>;
  /** youtube account */
  youtubeAccount?: Maybe<Scalars['String']>;
};

export enum SpeakerStatusEnum {
  /** Отказ */
  Decline = 'DECLINE',
  /** Переговоры */
  Discussion = 'DISCUSSION',
  /** Ранее выступали */
  PreviouslyPerformed = 'PREVIOUSLY_PERFORMED',
  /** Первичный контакт */
  PrimaryContact = 'PRIMARY_CONTACT'
}

export enum SpeakerStatusSbEnum {
  /** одобрен */
  Approved = 'APPROVED',
  /** отклонен */
  Declined = 'DECLINED'
}

export enum SpeakerTierEnum {
  /** Тир 1 */
  Tier_1 = 'TIER_1',
  /** Тир 2 */
  Tier_2 = 'TIER_2',
  /** Тир 3 */
  Tier_3 = 'TIER_3',
  /** Тир 4 */
  Tier_4 = 'TIER_4',
  /** Без тира */
  WithoutTier = 'WITHOUT_TIER'
}

export type SpeakerType = {
  __typename?: 'SpeakerType';
  /** Поле требуется для проверки службой безопасности, может содержать псевдоним/сценическое имя/никнейм (может отличаться от ФИО) */
  alias?: Maybe<Scalars['String']>;
  /** Другие тематики */
  anotherCategory?: Maybe<Array<CategoryType>>;
  /** Другой телефон */
  anotherPhone?: Maybe<Scalars['String']>;
  /** Фото в высоком разрешении */
  bigPhoto?: Maybe<Scalars['String']>;
  bigPhotoUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  /** Основные тематики */
  category?: Maybe<Array<CategoryType>>;
  /** Адрес компании */
  companyAddress?: Maybe<Scalars['String']>;
  /** Web-адрес сайта компании */
  companyUrl?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Maybe<ContentType>>>;
  contentSpeakers?: Maybe<Array<ContentFilterType>>;
  created?: Maybe<Scalars['String']>;
  /** Регалии */
  description?: Maybe<Scalars['String']>;
  directionOfActivity?: Maybe<Array<Maybe<TagCategoryType>>>;
  eventGroupsByHeadliner?: Maybe<Array<EventGroupType>>;
  eventitem?: Maybe<Array<EventItemType>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  facebookAccount?: Maybe<Scalars['String']>;
  /** Гонорар в рублях */
  fee?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  /** Имя (Eng) */
  firstNameEn?: Maybe<Scalars['String']>;
  /** Откуда пришел */
  fromCome?: Maybe<SpeakerFromComeEnum>;
  headlinersByEvent?: Maybe<Array<EventType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  instagramAccount?: Maybe<Scalars['String']>;
  /** Дата вступления в РОЗ */
  joinedDate?: Maybe<Scalars['CustomDateTime']>;
  lastName?: Maybe<Scalars['String']>;
  /** Фамилия (Eng) */
  lastNameEn?: Maybe<Scalars['String']>;
  leagueOfLecturersWinner?: Maybe<Scalars['Boolean']>;
  /** Ссылка на выступление */
  linkToSpeech?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Nominee list */
  nominee?: Maybe<Array<Maybe<NomineeType>>>;
  /** Фото */
  photo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  /** Опрос */
  poll?: Maybe<PollType>;
  pollGeneric?: Maybe<Array<PollType>>;
  /** Анкета */
  questionnaire?: Maybe<Scalars['String']>;
  /** Ответственный */
  responsibleUser?: Maybe<UserType>;
  rozMember?: Maybe<Scalars['Boolean']>;
  searchScore?: Maybe<Scalars['Float']>;
  /** сезон */
  season?: Maybe<LeagueOfLecturersSeasonType>;
  showInLibrary?: Maybe<Scalars['Boolean']>;
  showOnMainPage?: Maybe<Scalars['Boolean']>;
  speakerBySpeakerRequest?: Maybe<SpeakerRequestType>;
  /** Статус спикера */
  status?: Maybe<SpeakerStatusEnum>;
  /** Статус СБ */
  statusSb?: Maybe<SpeakerStatusSbEnum>;
  tags?: Maybe<Array<Maybe<TagCategoryType>>>;
  telegramAccount?: Maybe<Scalars['String']>;
  themeTags?: Maybe<Array<Maybe<TagType>>>;
  /** Тир */
  tier?: Maybe<SpeakerTierEnum>;
  title?: Maybe<Scalars['String']>;
  /** Должность (Eng) */
  titleEn?: Maybe<Scalars['String']>;
  /** twitter_account (old) */
  twitterAccount?: Maybe<Scalars['String']>;
  /** Для ручного ввода университета */
  university?: Maybe<Scalars['String']>;
  /** Пользователь */
  user?: Maybe<UserType>;
  vkAccount?: Maybe<Scalars['String']>;
};


export type SpeakerTypeNomineeArgs = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type SpeakerTypeWithMeta = {
  __typename?: 'SpeakerTypeWithMeta';
  bigPhotoUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  content?: Maybe<Array<Maybe<ContentType>>>;
  created?: Maybe<Scalars['String']>;
  directionOfActivity?: Maybe<Array<Maybe<TagCategoryType>>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  facebookAccount?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  instagramAccount?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  /** Speaker list, paginated by LimitOffsetPaginator */
  results?: Maybe<Array<Maybe<SpeakerType>>>;
  tags?: Maybe<Array<Maybe<TagCategoryType>>>;
  telegramAccount?: Maybe<Scalars['String']>;
  themeTags?: Maybe<Array<Maybe<TagType>>>;
  title?: Maybe<Scalars['String']>;
  /** Total count of matches elements */
  totalCount?: Maybe<Scalars['Int']>;
  vkAccount?: Maybe<Scalars['String']>;
};


export type SpeakerTypeWithMetaResultsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
};

export type SpecialProjectType = {
  __typename?: 'SpecialProjectType';
  active?: Maybe<Scalars['Boolean']>;
  contentByProject?: Maybe<Array<ContentFilterType>>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** При отсутствии почты заполнять: support@znanierussia.ru */
  emailSpecialProject?: Maybe<Scalars['String']>;
  eventsByProject?: Maybe<Array<EventType>>;
  header?: Maybe<Scalars['Boolean']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  isShownInFilter?: Maybe<Scalars['Boolean']>;
  lkProject?: Maybe<ProjectType>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Post list */
  newsByProject?: Maybe<Array<Maybe<PostType>>>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  photo?: Maybe<Scalars['String']>;
  /** ссылка на спец проект */
  projectUrl?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  smallPhoto?: Maybe<Scalars['String']>;
  /** Статус */
  status?: Maybe<Scalars['String']>;
};


export type SpecialProjectTypeNewsByProjectArgs = {
  id?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
};

export type SpeechDetailsType = {
  __typename?: 'SpeechDetailsType';
  eventItemId?: Maybe<Scalars['Int']>;
  presentationUrl?: Maybe<Scalars['String']>;
  reportUrl?: Maybe<Scalars['String']>;
  speechDateFinish?: Maybe<Scalars['DateTime']>;
  speechDateStart?: Maybe<Scalars['DateTime']>;
  speechTheme?: Maybe<Scalars['String']>;
};

export type StatisticType = {
  __typename?: 'StatisticType';
  classes?: Maybe<Scalars['JSONString']>;
  departments?: Maybe<Scalars['Int']>;
  divisions?: Maybe<Scalars['Int']>;
  members?: Maybe<Scalars['Int']>;
  municipalities?: Maybe<Array<Maybe<RatingType>>>;
  municipality?: Maybe<Scalars['Int']>;
  regions?: Maybe<Array<Maybe<RatingType>>>;
  schools?: Maybe<Array<Maybe<RatingType>>>;
};

export type StatisticsType = {
  __typename?: 'StatisticsType';
  numberOfEventParticipants?: Maybe<Scalars['Int']>;
  numberOfEvents?: Maybe<Scalars['Int']>;
  numberOfSpeakers?: Maybe<Scalars['Int']>;
};

export type TagCategoriesByMicroTagType = {
  __typename?: 'TagCategoriesByMicroTagType';
  tagCategories?: Maybe<Array<Maybe<TagCategoryByMicroTagType>>>;
};

export type TagCategoryByMicroTagType = {
  __typename?: 'TagCategoryByMicroTagType';
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type TagCategoryNode = Node & {
  __typename?: 'TagCategoryNode';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  h1?: Maybe<Scalars['String']>;
  hover?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  order: Scalars['Int'];
  pk?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  temporary: Scalars['Boolean'];
  type: CategoryTagCategoryTypeChoices;
};

export type TagCategoryNodeConnection = {
  __typename?: 'TagCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TagCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TagCategoryNode` and its cursor. */
export type TagCategoryNodeEdge = {
  __typename?: 'TagCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TagCategoryNode>;
};

export type TagCategoryType = {
  __typename?: 'TagCategoryType';
  active?: Maybe<Scalars['Boolean']>;
  /** Content list */
  contents?: Maybe<Array<ContentType>>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  eventItemsByThemeTagCategory?: Maybe<Array<EventItemType>>;
  /** Заголовок H1 */
  h1?: Maybe<Scalars['String']>;
  hover?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  maxContents?: Maybe<Scalars['Int']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  /** SEO описание */
  seoDescription?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  speaker?: Maybe<Array<SpeakerType>>;
  tags?: Maybe<Array<Maybe<TagType>>>;
  tagsByCategory?: Maybe<Array<TagType>>;
  temporary?: Maybe<Scalars['Boolean']>;
  /** Тип */
  type?: Maybe<TagCategoryTypeEnum>;
};


export type TagCategoryTypeContentsArgs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  event?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum TagCategoryTypeEnum {
  /** формат */
  Describe = 'DESCRIBE',
  /** тема */
  Theme = 'THEME'
}

export type TagCompilationBySlagWithMetaType = {
  __typename?: 'TagCompilationBySlagWithMetaType';
  countTagsCompilationBySlug?: Maybe<Scalars['Int']>;
  tagCompilationBySlug?: Maybe<Array<Maybe<ContentType>>>;
};


export type TagCompilationBySlagWithMetaTypeTagCompilationBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type TagCompilationBySlugListType = {
  __typename?: 'TagCompilationBySlugListType';
  coverUrl?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  /** Content list, paginated by LimitOffsetPaginator */
  tagCompilationBySlug?: Maybe<Array<Maybe<ContentType>>>;
  /** Total count of matches elements */
  totalCount?: Maybe<Scalars['Int']>;
};


export type TagCompilationBySlugListTypeTagCompilationBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Scalars['String']>;
};

export type TagCompilationsWithRelayNode = Node & {
  __typename?: 'TagCompilationsWithRelayNode';
  active: Scalars['Boolean'];
  automatic: Scalars['Boolean'];
  contentTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  contents?: Maybe<ContenWithtRelayNodeConnection>;
  created: Scalars['DateTime'];
  h1?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isClosedByRegistration?: Maybe<Scalars['Boolean']>;
  likesSort: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  newSort: Scalars['Boolean'];
  pk?: Maybe<Scalars['Int']>;
  randomImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  seoDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  subsidiary?: Maybe<TagCompilationsWithRelayNodeConnection>;
  subsidiaryCollections: TagCompilationsWithRelayNodeConnection;
  viewsSort: Scalars['Boolean'];
};


export type TagCompilationsWithRelayNodeContentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  describeTags_Slug?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  event?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Float']>;
  isClosedByRegistration?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  manualScore?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  podcastLength?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  themeTags_Slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  videoLength?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};


export type TagCompilationsWithRelayNodeSubsidiaryArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  automatic?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags_Slug?: InputMaybe<Scalars['String']>;
  tags_Slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TagCompilationsWithRelayNodeSubsidiaryCollectionsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  automatic?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags_Slug?: InputMaybe<Scalars['String']>;
  tags_Slug_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TagCompilationsWithRelayNodeConnection = {
  __typename?: 'TagCompilationsWithRelayNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TagCompilationsWithRelayNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TagCompilationsWithRelayNode` and its cursor. */
export type TagCompilationsWithRelayNodeEdge = {
  __typename?: 'TagCompilationsWithRelayNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TagCompilationsWithRelayNode>;
};

export type TagType = {
  __typename?: 'TagType';
  contentByDescribeTag?: Maybe<Array<ContentFilterType>>;
  contentByThemeTag?: Maybe<Array<ContentFilterType>>;
  cover?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  eventsByDescribeTag?: Maybe<Array<EventType>>;
  eventsByThemeTag?: Maybe<Array<EventType>>;
  /** Заголовок H1 */
  h1?: Maybe<Scalars['String']>;
  hover?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  maxContents?: Maybe<Scalars['Int']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** SEO описание */
  seoDescription?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  speakerByThemeTag?: Maybe<Array<SpeakerType>>;
  /** Макротег */
  tagCategory?: Maybe<TagCategoryType>;
  tagsByCompilation?: Maybe<Array<CompilationType>>;
  temporary?: Maybe<Scalars['Boolean']>;
};

export type TagsCompilationType = {
  __typename?: 'TagsCompilationType';
  contentTypes?: Maybe<Array<Maybe<ContentFilterType>>>;
  /** Заголовок H1 */
  h1?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  isClosedByRegistration?: Maybe<Scalars['Boolean']>;
  /** Название подборки */
  name?: Maybe<Scalars['String']>;
  randomImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** SEO описание */
  seoDescription?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  subsidiary?: Maybe<Array<Maybe<TagsCompilationType>>>;
};

export type TagsCompilationWithMetaType = {
  __typename?: 'TagsCompilationWithMetaType';
  countTagsCompilations?: Maybe<Scalars['Int']>;
  tagCompilations?: Maybe<Array<Maybe<TagsCompilationType>>>;
};


export type TagsCompilationWithMetaTypeTagCompilationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type TeamType = {
  __typename?: 'TeamType';
  accountMembers?: Maybe<Array<Maybe<UserType>>>;
  /** Аватар команды */
  avatar?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  capitan?: Maybe<UserType>;
  /** Город команды */
  city?: Maybe<Scalars['String']>;
  /** Откуда узнали о нас? */
  comment?: Maybe<Scalars['String']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  enrollmentByTeam?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  enrollments?: Maybe<Array<Maybe<EnrollmentType>>>;
  firstGame?: Maybe<Scalars['Boolean']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Количество игроков */
  members?: Maybe<Scalars['Int']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  name?: Maybe<Scalars['String']>;
  regionalStage?: Maybe<Scalars['Boolean']>;
};

export type TelegramUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  tgUserId: Scalars['Int'];
  username?: InputMaybe<Scalars['String']>;
};

export type TelegramUserType = {
  __typename?: 'TelegramUserType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** first name */
  firstName?: Maybe<Scalars['String']>;
  /** hash */
  hash?: Maybe<Scalars['String']>;
  /** last name */
  lastName?: Maybe<Scalars['String']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** photo url */
  photoUrl?: Maybe<Scalars['String']>;
  /** tg user id */
  tgUserId?: Maybe<Scalars['Int']>;
  /** пользователь roz */
  user?: Maybe<UserType>;
  /** username */
  username?: Maybe<Scalars['String']>;
};

export type TokenAuthMutation = {
  __typename?: 'TokenAuthMutation';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export type TopicType = {
  __typename?: 'TopicType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type TotalAnweredUsersType = {
  __typename?: 'TotalAnweredUsersType';
  count?: Maybe<Scalars['Int']>;
};

export type TranslationItemType = {
  __typename?: 'TranslationItemType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
  /** Время окончания */
  finishTime?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Время начала */
  startTime?: Maybe<Scalars['CustomDateTime']>;
  /** Название трансляции */
  title?: Maybe<Scalars['String']>;
  /** url */
  url?: Maybe<Scalars['String']>;
};

export enum Type {
  Final = 'FINAL',
  Grandfinal = 'GRANDFINAL',
  Joker = 'JOKER',
  Qualifying = 'QUALIFYING',
  Semifinal = 'SEMIFINAL'
}

export type UniversitiesRealType = {
  __typename?: 'UniversitiesRealType';
  address?: Maybe<AddressType>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  universitiesByEvent?: Maybe<Array<EventType>>;
  user?: Maybe<Array<UserType>>;
};

export type UniversityType = {
  __typename?: 'UniversityType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Наименование университета */
  name?: Maybe<Scalars['String']>;
  universitiesByEvent?: Maybe<Array<EventType>>;
  /** @deprecated UniversitiesType will be move into universities app */
  universityAddress?: Maybe<Scalars['String']>;
  user?: Maybe<Array<UserType>>;
};

export type UpdateCapitanInput = {
  capitanId: Scalars['ID'];
  teamId: Scalars['ID'];
};

export type UpdateCapitanMutation = {
  __typename?: 'UpdateCapitanMutation';
  team?: Maybe<TeamType>;
};

export type UpdateDivisionAddressInput = {
  address: Scalars['String'];
  divisionId: Scalars['ID'];
};

export type UpdateDivisionAddressMutation = {
  __typename?: 'UpdateDivisionAddressMutation';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type UpdateLeagueInput = {
  agreementFile?: InputMaybe<Scalars['String']>;
  agreementFilePart2?: InputMaybe<Scalars['String']>;
  agreementFilePart3?: InputMaybe<Scalars['String']>;
  firstThemeOfSpeech?: InputMaybe<Scalars['String']>;
  fourthThemeOfSpeech?: InputMaybe<Scalars['String']>;
  lectureName?: InputMaybe<Scalars['String']>;
  lectureShortDescription?: InputMaybe<Scalars['String']>;
  lectureVideo?: InputMaybe<Scalars['String']>;
  performanceTheme?: InputMaybe<Scalars['String']>;
  secondThemeOfSpeech?: InputMaybe<Scalars['String']>;
  thirdThemeOfSpeech?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
  videocard?: InputMaybe<Scalars['String']>;
};

export type UpdateLeagueMutation = {
  __typename?: 'UpdateLeagueMutation';
  user?: Maybe<UserType>;
};

export type UpdateMemberTicketInput = {
  discountCard?: InputMaybe<Scalars['String']>;
  discountCardFile?: InputMaybe<Scalars['String']>;
  educationalExperience?: InputMaybe<Scalars['String']>;
};

export type UpdateMemberTicketMutation = {
  __typename?: 'UpdateMemberTicketMutation';
  memberTicket?: Maybe<MemberTicketType>;
};

export type UpdateQuizRegistrationMutation = {
  __typename?: 'UpdateQuizRegistrationMutation';
  user?: Maybe<UserType>;
};

export type UpdateSpeakerRegistrationToDivisionInput = {
  eventItemId: Scalars['Int'];
  newSpeechDateFinish: Scalars['DateTime'];
  newSpeechDateStart: Scalars['DateTime'];
  newSpeechTheme: Scalars['String'];
  presentationUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateSpeakerRegistrationToDivisionMutation = {
  __typename?: 'UpdateSpeakerRegistrationToDivisionMutation';
  result?: Maybe<Scalars['String']>;
  speechList?: Maybe<Array<Maybe<SpeechDetailsType>>>;
};

export type UpdateUserInput = {
  academicDegree?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressInput>;
  addressDetail?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['Date']>;
  birthPlace?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebookAccount?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  governmentId?: InputMaybe<Scalars['ID']>;
  graduationYear?: InputMaybe<Scalars['String']>;
  instagramAccount?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  okAccount?: InputMaybe<Scalars['String']>;
  ovz?: InputMaybe<Scalars['String']>;
  participantRoz?: InputMaybe<Scalars['String']>;
  passportNumber?: InputMaybe<Scalars['String']>;
  passportReleaseDate?: InputMaybe<Scalars['Date']>;
  passportSeries?: InputMaybe<Scalars['String']>;
  passwordNew?: InputMaybe<Scalars['String']>;
  passwordOld?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  regalia?: InputMaybe<Scalars['String']>;
  registrationPlace?: InputMaybe<Scalars['String']>;
  releaseDptCode?: InputMaybe<Scalars['String']>;
  releaseDptName?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  speciality?: InputMaybe<Scalars['String']>;
  telegramAccount?: InputMaybe<Scalars['String']>;
  vkAccount?: InputMaybe<Scalars['String']>;
  vkAvatar?: InputMaybe<Scalars['String']>;
  whichUniversity?: InputMaybe<Scalars['String']>;
  workPlace?: InputMaybe<Scalars['String']>;
  youtubeAccount?: InputMaybe<Scalars['String']>;
};

export type UpdateUserMutation = {
  __typename?: 'UpdateUserMutation';
  user?: Maybe<UserType>;
};

export type UserInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  secretCode?: InputMaybe<Scalars['String']>;
  whereRegistration?: InputMaybe<Scalars['String']>;
};

export type UserQuestionType = {
  __typename?: 'UserQuestionType';
  check?: Maybe<Scalars['Boolean']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Текст вопроса */
  question?: Maybe<Scalars['String']>;
  questionCategory?: Maybe<QuestionCategoryType>;
  user?: Maybe<UserType>;
};

export enum UserSexEnum {
  /** Ж */
  F = 'F',
  /** М */
  M = 'M'
}

export type UserType = {
  __typename?: 'UserType';
  /** Учёная степень/звание */
  academicDegree?: Maybe<Scalars['String']>;
  address?: Maybe<AddressType>;
  /** Адрес проживания */
  addressDetail?: Maybe<Scalars['String']>;
  /** Аватар */
  avatar?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['CustomDate']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  /** дата регистрации */
  dateJoined?: Maybe<Scalars['CustomDateTime']>;
  divisionsByUser?: Maybe<Array<DivisionSuggestedType>>;
  /** Образование */
  education?: Maybe<Scalars['String']>;
  /** Email */
  email?: Maybe<Scalars['String']>;
  enrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  eventsByResponsibleUser?: Maybe<Array<EventType>>;
  expoPushTokens?: Maybe<Array<Maybe<ExpoPushTokenType>>>;
  expopushtoken?: Maybe<Array<ExpoPushTokenType>>;
  /** facebook account */
  facebookAccount?: Maybe<Scalars['String']>;
  /** Имя */
  firstName?: Maybe<Scalars['String']>;
  government?: Maybe<GovernmentType>;
  /** Год окончания университета */
  graduationYear?: Maybe<Scalars['String']>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** instagram account */
  instagramAccount?: Maybe<Scalars['String']>;
  /** Отметьте, если пользователь должен считаться активным. Уберите эту отметку вместо удаления учётной записи. */
  isActive?: Maybe<Scalars['Boolean']>;
  isEmailVerificated?: Maybe<Scalars['Boolean']>;
  isFavorite?: Maybe<Array<Maybe<FavoritesType>>>;
  isLike?: Maybe<Array<Maybe<LikesType>>>;
  /** Отметьте, если пользователь может входить в административную часть сайта. */
  isStaff?: Maybe<Scalars['Boolean']>;
  /** Указывает, что пользователь имеет все права без явного их назначения. */
  isSuperuser?: Maybe<Scalars['Boolean']>;
  /** последний вход */
  lastLogin?: Maybe<Scalars['CustomDateTime']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['String']>;
  lead?: Maybe<Array<Maybe<LeadType>>>;
  leagueLecturersEnrollment?: Maybe<LeagueOfLecturersEnrollmentType>;
  leagueLecturersEnrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  likesByUser?: Maybe<Array<LikesType>>;
  memberTicket?: Maybe<MemberTicketType>;
  membersByTeam?: Maybe<Array<TeamType>>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']>;
  /** псевдоним */
  nickname?: Maybe<Scalars['String']>;
  /** ok account */
  okAccount?: Maybe<Scalars['String']>;
  /** ограничение по здоровью/инвалидность */
  ovz?: Maybe<Scalars['String']>;
  participant?: Maybe<ParticipantType>;
  /** Участвовали ли вы в проектах РОЗ? */
  participantRoz?: Maybe<Scalars['String']>;
  participationsByUser?: Maybe<Array<ActionParticipationType>>;
  passportNumber?: Maybe<Scalars['String']>;
  passportReleaseDate?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  /** пароль */
  password?: Maybe<Scalars['String']>;
  /** Номер телефона */
  phone?: Maybe<Scalars['String']>;
  /** Должность */
  position?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<ProjectType>>>;
  projectsByManager?: Maybe<Array<ProjectType>>;
  questionsByUser?: Maybe<Array<UserQuestionType>>;
  quizEnrollmentsByUser?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  quizNickname?: Maybe<Scalars['String']>;
  quizTeam?: Maybe<Array<TeamType>>;
  ratingByUser?: Maybe<Array<NpsType>>;
  /** Регалии */
  regalia?: Maybe<Scalars['String']>;
  registrationCurrentGame?: Maybe<Scalars['Boolean']>;
  registrationPlace?: Maybe<Scalars['String']>;
  releaseDptCode?: Maybe<Scalars['String']>;
  releaseDptName?: Maybe<Scalars['String']>;
  rozAwardLikes?: Maybe<Scalars['Int']>;
  schoolScientistUser?: Maybe<SchoolScientistType>;
  schoolUser?: Maybe<SchoolType>;
  /** Пол */
  sex?: Maybe<UserSexEnum>;
  showLms?: Maybe<Scalars['Boolean']>;
  speakerRequests?: Maybe<SpeakerRequestType>;
  speakers?: Maybe<SpeakerType>;
  speakersByResponsibleUser?: Maybe<Array<SpeakerType>>;
  /** Специальность */
  speciality?: Maybe<Scalars['String']>;
  /** ID лэйбла в Teachbase */
  teachbaseLabelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  team?: Maybe<TeamType>;
  /** telegram account */
  telegramAccount?: Maybe<Scalars['String']>;
  telegramUser?: Maybe<TelegramUserType>;
  userFavorites?: Maybe<Array<FavoritesType>>;
  userLikes?: Maybe<Array<LikesType>>;
  /** Обязательное поле. Не более 150 символов. Только буквы, цифры и символы @/./+/-/_. */
  username?: Maybe<Scalars['String']>;
  /** uuid */
  uuid?: Maybe<Scalars['UUID']>;
  /** vk account */
  vkAccount?: Maybe<Scalars['String']>;
  /** vk avatar */
  vkAvatar?: Maybe<Scalars['String']>;
  /** Откуда прошла регистрация */
  whereRegistration?: Maybe<Scalars['String']>;
  whichUniversityUserCome?: Maybe<UniversityType>;
  /** Место работы */
  workPlace?: Maybe<Scalars['String']>;
  /** youtube account */
  youtubeAccount?: Maybe<Scalars['String']>;
};


export type UserTypeLeadArgs = {
  uuid?: InputMaybe<Scalars['UUID']>;
};


export type UserTypeQuizNicknameArgs = {
  projectId?: InputMaybe<Scalars['ID']>;
};

export type VenueType = {
  __typename?: 'VenueType';
  address?: Maybe<AddressType>;
  /** Вместимость места */
  capacity?: Maybe<Scalars['Int']>;
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** Детали */
  details?: Maybe<Scalars['String']>;
  /** Площадка */
  division?: Maybe<DivisionSuggestedType>;
  eventGroupsByVenue?: Maybe<Array<EventGroupType>>;
  events?: Maybe<Array<EventType>>;
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название места */
  name?: Maybe<Scalars['String']>;
  sliderByVenue?: Maybe<Array<MainSliderType>>;
  /** Я.Карты */
  yandexMapCode?: Maybe<Scalars['String']>;
  yandexMapWidgetUrl?: Maybe<Scalars['String']>;
};

export type VerificationLeagueEnrollmentMutation = {
  __typename?: 'VerificationLeagueEnrollmentMutation';
  user?: Maybe<UserType>;
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type ViewInput = {
  slug: Scalars['String'];
};

export type SpeechDetailFragment = { __typename?: 'SpeechDetailsType', eventItemId?: number | null, speechTheme?: string | null, speechDateStart?: any | null, speechDateFinish?: any | null, reportUrl?: string | null };

export type AttachSpeakerReportToPerformanceMutationVariables = Exact<{
  input?: InputMaybe<SpeakerReportToDivisionInput>;
}>;


export type AttachSpeakerReportToPerformanceMutation = { __typename?: 'Mutation', addSpeakerReportToEventItem?: { __typename?: 'AddSpeakerReportToEventItemMutation', result?: string | null, speechList?: Array<{ __typename?: 'SpeechDetailsType', eventItemId?: number | null, speechTheme?: string | null, speechDateStart?: any | null, speechDateFinish?: any | null, reportUrl?: string | null } | null> | null } | null };

export type CreateParticipationInActionMutationVariables = Exact<{
  input?: InputMaybe<ActionParticipationInput>;
}>;


export type CreateParticipationInActionMutation = { __typename?: 'Mutation', createActionParticipation?: { __typename?: 'CreateActionParticipationMutation', result?: string | null } | null };

export type CreateSpeakerPerformanceMutationVariables = Exact<{
  input?: InputMaybe<SpeakerRegistrationToDivisionInput>;
}>;


export type CreateSpeakerPerformanceMutation = { __typename?: 'Mutation', createSpeakerRegistrationToDivision?: { __typename?: 'CreateSpeakerRegistrationToDivisionMutation', result?: string | null, speechList?: Array<{ __typename?: 'SpeechDetailsType', eventItemId?: number | null, speechTheme?: string | null, speechDateStart?: any | null, speechDateFinish?: any | null, reportUrl?: string | null } | null> | null } | null };

export type DeleteSpeakerPerformanceMutationVariables = Exact<{
  input?: InputMaybe<SpeakerLeaveDivisionInput>;
}>;


export type DeleteSpeakerPerformanceMutation = { __typename?: 'Mutation', deleteSpeakerRegistrationToDivision?: { __typename?: 'DeleteSpeakerRegistrationToDivisionMutation', result?: string | null, speechList?: Array<{ __typename?: 'SpeechDetailsType', eventItemId?: number | null, speechTheme?: string | null, speechDateStart?: any | null, speechDateFinish?: any | null, reportUrl?: string | null } | null> | null } | null };

export type CreateActionDivisionMutationVariables = Exact<{
  input?: InputMaybe<ActionDivisionInput>;
}>;


export type CreateActionDivisionMutation = { __typename?: 'Mutation', registerActionDivision?: { __typename?: 'RegisterActionDivisionMutation', isSuccess?: boolean | null, resultMessage?: string | null, isDivisionCreated?: boolean | null } | null };

export type UpdateSpeakerPerformanceMutationVariables = Exact<{
  input?: InputMaybe<UpdateSpeakerRegistrationToDivisionInput>;
}>;


export type UpdateSpeakerPerformanceMutation = { __typename?: 'Mutation', updateSpeakerRegistrationToDivision?: { __typename?: 'UpdateSpeakerRegistrationToDivisionMutation', result?: string | null, speechList?: Array<{ __typename?: 'SpeechDetailsType', eventItemId?: number | null, speechTheme?: string | null, speechDateStart?: any | null, speechDateFinish?: any | null, reportUrl?: string | null } | null> | null } | null };

export type GetActionParticipationQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetActionParticipationQuery = { __typename?: 'Query', actionParticipation?: { __typename?: 'ActionParticipationType', topic?: string | null, status?: ActionParticipationStatusEnum | null } | null };

export type GetActionDivisionQueryVariables = Exact<{
  slug: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetActionDivisionQuery = { __typename?: 'Query', actionDivisions?: Array<{ __typename?: 'ActionDivisionType', id: string, title?: string | null, personalPhone?: string | null, address?: { __typename?: 'AddressType', value?: string | null } | null, speechDetails?: Array<{ __typename?: 'SpeechDetailsType', eventItemId?: number | null, speechTheme?: string | null, speechDateStart?: any | null, speechDateFinish?: any | null, reportUrl?: string | null } | null> | null } | null> | null };

export type GetActionStartInfoQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetActionStartInfoQuery = { __typename?: 'Query', eventGroupBySlug?: { __typename?: 'EventGroupType', enrollStartDate?: any | null, enrollFinishDate?: any | null, action?: { __typename?: 'EventGroupActionType', id: string, title?: string | null, guideUrl?: string | null } | null } | null };

export type GetEventGroupActionQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetEventGroupActionQuery = { __typename?: 'Query', eventGroupAction?: { __typename?: 'EventGroupActionType', id: string, title?: string | null, hotlinePhone?: string | null, supportEmail?: string | null, agreementUrl?: string | null, designUrl?: string | null, presentationExampleUrl?: string | null, divisions?: Array<{ __typename?: 'DivisionType', id: string, title?: string | null, personalEmail?: string | null, personalPhone?: string | null, venueByDivision?: { __typename?: 'VenueType', address?: { __typename?: 'AddressType', area?: string | null, areaFiasId?: string | null, areaKladrId?: string | null, areaType?: string | null, areaTypeFull?: string | null, areaWithType?: string | null, block?: string | null, blockType?: string | null, blockTypeFull?: string | null, capitalMarker?: string | null, city?: string | null, cityArea?: string | null, cityDistrict?: string | null, cityDistrictFiasId?: string | null, cityDistrictKladrId?: string | null, cityDistrictType?: string | null, cityDistrictTypeFull?: string | null, cityDistrictWithType?: string | null, cityFiasId?: string | null, cityKladrId?: string | null, cityType?: string | null, cityTypeFull?: string | null, cityWithType?: string | null, country?: string | null, countryIsoCode?: string | null, entrance?: string | null, federalDistrict?: string | null, fiasCode?: string | null, fiasId?: string | null, fiasLevel?: string | null, flat?: string | null, flatArea?: string | null, flatCadnum?: string | null, flatFiasId?: string | null, flatType?: string | null, flatTypeFull?: string | null, floor?: string | null, geoLat?: string | null, geoLon?: string | null, geonameId?: string | null, historyValues?: Array<string | null> | null, house?: string | null, houseCadnum?: string | null, houseFiasId?: string | null, houseKladrId?: string | null, houseType?: string | null, houseTypeFull?: string | null, kladrId?: string | null, postalBox?: string | null, postalCode?: string | null, region?: string | null, regionFiasId?: string | null, regionIsoCode?: string | null, regionKladrId?: string | null, regionType?: string | null, regionTypeFull?: string | null, regionWithType?: string | null, settlement?: string | null, settlementFiasId?: string | null, settlementKladrId?: string | null, settlementType?: string | null, settlementTypeFull?: string | null, settlementWithType?: string | null, street?: string | null, streetFiasId?: string | null, streetKladrId?: string | null, streetType?: string | null, streetTypeFull?: string | null, streetWithType?: string | null, timezone?: string | null, unparsedParts?: string | null, value?: string | null } | null } | null } | null> | null } | null };

export type AddressFragment = { __typename?: 'AddressType', area?: string | null, areaFiasId?: string | null, areaKladrId?: string | null, areaType?: string | null, areaTypeFull?: string | null, areaWithType?: string | null, block?: string | null, blockType?: string | null, blockTypeFull?: string | null, capitalMarker?: string | null, city?: string | null, cityArea?: string | null, cityDistrict?: string | null, cityDistrictFiasId?: string | null, cityDistrictKladrId?: string | null, cityDistrictType?: string | null, cityDistrictTypeFull?: string | null, cityDistrictWithType?: string | null, cityFiasId?: string | null, cityKladrId?: string | null, cityType?: string | null, cityTypeFull?: string | null, cityWithType?: string | null, country?: string | null, countryIsoCode?: string | null, entrance?: string | null, federalDistrict?: string | null, fiasCode?: string | null, fiasId?: string | null, fiasLevel?: string | null, flat?: string | null, flatArea?: string | null, flatCadnum?: string | null, flatFiasId?: string | null, flatType?: string | null, flatTypeFull?: string | null, floor?: string | null, geoLat?: string | null, geoLon?: string | null, geonameId?: string | null, historyValues?: Array<string | null> | null, house?: string | null, houseCadnum?: string | null, houseFiasId?: string | null, houseKladrId?: string | null, houseType?: string | null, houseTypeFull?: string | null, kladrId?: string | null, postalBox?: string | null, postalCode?: string | null, region?: string | null, regionFiasId?: string | null, regionIsoCode?: string | null, regionKladrId?: string | null, regionType?: string | null, regionTypeFull?: string | null, regionWithType?: string | null, settlement?: string | null, settlementFiasId?: string | null, settlementKladrId?: string | null, settlementType?: string | null, settlementTypeFull?: string | null, settlementWithType?: string | null, street?: string | null, streetFiasId?: string | null, streetKladrId?: string | null, streetType?: string | null, streetTypeFull?: string | null, streetWithType?: string | null, timezone?: string | null, unparsedParts?: string | null, value?: string | null };

export type GetAddressQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
}>;


export type GetAddressQuery = { __typename?: 'Query', suggestAddress?: Array<{ __typename?: 'AddressType', area?: string | null, areaFiasId?: string | null, areaKladrId?: string | null, areaType?: string | null, areaTypeFull?: string | null, areaWithType?: string | null, block?: string | null, blockType?: string | null, blockTypeFull?: string | null, capitalMarker?: string | null, city?: string | null, cityArea?: string | null, cityDistrict?: string | null, cityDistrictFiasId?: string | null, cityDistrictKladrId?: string | null, cityDistrictType?: string | null, cityDistrictTypeFull?: string | null, cityDistrictWithType?: string | null, cityFiasId?: string | null, cityKladrId?: string | null, cityType?: string | null, cityTypeFull?: string | null, cityWithType?: string | null, country?: string | null, countryIsoCode?: string | null, entrance?: string | null, federalDistrict?: string | null, fiasCode?: string | null, fiasId?: string | null, fiasLevel?: string | null, flat?: string | null, flatArea?: string | null, flatCadnum?: string | null, flatFiasId?: string | null, flatType?: string | null, flatTypeFull?: string | null, floor?: string | null, geoLat?: string | null, geoLon?: string | null, geonameId?: string | null, historyValues?: Array<string | null> | null, house?: string | null, houseCadnum?: string | null, houseFiasId?: string | null, houseKladrId?: string | null, houseType?: string | null, houseTypeFull?: string | null, kladrId?: string | null, postalBox?: string | null, postalCode?: string | null, region?: string | null, regionFiasId?: string | null, regionIsoCode?: string | null, regionKladrId?: string | null, regionType?: string | null, regionTypeFull?: string | null, regionWithType?: string | null, settlement?: string | null, settlementFiasId?: string | null, settlementKladrId?: string | null, settlementType?: string | null, settlementTypeFull?: string | null, settlementWithType?: string | null, street?: string | null, streetFiasId?: string | null, streetKladrId?: string | null, streetType?: string | null, streetTypeFull?: string | null, streetWithType?: string | null, timezone?: string | null, unparsedParts?: string | null, value?: string | null } | null> | null };

export type GetCityQueryVariables = Exact<{
  term: Scalars['String'];
}>;


export type GetCityQuery = { __typename?: 'Query', suggestCity?: Array<{ __typename?: 'AddressType', area?: string | null, areaFiasId?: string | null, areaKladrId?: string | null, areaType?: string | null, areaTypeFull?: string | null, areaWithType?: string | null, block?: string | null, blockType?: string | null, blockTypeFull?: string | null, capitalMarker?: string | null, city?: string | null, cityArea?: string | null, cityDistrict?: string | null, cityDistrictFiasId?: string | null, cityDistrictKladrId?: string | null, cityDistrictType?: string | null, cityDistrictTypeFull?: string | null, cityDistrictWithType?: string | null, cityFiasId?: string | null, cityKladrId?: string | null, cityType?: string | null, cityTypeFull?: string | null, cityWithType?: string | null, country?: string | null, countryIsoCode?: string | null, entrance?: string | null, federalDistrict?: string | null, fiasCode?: string | null, fiasId?: string | null, fiasLevel?: string | null, flat?: string | null, flatArea?: string | null, flatCadnum?: string | null, flatFiasId?: string | null, flatType?: string | null, flatTypeFull?: string | null, floor?: string | null, geoLat?: string | null, geoLon?: string | null, geonameId?: string | null, historyValues?: Array<string | null> | null, house?: string | null, houseCadnum?: string | null, houseFiasId?: string | null, houseKladrId?: string | null, houseType?: string | null, houseTypeFull?: string | null, kladrId?: string | null, postalBox?: string | null, postalCode?: string | null, region?: string | null, regionFiasId?: string | null, regionIsoCode?: string | null, regionKladrId?: string | null, regionType?: string | null, regionTypeFull?: string | null, regionWithType?: string | null, settlement?: string | null, settlementFiasId?: string | null, settlementKladrId?: string | null, settlementType?: string | null, settlementTypeFull?: string | null, settlementWithType?: string | null, street?: string | null, streetFiasId?: string | null, streetKladrId?: string | null, streetType?: string | null, streetTypeFull?: string | null, streetWithType?: string | null, timezone?: string | null, unparsedParts?: string | null, value?: string | null } | null> | null };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { __typename?: 'Query', regions?: Array<{ __typename?: 'RegionType', id: string, name?: string | null, fiasId?: string | null, typeFull?: string | null, type?: string | null } | null> | null };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String'];
  password_confirm: Scalars['String'];
  token: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordMutation', user?: { __typename?: 'UserType', id: string } | null } | null };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', tokenAuth?: { __typename?: 'TokenAuthMutation', payload: any, token: string, refreshToken: string, refreshExpiresIn: number } | null };

export type CreateMemberTicketMutationVariables = Exact<{
  input?: InputMaybe<CreateMemberTicketInput>;
}>;


export type CreateMemberTicketMutation = { __typename?: 'Mutation', applyForMemberTicket?: { __typename?: 'ApplyForMemberTicketMutation', memberTicket?: { __typename?: 'MemberTicketType', ticketNumber?: string | null } | null } | null };

export type UpdateMemberTicketActionMutationVariables = Exact<{
  input?: InputMaybe<UpdateMemberTicketInput>;
}>;


export type UpdateMemberTicketActionMutation = { __typename?: 'Mutation', updateMemberTicket?: { __typename?: 'UpdateMemberTicketMutation', memberTicket?: { __typename?: 'MemberTicketType', discountCard?: MemberTicketDiscountCardEnum | null, discountCardFile?: string | null, educationalExperience?: MemberTicketEducationalExperienceEnum | null } | null } | null };

export type SendApplicationMutationVariables = Exact<{
  input?: InputMaybe<LeadInput>;
}>;


export type SendApplicationMutation = { __typename?: 'Mutation', createLead?: { __typename?: 'LeadMutation', lead?: { __typename?: 'LeadType', id: string, projectLink?: string | null } | null } | null };

export type CategoryFragment = { __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: Array<{ __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null } | null> | null };

export type SubscribeOnTopFilmsMutationVariables = Exact<{
  input?: InputMaybe<EmailInput>;
}>;


export type SubscribeOnTopFilmsMutation = { __typename?: 'Mutation', createMailingList?: { __typename?: 'MailingListMutation', email?: { __typename?: 'MailingListType', email?: string | null } | null } | null };

export type GetTagCompilationsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  randomize?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTagCompilationsQuery = { __typename?: 'Query', tagCompilations?: Array<{ __typename?: 'TagsCompilationType', name?: string | null, slug?: string | null, randomImages?: Array<string | null> | null, h1?: string | null, seoDescription?: string | null, icon?: string | null, contentTypes?: Array<{ __typename?: 'ContentFilterType', type?: ContentTypeEnum | null } | null> | null }> | null };

export type GetTagCompilationsWithTotalCountQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  randomize?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  contentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetTagCompilationsWithTotalCountQuery = { __typename?: 'Query', tagCompilationsWithMeta?: { __typename?: 'TagsCompilationWithMetaType', countTagsCompilations?: number | null, tagCompilations?: Array<{ __typename?: 'TagsCompilationType', name?: string | null, slug?: string | null, randomImages?: Array<string | null> | null, h1?: string | null, seoDescription?: string | null, icon?: string | null, isClosedByRegistration?: boolean | null, contentTypes?: Array<{ __typename?: 'ContentFilterType', type?: ContentTypeEnum | null } | null> | null } | null> | null } | null };

export type FullContentFragment = { __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, created?: any | null, coverUrl?: string | null, promoted?: boolean | null, documentUrl?: string | null, videoUrl?: string | null, videoLength?: string | null, countView?: number | null, countLikes?: number | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, event?: { __typename?: 'EventType', name?: string | null } | null };

export type UpdateContentViewMutationVariables = Exact<{
  input?: InputMaybe<ViewInput>;
}>;


export type UpdateContentViewMutation = { __typename?: 'Mutation', updateView?: { __typename?: 'ContentViewMutation', view?: string | null } | null };

export type UpdateFavoriteMutationVariables = Exact<{
  input?: InputMaybe<FavoriteInput>;
}>;


export type UpdateFavoriteMutation = { __typename?: 'Mutation', updateFavorite?: { __typename?: 'FavoriteContentMutation', favorite?: string | null } | null };

export type UpdateLikeMutationVariables = Exact<{
  input?: InputMaybe<LikeInput>;
}>;


export type UpdateLikeMutation = { __typename?: 'Mutation', updateLike?: { __typename?: 'LikeContentMutation', like?: string | null } | null };

export type GetArticleBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetArticleBySlugQuery = { __typename?: 'Query', contentBySlug?: { __typename?: 'ContentType', id: string, title?: string | null, description?: string | null, slug?: string | null, created?: any | null, coverUrl?: string | null, body?: string | null, countView?: number | null, countLikes?: number | null, categories?: Array<{ __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null } | null };

export type GetArticleRuntimeBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetArticleRuntimeBySlugQuery = { __typename?: 'Query', contentBySlug?: { __typename?: 'ContentType', id: string, slug?: string | null, created?: any | null, countLikes?: number | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null } | null };

export type GetContentByMicroTagsWithCountQueryVariables = Exact<{
  themeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tagCategorySlugsTheme?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tagCategorySlugsDescribe?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetContentByMicroTagsWithCountQuery = { __typename?: 'Query', contentsByMicroTagsWithMeta?: { __typename?: 'ContentWithMetaListType', countContents?: number | null, contents?: Array<{ __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, coverUrl?: string | null, videoLength?: string | null, isClosedByRegistration?: boolean | null, isRecommendedByUs?: boolean | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string } | null> | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null, slug?: string | null } | null> | null, tagscompilation?: Array<{ __typename?: 'TagsCompilationType', slug?: string | null, isClosedByRegistration?: boolean | null } | null> | null } | null> | null } | null };

export type GetContentWithTotalCountQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  ordering?: InputMaybe<Scalars['String']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetContentWithTotalCountQuery = { __typename?: 'Query', contentsWithMeta?: { __typename?: 'ContentWithMetaType', countContents?: number | null, contents?: Array<{ __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, created?: any | null, coverUrl?: string | null, promoted?: boolean | null, documentUrl?: string | null, videoUrl?: string | null, videoLength?: string | null, countView?: number | null, countLikes?: number | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, event?: { __typename?: 'EventType', name?: string | null } | null } | null> | null } | null };

export type GetContentsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  ordering?: InputMaybe<Scalars['String']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetContentsQuery = { __typename?: 'Query', contents?: Array<{ __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, created?: any | null, coverUrl?: string | null, promoted?: boolean | null, documentUrl?: string | null, videoUrl?: string | null, videoLength?: string | null, countView?: number | null, countLikes?: number | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, event?: { __typename?: 'EventType', name?: string | null } | null }> | null };

export type GetContentsByMacroTagQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetContentsByMacroTagQuery = { __typename?: 'Query', contentsByMacroTag?: Array<{ __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, coverUrl?: string | null, videoLength?: string | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null }> | null };

export type GetContentsByMacroTagRuntimeQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetContentsByMacroTagRuntimeQuery = { __typename?: 'Query', contentsByMacroTag?: Array<{ __typename?: 'ContentType', id: string, slug?: string | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null }> | null };

export type GetContentsRuntimeQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetContentsRuntimeQuery = { __typename?: 'Query', contents?: Array<{ __typename?: 'ContentType', id: string, slug?: string | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null }> | null };

export type GetMacroTagsContentQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  contentLimit?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  randomize?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMacroTagsContentQuery = { __typename?: 'Query', tagCategory?: Array<{ __typename?: 'TagCategoryType', slug?: string | null, name?: string | null, contents?: Array<{ __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, coverUrl?: string | null, videoLength?: string | null, isClosedByRegistration?: boolean | null, isRecommendedByUs?: boolean | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, firstName?: string | null, lastName?: string | null, photoUrl?: string | null } | null> | null, tagscompilation?: Array<{ __typename?: 'TagsCompilationType', slug?: string | null, isClosedByRegistration?: boolean | null } | null> | null }> | null } | null> | null };

export type GetMacroTagsContentRuntimeQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  contentLimit?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  randomize?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMacroTagsContentRuntimeQuery = { __typename?: 'Query', tagCategory?: Array<{ __typename?: 'TagCategoryType', slug?: string | null, name?: string | null, contents?: Array<{ __typename?: 'ContentType', id: string, slug?: string | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null }> | null } | null> | null };

export type GetPodcastBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetPodcastBySlugQuery = { __typename?: 'Query', contentBySlug?: { __typename?: 'ContentType', id: string, slug?: string | null, type?: ContentTypeEnum | null, title?: string | null, description?: string | null, coverUrl?: string | null, podcast?: string | null, countView?: number | null, countLikes?: number | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null, slug?: string | null } | null> | null } | null };

export type GetPodcastRuntimeBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetPodcastRuntimeBySlugQuery = { __typename?: 'Query', contentBySlug?: { __typename?: 'ContentType', id: string, slug?: string | null, countLikes?: number | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null } | null };

export type GetRandomArticlesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetRandomArticlesQuery = { __typename?: 'Query', randomArticles?: Array<{ __typename?: 'ContentType', slug?: string | null, created?: any | null, coverUrl?: string | null, title?: string | null } | null> | null };

export type GetTagCompilationBySlugRuntimeQueryVariables = Exact<{
  slugTag?: InputMaybe<Scalars['String']>;
  typeTag?: InputMaybe<Scalars['String']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetTagCompilationBySlugRuntimeQuery = { __typename?: 'Query', tagCompilationBySlugWithMeta?: { __typename?: 'TagCompilationBySlagWithMetaType', tagCompilationBySlug?: Array<{ __typename?: 'ContentType', id: string, slug?: string | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null } | null> | null } | null };

export type GetTagCompilationBySlugWithCountQueryVariables = Exact<{
  slugTag?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  typeTag?: InputMaybe<Scalars['String']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetTagCompilationBySlugWithCountQuery = { __typename?: 'Query', tagCompilationBySlugWithMeta?: { __typename?: 'TagCompilationBySlagWithMetaType', countTagsCompilationBySlug?: number | null, tagCompilationBySlug?: Array<{ __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, description?: string | null, created?: any | null, coverUrl?: string | null, videoLength?: string | null, countView?: number | null, documentUrl?: string | null, isClosedByRegistration?: boolean | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, tagscompilation?: Array<{ __typename?: 'TagsCompilationType', slug?: string | null, isClosedByRegistration?: boolean | null } | null> | null } | null> | null } | null };

export type GetVideoBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetVideoBySlugQuery = { __typename?: 'Query', contentBySlug?: { __typename?: 'ContentType', id: string, slug?: string | null, title?: string | null, body?: string | null, type?: ContentTypeEnum | null, created?: any | null, description?: string | null, coverUrl?: string | null, videoUrl?: string | null, countView?: number | null, countLikes?: number | null, isClosedByRegistration?: boolean | null, categories?: Array<{ __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null, slug?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', slug?: string | null, name?: string | null } | null> | null, tagscompilation?: Array<{ __typename?: 'TagsCompilationType', slug?: string | null, isClosedByRegistration?: boolean | null } | null> | null } | null };

export type GetVideoRuntimeBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetVideoRuntimeBySlugQuery = { __typename?: 'Query', contentBySlug?: { __typename?: 'ContentType', id: string, slug?: string | null, countLikes?: number | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null } | null };

export type GetCourseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCourseQuery = { __typename?: 'Query', course?: { __typename?: 'CourseNode', name: string, description?: string | null, teachbaseUrl?: string | null, sectionsDescription?: string | null, sectionsQty: number, speakers?: Array<{ __typename?: 'SpeakerType', id: string, firstName?: string | null, lastName?: string | null, photoUrl?: string | null } | null> | null } | null };

export type GetCoursesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCoursesQuery = { __typename?: 'Query', allCourses?: { __typename?: 'CourseNodeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'CourseNodeEdge', node?: { __typename?: 'CourseNode', name: string, description?: string | null, coverUrl?: string | null, teachbaseUrl?: string | null, id: string } | null } | null> } | null };

export type DepartmentFragment = { __typename?: 'DepartmentType', id: string, title?: string | null, slug?: string | null };

export type GetDepartmentsBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetDepartmentsBySlugQuery = { __typename?: 'Query', departmentBySlug?: { __typename?: 'DepartmentType', description?: string | null, id: string, title?: string | null, slug?: string | null, childDepartment?: Array<{ __typename?: 'DepartmentType', id: string, title?: string | null, slug?: string | null } | null> | null, parentDepartment?: { __typename?: 'DepartmentType', id: string, title?: string | null, slug?: string | null } | null, persons?: Array<{ __typename?: 'PersonType', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, slug?: string | null, badge?: string | null, email?: string | null, photo?: string | null, position?: string | null, url?: string | null } | null> | null } | null };

export type DepartmentFragmentFragment = { __typename?: 'DepartmentType', id: string, title?: string | null, slug?: string | null };

export type PersonFragmentFragment = { __typename?: 'PersonType', firstName?: string | null, lastName?: string | null, middleName?: string | null, badge?: string | null, email?: string | null, position?: string | null };

export type GetDepartmentsBySlugWithChildrenQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetDepartmentsBySlugWithChildrenQuery = { __typename?: 'Query', departmentBySlug?: { __typename?: 'DepartmentType', id: string, title?: string | null, slug?: string | null, childDepartment?: Array<{ __typename?: 'DepartmentType', id: string, title?: string | null, slug?: string | null, persons?: Array<{ __typename?: 'PersonType', firstName?: string | null, lastName?: string | null, middleName?: string | null, badge?: string | null, email?: string | null, position?: string | null } | null> | null } | null> | null, parentDepartment?: { __typename?: 'DepartmentType', id: string, title?: string | null, slug?: string | null } | null } | null };

export type GetDivisionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDivisionTypesQuery = { __typename?: 'Query', divisionTypes?: Array<{ __typename?: 'DivisionTypeType', id: string, name?: string | null } | null> | null };

export type GetDocumentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentGroupsQuery = { __typename?: 'Query', documentGroups?: Array<{ __typename?: 'DocumentGroupType', title?: string | null, documents?: Array<{ __typename?: 'DocumentType', slug?: string | null, title?: string | null, fileUrl?: string | null } | null> | null } | null> | null };

export type BroadcastFragment = { __typename?: 'BroadcastType', id: string, startTime?: any | null, finishTime?: any | null, published?: boolean | null, url?: string | null };

export type EventFragment = { __typename?: 'EventType', id: string, name?: string | null, intro?: string | null, slug?: string | null, startDate?: any | null, finishDate?: any | null, enrollFinishDate?: any | null, isOffline?: boolean | null, offRegistration?: boolean | null, placesLeft?: number | null, coverUrl?: string | null, mobileImageUrl?: string | null, videoUrl?: string | null, alternativeAddress?: string | null, isHideDateTime?: boolean | null, isHideWeekDays?: boolean | null };

export type EventLinksFragment = { __typename?: 'EventLinkType', name?: string | null, url?: string | null };

export type EventFaqFragment = { __typename?: 'FaqType', id: string, answer?: string | null, question?: string | null };

export type LearnFragment = { __typename?: 'LearnType', slug?: string | null, order?: number | null, title?: string | null, image?: string | null, description?: string | null };

export type PartnerFragment = { __typename?: 'PartnerType', id: string, name?: string | null, url?: string | null, slug?: string | null, logoUrl?: string | null };

export type CheckinEventEnrollmentMutationVariables = Exact<{
  input?: InputMaybe<EnrollmentCheckinMInput>;
}>;


export type CheckinEventEnrollmentMutation = { __typename?: 'Mutation', enrollmentCheckin?: { __typename?: 'EnrollmentCheckinMutation', result?: string | null } | null };

export type CheckinEventEnrollmentNoAdminMutationVariables = Exact<{
  eventUuid?: InputMaybe<Scalars['String']>;
}>;


export type CheckinEventEnrollmentNoAdminMutation = { __typename?: 'Mutation', enrollmentCheckinNoAdmin?: { __typename?: 'EnrollmentCheckinNoAdminMutation', result?: string | null } | null };

export type CreateEventNpsMutationVariables = Exact<{
  input?: InputMaybe<EventNpsInput>;
}>;


export type CreateEventNpsMutation = { __typename?: 'Mutation', createEventNps?: { __typename?: 'EventNpsMutation', result?: string | null } | null };

export type RegisterToEventMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type RegisterToEventMutation = { __typename?: 'Mutation', enrollToEvent?: { __typename?: 'EnrollToEventMutation', result?: string | null, event?: { __typename?: 'EventType', id: string } | null } | null };

export type CancelEventRegistrationMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type CancelEventRegistrationMutation = { __typename?: 'Mutation', leaveEvent?: { __typename?: 'LeaveEventMutation', result?: string | null, event?: { __typename?: 'EventType', id: string } | null } | null };

export type GetAlbumsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetAlbumsQuery = { __typename?: 'Query', eventBySlug?: { __typename?: 'EventType', name?: string | null, eventDays?: Array<{ __typename?: 'EventDayType', date?: any | null, eventItems?: Array<{ __typename?: 'EventItemType', id: string, title?: string | null, startTime?: any | null, finishTime?: any | null, photos?: Array<{ __typename?: 'EventPhotoType', id: string, fileUrl?: string | null, isCover?: boolean | null }> | null } | null> | null } | null> | null } | null };

export type GetEventQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  photosLimit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventQuery = { __typename?: 'Query', eventBySlug?: { __typename?: 'EventType', description?: string | null, alternativeAddress?: string | null, requiredUserFields?: Array<string | null> | null, recommendedUserFields?: Array<string | null> | null, afterEnrollInfo?: string | null, afterEnrollLinkLabel?: string | null, afterEnrollLinkUrl?: string | null, autoRedirect?: boolean | null, id: string, name?: string | null, intro?: string | null, slug?: string | null, startDate?: any | null, finishDate?: any | null, enrollFinishDate?: any | null, isOffline?: boolean | null, offRegistration?: boolean | null, placesLeft?: number | null, coverUrl?: string | null, mobileImageUrl?: string | null, videoUrl?: string | null, isHideDateTime?: boolean | null, isHideWeekDays?: boolean | null, offers?: Array<{ __typename?: 'OfferType', id: string, description?: string | null, image?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null } | null> | null, venue?: { __typename?: 'VenueType', id: string, name?: string | null, capacity?: number | null, details?: string | null, yandexMapWidgetUrl?: string | null, address?: { __typename?: 'AddressType', city?: string | null, value?: string | null, areaFiasId?: string | null, regionFiasId?: string | null, cityFiasId?: string | null, settlementFiasId?: string | null } | null } | null, headliners?: Array<{ __typename?: 'SpeakerType', middleName?: string | null, id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, eventDays?: Array<{ __typename?: 'EventDayType', date?: any | null, eventItems?: Array<{ __typename?: 'EventItemType', active?: boolean | null, id: string, title?: string | null, startTime?: any | null, finishTime?: any | null, description?: string | null, speakerIds?: Array<string | null> | null, track?: Array<{ __typename?: 'CategoryType', id: string, name?: string | null }> | null, broadcast?: { __typename?: 'BroadcastType', id: string, title?: string | null, startTime?: any | null, finishTime?: any | null, url?: string | null, published?: boolean | null } | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null } | null> | null } | null> | null, broadcasts?: Array<{ __typename?: 'BroadcastType', id: string, title?: string | null, startTime?: any | null, finishTime?: any | null, url?: string | null, imageUrl?: string | null, published?: boolean | null } | null> | null, partners?: Array<{ __typename?: 'PartnerType', id: string, name?: string | null, url?: string | null, slug?: string | null, logoUrl?: string | null } | null> | null, infoPartners?: Array<{ __typename?: 'PartnerType', id: string, name?: string | null, url?: string | null, slug?: string | null, logoUrl?: string | null } | null> | null, learns?: Array<{ __typename?: 'LearnType', slug?: string | null, order?: number | null, title?: string | null, image?: string | null, description?: string | null } | null> | null, album?: { __typename?: 'EventPhotoAlbumType', photos?: Array<{ __typename?: 'EventPhotoType', id: string, file?: string | null, fileUrl?: string | null, eventItem?: { __typename?: 'EventItemType', id: string } | null }> | null } | null, universities?: Array<{ __typename?: 'UniversitiesRealType', name?: string | null } | null> | null, eventLinks?: Array<{ __typename?: 'EventLinkType', name?: string | null, url?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', slug?: string | null, tagCategory?: { __typename?: 'TagCategoryType', slug?: string | null } | null }> | null, describeTags?: Array<{ __typename?: 'TagType', slug?: string | null }> | null, faqs?: Array<{ __typename?: 'FaqType', id: string, answer?: string | null, question?: string | null } | null> | null } | null };

export type GetEventEnrollQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetEventEnrollQuery = { __typename?: 'Query', eventBySlugNoChd?: { __typename?: 'EventTypeNoChd', uuid: string, name: string, isUserEnrolled?: boolean | null, isUserAttended?: boolean | null, enrollmentQrcode?: string | null, isOffline: boolean } | null };

export type GetEventEnrollmentByUuidQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type GetEventEnrollmentByUuidQuery = { __typename?: 'Query', enrollmentByUuid?: { __typename?: 'EventEnrollmentType', event?: { __typename?: 'EventType', name?: string | null } | null, user?: { __typename?: 'UserType', firstName?: string | null, lastName?: string | null } | null } | null };

export type GetEventScheduleQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetEventScheduleQuery = { __typename?: 'Query', eventBySlug?: { __typename?: 'EventType', eventDays?: Array<{ __typename?: 'EventDayType', date?: any | null, eventItems?: Array<{ __typename?: 'EventItemType', id: string, title?: string | null, startTime?: any | null, finishTime?: any | null, description?: string | null, speakerIds?: Array<string | null> | null, track?: Array<{ __typename?: 'CategoryType', id: string, name?: string | null }> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GetEventsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  ordering?: InputMaybe<Scalars['String']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  settlementId?: InputMaybe<Scalars['String']>;
  areaId?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  specialProject?: InputMaybe<Scalars['String']>;
  speakersIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetEventsQuery = { __typename?: 'Query', events?: Array<{ __typename?: 'EventType', promoted?: boolean | null, id: string, name?: string | null, intro?: string | null, slug?: string | null, startDate?: any | null, finishDate?: any | null, enrollFinishDate?: any | null, isOffline?: boolean | null, offRegistration?: boolean | null, placesLeft?: number | null, coverUrl?: string | null, mobileImageUrl?: string | null, videoUrl?: string | null, alternativeAddress?: string | null, isHideDateTime?: boolean | null, isHideWeekDays?: boolean | null, venue?: { __typename?: 'VenueType', id: string, capacity?: number | null, address?: { __typename?: 'AddressType', city?: string | null } | null } | null, categories?: Array<{ __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null } | null> | null, broadcasts?: Array<{ __typename?: 'BroadcastType', id: string, startTime?: any | null, finishTime?: any | null, published?: boolean | null, url?: string | null } | null> | null }> | null };

export type GetEventsByMacroTagsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventsByMacroTagsQuery = { __typename?: 'Query', eventsByMacroTags?: Array<{ __typename?: 'EventType', id: string, name?: string | null, slug?: string | null, coverUrl?: string | null, startDate?: any | null, mobileImageUrl?: string | null, alternativeAddress?: string | null, venue?: { __typename?: 'VenueType', address?: { __typename?: 'AddressType', city?: string | null } | null } | null }> | null };

export type GetEventsWithMetaQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  alternativeAddressFilter?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Scalars['String']>;
  settlementId?: InputMaybe<Scalars['String']>;
  areaId?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  specialProject?: InputMaybe<Scalars['String']>;
  tagCategorySlugsTheme?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventsWithMetaQuery = { __typename?: 'Query', eventsWithMeta?: { __typename?: 'EventWithMetaType', countEvents?: number | null, events?: Array<{ __typename?: 'EventType', id: string, name?: string | null, intro?: string | null, slug?: string | null, startDate?: any | null, finishDate?: any | null, enrollFinishDate?: any | null, isOffline?: boolean | null, offRegistration?: boolean | null, placesLeft?: number | null, coverUrl?: string | null, mobileImageUrl?: string | null, videoUrl?: string | null, alternativeAddress?: string | null, isHideDateTime?: boolean | null, isHideWeekDays?: boolean | null, venue?: { __typename?: 'VenueType', capacity?: number | null, address?: { __typename?: 'AddressType', city?: string | null } | null } | null, broadcasts?: Array<{ __typename?: 'BroadcastType', id: string, startTime?: any | null, finishTime?: any | null, published?: boolean | null, url?: string | null } | null> | null } | null> | null } | null };

export type EventGroupFragment = { __typename?: 'EventGroupType', id: string, name?: string | null, startDate?: any | null, finishDate?: any | null, description?: string | null, isOffline?: boolean | null, coverUrl?: string | null, mobileImageUrl?: string | null, intro?: string | null, eventGroupLinks?: Array<{ __typename?: 'EventGroupLinkType', name?: string | null, url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null } | null> | null, venue?: { __typename?: 'VenueType', address?: { __typename?: 'AddressType', city?: string | null, value?: string | null } | null } | null };

export type GetActionSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActionSourcesQuery = { __typename?: 'Query', actionSources?: Array<{ __typename?: 'ActionSourceType', name?: string | null } | null> | null };

export type GetEventGroupBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventGroupBySlugQuery = { __typename?: 'Query', eventGroupBySlug?: { __typename?: 'EventGroupType', id: string, name?: string | null, startDate?: any | null, finishDate?: any | null, description?: string | null, isOffline?: boolean | null, coverUrl?: string | null, mobileImageUrl?: string | null, intro?: string | null, events?: Array<{ __typename?: 'EventType', title?: string | null, subtitle?: string | null, slug?: string | null, startDate?: any | null, broadcasts?: Array<{ __typename?: 'BroadcastType', id: string, title?: string | null, startTime?: any | null, finishTime?: any | null, url?: string | null, imageUrl?: string | null, published?: boolean | null } | null> | null, album?: { __typename?: 'EventPhotoAlbumType', photos?: Array<{ __typename?: 'EventPhotoType', fileUrl?: string | null }> | null } | null } | null> | null, headliners?: Array<{ __typename?: 'SpeakerType', middleName?: string | null, id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, partners?: Array<{ __typename?: 'PartnerType', id: string, name?: string | null, url?: string | null, slug?: string | null, logoUrl?: string | null } | null> | null, infoPartners?: Array<{ __typename?: 'PartnerType', id: string, name?: string | null, url?: string | null, slug?: string | null, logoUrl?: string | null } | null> | null, learnsByEventGroup?: Array<{ __typename?: 'LearnType', slug?: string | null, order?: number | null, title?: string | null, image?: string | null, description?: string | null }> | null, faqs?: Array<{ __typename?: 'FaqType', id: string, answer?: string | null, question?: string | null } | null> | null, eventGroupLinks?: Array<{ __typename?: 'EventGroupLinkType', name?: string | null, url?: string | null } | null> | null, categories?: Array<{ __typename?: 'CategoryType', id: string, slug?: string | null, name?: string | null, description?: string | null } | null> | null, venue?: { __typename?: 'VenueType', address?: { __typename?: 'AddressType', city?: string | null, value?: string | null } | null } | null } | null };

export type GetExperimentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExperimentsQuery = { __typename?: 'Query', getCurrentExperiments?: Array<{ __typename?: 'ExperimentType', slug?: string | null, status?: ExperimentStatusEnum | null, finishedAt?: any | null, groups?: Array<{ __typename?: 'ExperimentGroupType', slug?: string | null, groupWeight?: number | null } | null> | null } | null> | null };

export type CheckAnswerMutationVariables = Exact<{
  input?: InputMaybe<CheckAnswerInput>;
}>;


export type CheckAnswerMutation = { __typename?: 'Mutation', checkAnswer?: { __typename?: 'CheckAnswerMutations', checkAnswer?: { __typename?: 'CheckAnswerType', isRight?: boolean | null, textProof?: string | null } | null } | null };

export type GetDailyQuestionQueryVariables = Exact<{
  competitionSlug?: InputMaybe<Scalars['String']>;
}>;


export type GetDailyQuestionQuery = { __typename?: 'Query', actualQuestion?: { __typename?: 'ActualQuestionType', id: string, text?: string | null, datetimePublication?: any | null, image?: string | null, colorBackgroundQuestion?: string | null, colorBackgroundImage?: string | null, answerTexts?: Array<{ __typename?: 'AnswerTexts', id: string, text?: string | null } | null> | null } | null };

export type GetDailyQuestionUserScoreQueryVariables = Exact<{
  competitionSlug?: InputMaybe<Scalars['String']>;
}>;


export type GetDailyQuestionUserScoreQuery = { __typename?: 'Query', dailyQuestionUserScore?: { __typename?: 'DailyQuestionUserScoreType', amount?: number | null, multiplier?: number | null, countOperations?: number | null } | null };

export type GetGovernmentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetGovernmentsQuery = { __typename?: 'Query', governments?: Array<{ __typename?: 'GovernmentType', id: string, governmentName?: string | null }> | null };

export type GetStatisticsAttractingSpeakersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatisticsAttractingSpeakersQuery = { __typename?: 'Query', statisticsAttractingSpeakers?: { __typename?: 'StatisticsType', numberOfEvents?: number | null, numberOfSpeakers?: number | null, numberOfEventParticipants?: number | null } | null };

export type LeagueLecturersEnrollmentFragment = { __typename?: 'LeagueOfLecturersEnrollmentType', id: string, stage?: number | null, status?: EnrollmentStatusEnum | null, videocard?: string | null, lectureName?: string | null, lectureVideo?: string | null, agreementFile?: string | null, agreementFilePart2?: string | null, agreementFilePart3?: string | null, performanceTheme?: string | null, firstThemeOfSpeech?: string | null, secondThemeOfSpeech?: string | null, thirdThemeOfSpeech?: string | null, fourthThemeOfSpeech?: string | null, season?: { __typename?: 'LeagueOfLecturersSeasonType', id: string, title?: string | null, applicationStartsAt?: any | null, applicationFinishesAt?: any | null, seasonEndDate?: any | null } | null };

export type LeagueLecturersSeasonFragment = { __typename?: 'LeagueOfLecturersSeasonType', id: string, title?: string | null, applicationStartsAt?: any | null, applicationFinishesAt?: any | null, seasonEndDate?: any | null };

export type CheckLeagueEnrollmentEmailMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;


export type CheckLeagueEnrollmentEmailMutation = { __typename?: 'Mutation', verificationLeagueEnrollment?: { __typename?: 'VerificationLeagueEnrollmentMutation', user?: { __typename?: 'UserType', leagueLecturersEnrollment?: { __typename?: 'LeagueOfLecturersEnrollmentType', status?: EnrollmentStatusEnum | null } | null } | null } | null };

export type EnrollToLeagueLecturersMutationVariables = Exact<{
  input?: InputMaybe<CreateLeagueInput>;
}>;


export type EnrollToLeagueLecturersMutation = { __typename?: 'Mutation', createLeagueEnrollment?: { __typename?: 'CreateLeagueMutation', user?: { __typename?: 'UserType', id: string } | null } | null };

export type UpdateLeagueLecturersEnrollmentMutationVariables = Exact<{
  input?: InputMaybe<UpdateLeagueInput>;
}>;


export type UpdateLeagueLecturersEnrollmentMutation = { __typename?: 'Mutation', updateLeagueEnrollment?: { __typename?: 'UpdateLeagueMutation', user?: { __typename?: 'UserType', id: string } | null } | null };

export type GetLeagueSeasonsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetLeagueSeasonsQuery = { __typename?: 'Query', seasonsLeagueOfLecturers?: Array<{ __typename?: 'LeagueOfLecturersSeasonType', id: string, title?: string | null, applicationStartsAt?: any | null, applicationFinishesAt?: any | null, seasonEndDate?: any | null } | null> | null };

export type GetLeagueTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeagueTopicsQuery = { __typename?: 'Query', leagueTopics?: Array<{ __typename?: 'TopicType', id?: string | null, name?: string | null } | null> | null };

export type MainSliderQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type MainSliderQuery = { __typename?: 'Query', mainSlider?: Array<{ __typename?: 'MainSliderType', id: string, order?: number | null, date?: any | null, endDate?: any | null, name?: string | null, description?: string | null, url?: string | null, imageUrl?: string | null, mobileImage?: string | null, videoUrl?: string | null, active?: boolean | null, venue?: { __typename?: 'VenueType', id: string, address?: { __typename?: 'AddressType', city?: string | null } | null } | null, events?: Array<{ __typename?: 'EventType', id: string, isOffline?: boolean | null, broadcasts?: Array<{ __typename?: 'BroadcastType', id: string, url?: string | null, startTime?: any | null, finishTime?: any | null, published?: boolean | null } | null> | null } | null> | null } | null> | null };

export type LikeNomineeMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type LikeNomineeMutation = { __typename?: 'Mutation', addLike?: { __typename?: 'AddLikeMutation', nominee?: { __typename?: 'NomineeType', id: string, liked?: boolean | null } | null } | null };

export type GetNomineeBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetNomineeBySlugQuery = { __typename?: 'Query', nomineeBySlug?: { __typename?: 'NomineeType', id: string, slug?: string | null, type?: NomineeTypeEnum | null, title?: string | null, liked?: boolean | null, preview?: string | null, description?: string | null, nomination?: string | null, imageUrl?: string | null, presentationUrl?: string | null, videoUrl?: string | null, videoLink?: string | null, videoLinkInterview?: string | null, year?: number | null, speaker?: { __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null, awards?: Array<{ __typename?: 'AwardType', id: string, name?: string | null } | null> | null } | null };

export type GetNomineesQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
}>;


export type GetNomineesQuery = { __typename?: 'Query', nominees?: Array<{ __typename?: 'NomineeType', id: string, slug?: string | null, title?: string | null, liked?: boolean | null, preview?: string | null, imageUrl?: string | null, speaker?: { __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null, awards?: Array<{ __typename?: 'AwardType', id: string, name?: string | null } | null> | null } | null> | null };

export type CreateNpsMutationVariables = Exact<{
  input?: InputMaybe<RatingInput>;
}>;


export type CreateNpsMutation = { __typename?: 'Mutation', createNps?: { __typename?: 'ContentNpsMutation', nps?: { __typename?: 'NpsType', id: string } | null } | null };

export type CreateNpsWithoutUserMutationVariables = Exact<{
  input?: InputMaybe<RatingInput>;
}>;


export type CreateNpsWithoutUserMutation = { __typename?: 'Mutation', createNpsWithoutUser?: { __typename?: 'ContentNpsWithoutUserMutation', nps?: { __typename?: 'NpsType', id: string } | null } | null };

export type GetPageBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetPageBySlugQuery = { __typename?: 'Query', pageBySlug?: { __typename?: 'PageType', id: string, slug?: string | null, created?: any | null, date?: any | null, title?: string | null, description?: string | null, body?: string | null, published?: boolean | null } | null };

export type GetPageGroupBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetPageGroupBySlugQuery = { __typename?: 'Query', pageGroupBySlug?: { __typename?: 'PageGroupType', id: string, slug?: string | null, title?: string | null, description?: string | null, published?: boolean | null, pages?: Array<{ __typename?: 'PageType', id: string, slug?: string | null, title?: string | null, description?: string | null, body?: string | null, published?: boolean | null, image?: string | null, documentGroups?: Array<{ __typename?: 'DocumentGroupType', slug?: string | null, title?: string | null, documents?: Array<{ __typename?: 'DocumentType', slug?: string | null, title?: string | null, fileUrl?: string | null, url?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GetEventGroupPhotosQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventGroupPhotosQuery = { __typename?: 'Query', eventGroupBySlug?: { __typename?: 'EventGroupType', id: string, name?: string | null, events?: Array<{ __typename?: 'EventType', id: string, slug?: string | null, title?: string | null, eventDays?: Array<{ __typename?: 'EventDayType', date?: any | null, eventItems?: Array<{ __typename?: 'EventItemType', id: string, title?: string | null, startTime?: any | null, finishTime?: any | null, albumCover?: { __typename?: 'EventPhotoType', fileUrl?: string | null } | null, photos?: Array<{ __typename?: 'EventPhotoType', fileUrl?: string | null, isCover?: boolean | null }> | null } | null> | null } | null> | null } | null> | null } | null };

export type GetEventItemPhotosQueryVariables = Exact<{
  eventItemId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventItemPhotosQuery = { __typename?: 'Query', eventItemById?: { __typename?: 'EventItemType', title?: string | null, startTime?: any | null, finishTime?: any | null, photos?: Array<{ __typename?: 'EventPhotoType', id: string, file?: string | null, fileUrl?: string | null }> | null } | null };

export type GetEventPhotosQueryVariables = Exact<{
  eventSlug: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventPhotosQuery = { __typename?: 'Query', eventBySlug?: { __typename?: 'EventType', album?: { __typename?: 'EventPhotoAlbumType', photos?: Array<{ __typename?: 'EventPhotoType', id: string, file?: string | null, fileUrl?: string | null }> | null } | null } | null };

export type PollQuestionFragment = { __typename?: 'QuestionType', id?: string | null, min?: number | null, max?: number | null, type?: string | null, allowMultiply?: boolean | null, textType?: string | null, body?: string | null, choices?: Array<string | null> | null };

export type CreateAnswerOfPollMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<AnswerInput>> | InputMaybe<AnswerInput>>;
}>;


export type CreateAnswerOfPollMutation = { __typename?: 'Mutation', createAnswer?: { __typename?: 'CreateAnswerMutation', poll?: { __typename?: 'PollType', id: string } | null } | null };

export type GetPollQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetPollQuery = { __typename?: 'Query', pollBySlug?: { __typename?: 'PollType', id: string, slug?: string | null, name?: string | null, projectType?: PollProjectTypeEnum | null, pollsPosition?: number | null, questions?: Array<{ __typename?: 'QuestionType', id?: string | null, min?: number | null, max?: number | null, type?: string | null, allowMultiply?: boolean | null, textType?: string | null, body?: string | null, choices?: Array<string | null> | null } | null> | null, enrollmentLl?: { __typename?: 'LeagueOfLecturersEnrollmentType', id: string, user?: { __typename?: 'UserType', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, position?: string | null } | null } | null, schoolScientistPoll?: { __typename?: 'SchoolScientistType', id: string, status?: SchoolScientistEnrollmentStatusEnum | null } | null, polls?: Array<{ __typename?: 'PollType', id: string, slug?: string | null, questions?: Array<{ __typename?: 'QuestionType', id?: string | null, min?: number | null, max?: number | null, type?: string | null, allowMultiply?: boolean | null, textType?: string | null, body?: string | null, choices?: Array<string | null> | null } | null> | null, speaker?: { __typename?: 'SpeakerType', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, photoUrl?: string | null, title?: string | null } | null }> | null, pollByEvent?: { __typename?: 'EventType', name?: string | null, slug?: string | null, startDate?: any | null, finishDate?: any | null, isRepeatedPollAnswersAllowed?: boolean | null, venue?: { __typename?: 'VenueType', address?: { __typename?: 'AddressType', city?: string | null } | null } | null } | null } | null };

export type PostFragment = { __typename?: 'PostType', id: string, title?: string | null, created?: any | null, slug?: string | null, imageUrl?: string | null, mobileImageUrl?: string | null, description?: string | null, mark?: boolean | null, published?: boolean | null, publishedAt?: any | null, body?: string | null, specialProject?: Array<{ __typename?: 'SpecialProjectType', name?: string | null }> | null };

export type GetPostQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetPostQuery = { __typename?: 'Query', postBySlug?: { __typename?: 'PostType', id: string, title?: string | null, created?: any | null, slug?: string | null, imageUrl?: string | null, mobileImageUrl?: string | null, description?: string | null, mark?: boolean | null, published?: boolean | null, publishedAt?: any | null, body?: string | null, specialProject?: Array<{ __typename?: 'SpecialProjectType', name?: string | null }> | null } | null };

export type GetPostsWithTotalCountQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  slugSpecialProject?: InputMaybe<Scalars['String']>;
}>;


export type GetPostsWithTotalCountQuery = { __typename?: 'Query', postsWithMeta?: { __typename?: 'PostTypeWithMeta', totalCount?: number | null, results?: Array<{ __typename?: 'PostType', id: string, title?: string | null, created?: any | null, slug?: string | null, imageUrl?: string | null, mobileImageUrl?: string | null, description?: string | null, mark?: boolean | null, published?: boolean | null, publishedAt?: any | null, body?: string | null, specialProject?: Array<{ __typename?: 'SpecialProjectType', name?: string | null }> | null } | null> | null } | null };

export type GetProcurementsQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
}>;


export type GetProcurementsQuery = { __typename?: 'Query', procurements?: Array<{ __typename?: 'ProcurementType', id: string, type?: string | null, title?: string | null, platformUrl?: string | null, publishingDate?: any | null, closingDate?: any | null, startPrice?: number | null, contactsName?: string | null, contactsEmail?: string | null, contactsPhone?: string | null, documentationUrl?: string | null, actUrl?: string | null }> | null };

export type ShortSpecialProjectFragment = { __typename?: 'SpecialProjectType', id: string, name?: string | null, projectUrl?: string | null, smallPhoto?: string | null };

export type SpecialProjectFragment = { __typename?: 'SpecialProjectType', id: string, slug?: string | null, name?: string | null, photo?: string | null, projectUrl?: string | null, description?: string | null };

export type GetShortSpecialProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShortSpecialProjectQuery = { __typename?: 'Query', shortSpecialProject?: Array<{ __typename?: 'SpecialProjectType', id: string, name?: string | null, projectUrl?: string | null, smallPhoto?: string | null } | null> | null };

export type SpecialProjectsQueryVariables = Exact<{
  isShownInFilter?: InputMaybe<Scalars['Boolean']>;
}>;


export type SpecialProjectsQuery = { __typename?: 'Query', specialProjects?: Array<{ __typename?: 'SpecialProjectType', id: string, slug?: string | null, name?: string | null, photo?: string | null, projectUrl?: string | null, description?: string | null } | null> | null };

export type QuestionCategoryFragment = { __typename?: 'QuestionCategoryType', id: string, name?: string | null };

export type QuestionFragment = { __typename?: 'UserQuestionType', id: string, question?: string | null };

export type CreateQuestionMutationVariables = Exact<{
  input?: InputMaybe<QuestionInput>;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createUserQuestion?: { __typename?: 'CreateUserQuestion', userQuestion?: { __typename?: 'UserQuestionType', id: string, question?: string | null, questionCategory?: { __typename?: 'QuestionCategoryType', id: string, name?: string | null } | null } | null } | null };

export type GetQuestionsCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionsCategoriesQuery = { __typename?: 'Query', questionCategories?: Array<{ __typename?: 'QuestionCategoryType', id: string, name?: string | null } | null> | null };

export type RegisterToQuizMutationVariables = Exact<{
  gameId: Scalars['ID'];
  teamName?: InputMaybe<Scalars['String']>;
  teamCity?: InputMaybe<Scalars['String']>;
  teamMembers?: InputMaybe<Scalars['Int']>;
  firstGame: Scalars['Boolean'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type RegisterToQuizMutation = { __typename?: 'Mutation', createQuizRegistration?: { __typename?: 'CreateQuizRegistrationMutation', user?: { __typename?: 'UserType', id: string } | null } | null };

export type GetChatBotQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChatBotQuery = { __typename?: 'Query', chatBot?: { __typename?: 'ChatBotCheckType', chatBot?: boolean | null } | null };

export type GetCurrentRoundQueryVariables = Exact<{
  date?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetCurrentRoundQuery = { __typename?: 'Query', currentRound?: Array<{ __typename?: 'RoundType', id: string, title?: string | null, dateStart?: any | null, dateEnd?: any | null, games?: Array<{ __typename?: 'GameType', id: string, title?: string | null, broadcast?: string | null, dateStart?: any | null, dateEnd?: any | null, registerOffDate?: any | null, type: Type } | null> | null } | null> | null };

export type GetCurrentSeasonsQueryVariables = Exact<{
  date?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetCurrentSeasonsQuery = { __typename?: 'Query', currentSeason?: Array<{ __typename?: 'SeasonType', id: string, title?: string | null, dateStart?: any | null, dateEnd?: any | null, rounds?: Array<{ __typename?: 'RoundType', id: string, title?: string | null, games?: Array<{ __typename?: 'GameType', id: string, title?: string | null, broadcast?: string | null, dateStart?: any | null, dateEnd?: any | null, registerOffDate?: any | null, type: Type } | null> | null } | null> | null } | null> | null };

export type GetGameQueryVariables = Exact<{
  gameId?: InputMaybe<Scalars['ID']>;
}>;


export type GetGameQuery = { __typename?: 'Query', gameById?: { __typename?: 'GameType', id: string, title?: string | null, type: Type, ratings?: Array<{ __typename?: 'QuizRatingType', city?: string | null, teamName?: string | null, roundOne?: number | null, roundTwo?: number | null, roundThree?: number | null, roundFour?: number | null, roundFive?: number | null, roundSix?: number | null, roundSeven?: number | null, time?: string | null, total?: number | null, place?: number | null } | null> | null } | null };

export type GetGamesQueryVariables = Exact<{
  dateStart?: InputMaybe<Scalars['DateTime']>;
  dateEnd?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetGamesQuery = { __typename?: 'Query', games?: Array<{ __typename?: 'GameType', id: string, title?: string | null, dateStart?: any | null, dateEnd?: any | null, registerOffDate?: any | null, broadcast?: string | null, type: Type, ratings?: Array<{ __typename?: 'QuizRatingType', city?: string | null, teamName?: string | null, roundOne?: number | null, roundTwo?: number | null, roundThree?: number | null, roundFour?: number | null, roundFive?: number | null, roundSix?: number | null, roundSeven?: number | null, time?: string | null, total?: number | null, place?: number | null } | null> | null } | null> | null };

export type RegisterSchoolMutationVariables = Exact<{
  input?: InputMaybe<SchoolCreateInput>;
}>;


export type RegisterSchoolMutation = { __typename?: 'Mutation', createEnrollmentSchool?: { __typename?: 'SchoolCreateMutation', school?: { __typename?: 'SchoolType', id: string } | null } | null };

export type RegisterScientistMutationVariables = Exact<{ [key: string]: never; }>;


export type RegisterScientistMutation = { __typename?: 'Mutation', createEnrollmentScientistSchool?: { __typename?: 'SchoolScientistCreateMutation', schoolScientist?: { __typename?: 'SchoolScientistType', id: string } | null } | null };

export type CreateSchoolVisitMutationVariables = Exact<{
  input?: InputMaybe<SchoolScientistVisitInput>;
}>;


export type CreateSchoolVisitMutation = { __typename?: 'Mutation', createEnrollmentScientistSchoolVisit?: { __typename?: 'SchoolScientistVisitCreateMutation', scientistVisit?: { __typename?: 'ScientistVisitType', id: string, dateVisiting?: any | null } | null } | null };

export type DeleteSchoolVisitMutationVariables = Exact<{
  input?: InputMaybe<SchoolScientistVisitInput>;
}>;


export type DeleteSchoolVisitMutation = { __typename?: 'Mutation', deleteEnrollmentScientistSchoolVisit?: { __typename?: 'SchoolScientistVisitDeleteMutation', deleteStatus?: boolean | null } | null };

export type UpdateScientistMutationVariables = Exact<{
  input?: InputMaybe<SchoolScientistUpdateInput>;
}>;


export type UpdateScientistMutation = { __typename?: 'Mutation', updateEnrollmentScientistSchool?: { __typename?: 'SchoolScientistUpdateMutation', schoolScientist?: { __typename?: 'SchoolScientistType', id: string } | null } | null };

export type GetSchoolEnrollmentQueryVariables = Exact<{
  allSchools?: InputMaybe<Scalars['Boolean']>;
  regionFias?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetSchoolEnrollmentQuery = { __typename?: 'Query', searchSchoolEnrollment?: Array<{ __typename?: 'SchoolType', id: string, schoolName?: string | null, schoolPhoneWithMask?: string | null, address?: { __typename?: 'AddressType', region?: string | null, city?: string | null, street?: string | null, house?: string | null } | null, visitsSchoolScientist?: Array<{ __typename?: 'ScientistVisitType', id: string, dateVisiting?: any | null, school?: { __typename?: 'SchoolType', id: string } | null }> | null }> | null };

export type GetScientistEnrollmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScientistEnrollmentQuery = { __typename?: 'Query', searchSchoolEnrollmentScientist?: Array<{ __typename?: 'SchoolScientistType', id: string, status?: SchoolScientistEnrollmentStatusEnum | null, hasReport?: boolean | null } | null> | null };

export type SearchResultsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  outputType?: InputMaybe<Scalars['String']>;
}>;


export type SearchResultsQuery = { __typename?: 'Query', search?: { __typename?: 'SearchType', events?: Array<{ __typename?: 'EventType', id: string, slug?: string | null, name?: string | null, coverUrl?: string | null, mobileImageUrl?: string | null, startDate?: any | null, finishDate?: any | null, isOffline?: boolean | null, broadcasts?: Array<{ __typename?: 'BroadcastType', startTime?: any | null, finishTime?: any | null, published?: boolean | null } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentType', id: string, slug?: string | null, title?: string | null, type?: ContentTypeEnum | null, coverUrl?: string | null, videoLength?: string | null, created?: any | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, firstName?: string | null, lastName?: string | null, title?: string | null, photoUrl?: string | null } | null> | null, news?: Array<{ __typename?: 'PostType', id: string, slug?: string | null, title?: string | null, imageUrl?: string | null, publishedAt?: any | null } | null> | null } | null };

export type SpeakerContentFragment = { __typename?: 'SpeakerType', content?: Array<{ __typename?: 'ContentType', id: string, slug?: string | null, title?: string | null, documentUrl?: string | null, type?: ContentTypeEnum | null, videoLength?: string | null, coverUrl?: string | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null } | null> | null };

export type SpeakerEventFragment = { __typename?: 'SpeakerType', events?: Array<{ __typename?: 'EventType', slug?: string | null, coverUrl?: string | null, mobileImageUrl?: string | null, name?: string | null, startDate?: any | null, finishDate?: any | null, enrollFinishDate?: any | null, placesLeft?: number | null, isOffline?: boolean | null, offRegistration?: boolean | null, alternativeAddress?: string | null, city?: string | null, promoted?: boolean | null } | null> | null };

export type SpeakerFragment = { __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null };

export type BecomeSpeakerMutationVariables = Exact<{
  input?: InputMaybe<SpeakerRequestInput>;
}>;


export type BecomeSpeakerMutation = { __typename?: 'Mutation', createSpeakerRequest?: { __typename?: 'SpeakerRequestMutation', speakerRequest?: { __typename?: 'SpeakerRequestType', id: string } | null } | null };

export type GetSpeakersByAlphabetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpeakersByAlphabetQuery = { __typename?: 'Query', speakersByAlphabet?: Array<{ __typename?: 'SpeakerAlphabet', letter?: string | null } | null> | null };

export type GetSpeakerQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type GetSpeakerQuery = { __typename?: 'Query', speakerById?: { __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null, content?: Array<{ __typename?: 'ContentType', id: string, slug?: string | null, title?: string | null, documentUrl?: string | null, type?: ContentTypeEnum | null, videoLength?: string | null, coverUrl?: string | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null } | null> | null, events?: Array<{ __typename?: 'EventType', slug?: string | null, coverUrl?: string | null, mobileImageUrl?: string | null, name?: string | null, startDate?: any | null, finishDate?: any | null, enrollFinishDate?: any | null, placesLeft?: number | null, isOffline?: boolean | null, offRegistration?: boolean | null, alternativeAddress?: string | null, city?: string | null, promoted?: boolean | null } | null> | null } | null };

export type GetSpeakersQueryVariables = Exact<{
  leagueOfLecturersWinner?: InputMaybe<Scalars['Boolean']>;
  season?: InputMaybe<Scalars['ID']>;
  showOnMainPage?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type GetSpeakersQuery = { __typename?: 'Query', speakers?: Array<{ __typename?: 'SpeakerType', bigPhotoUrl?: string | null, vkAccount?: string | null, telegramAccount?: string | null, id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, directionOfActivity?: Array<{ __typename?: 'TagCategoryType', name?: string | null, icon?: string | null } | null> | null }> | null };

export type GetMicroTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMicroTagsQuery = { __typename?: 'Query', microTags?: Array<{ __typename?: 'TagType', id: string, name?: string | null, slug?: string | null, tagCategory?: { __typename?: 'TagCategoryType', type?: TagCategoryTypeEnum | null } | null } | null> | null };

export type GetTagsQueryVariables = Exact<{
  onlyWithContent?: InputMaybe<Scalars['Boolean']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetTagsQuery = { __typename?: 'Query', tagCategory?: Array<{ __typename?: 'TagCategoryType', slug?: string | null, name?: string | null, icon?: string | null, hover?: string | null } | null> | null };

export type GetMacroTagBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  describeTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetMacroTagBySlugQuery = { __typename?: 'Query', tagCategoryBySlug?: { __typename?: 'TagCategoryType', slug?: string | null, name?: string | null, h1?: string | null, seoDescription?: string | null, tags?: Array<{ __typename?: 'TagType', id: string, name?: string | null, slug?: string | null, icon?: string | null, hover?: string | null, h1?: string | null, seoDescription?: string | null } | null> | null } | null };

export type GetUniversitiesQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']>;
}>;


export type GetUniversitiesQuery = { __typename?: 'Query', searchUniversities?: Array<{ __typename?: 'UniversitiesRealType', name?: string | null }> | null };

export type MemberTicketFragment = { __typename?: 'MemberTicketType', status?: MemberTicketStatusEnum | null, ticketNumber?: string | null, educationalExperience?: MemberTicketEducationalExperienceEnum | null, discountCard?: MemberTicketDiscountCardEnum | null, discountCardFile?: string | null, denialDate?: any | null };

export type TelegramUserFragment = { __typename?: 'TelegramUserType', tgUserId?: number | null, username?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null };

export type TelegramUserCreationMutationVariables = Exact<{
  input?: InputMaybe<TelegramUserInput>;
}>;


export type TelegramUserCreationMutation = { __typename?: 'Mutation', createTelegramUser?: { __typename?: 'CreateTelegramUserMutation', user?: { __typename?: 'UserType', telegramUser?: { __typename?: 'TelegramUserType', tgUserId?: number | null, username?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null } | null } | null } | null };

export type SaveUserDataMutationVariables = Exact<{
  user?: InputMaybe<UpdateUserInput>;
}>;


export type SaveUserDataMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserMutation', user?: { __typename?: 'UserType', id: string } | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, password?: string | null, username?: string | null, nickname?: string | null, avatarUrl?: string | null, avatar?: string | null, vkAvatar?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, email?: string | null, sex?: UserSexEnum | null, birthDate?: any | null, birthPlace?: string | null, phone?: string | null, position?: string | null, workPlace?: string | null, registrationCurrentGame?: boolean | null, regalia?: string | null, passportSeries?: string | null, passportNumber?: string | null, passportReleaseDate?: string | null, releaseDptCode?: string | null, releaseDptName?: string | null, registrationPlace?: string | null, addressDetail?: string | null, education?: string | null, academicDegree?: string | null, instagramAccount?: string | null, facebookAccount?: string | null, telegramAccount?: string | null, youtubeAccount?: string | null, vkAccount?: string | null, okAccount?: string | null, showLms?: boolean | null, ovz?: string | null, participantRoz?: string | null, graduationYear?: string | null, speciality?: string | null, isEmailVerificated?: boolean | null, whichUniversityUserCome?: { __typename?: 'UniversityType', name?: string | null } | null, events?: Array<{ __typename?: 'EventType', id: string, name?: string | null, intro?: string | null, slug?: string | null, startDate?: any | null, finishDate?: any | null, enrollFinishDate?: any | null, isOffline?: boolean | null, offRegistration?: boolean | null, placesLeft?: number | null, coverUrl?: string | null, mobileImageUrl?: string | null, videoUrl?: string | null, alternativeAddress?: string | null, isHideDateTime?: boolean | null, isHideWeekDays?: boolean | null, venue?: { __typename?: 'VenueType', id: string, capacity?: number | null, address?: { __typename?: 'AddressType', city?: string | null } | null } | null } | null> | null, address?: { __typename?: 'AddressType', area?: string | null, areaFiasId?: string | null, areaKladrId?: string | null, areaType?: string | null, areaTypeFull?: string | null, areaWithType?: string | null, block?: string | null, blockType?: string | null, blockTypeFull?: string | null, capitalMarker?: string | null, city?: string | null, cityArea?: string | null, cityDistrict?: string | null, cityDistrictFiasId?: string | null, cityDistrictKladrId?: string | null, cityDistrictType?: string | null, cityDistrictTypeFull?: string | null, cityDistrictWithType?: string | null, cityFiasId?: string | null, cityKladrId?: string | null, cityType?: string | null, cityTypeFull?: string | null, cityWithType?: string | null, country?: string | null, countryIsoCode?: string | null, entrance?: string | null, federalDistrict?: string | null, fiasCode?: string | null, fiasId?: string | null, fiasLevel?: string | null, flat?: string | null, flatArea?: string | null, flatCadnum?: string | null, flatFiasId?: string | null, flatType?: string | null, flatTypeFull?: string | null, floor?: string | null, geoLat?: string | null, geoLon?: string | null, geonameId?: string | null, historyValues?: Array<string | null> | null, house?: string | null, houseCadnum?: string | null, houseFiasId?: string | null, houseKladrId?: string | null, houseType?: string | null, houseTypeFull?: string | null, kladrId?: string | null, postalBox?: string | null, postalCode?: string | null, region?: string | null, regionFiasId?: string | null, regionIsoCode?: string | null, regionKladrId?: string | null, regionType?: string | null, regionTypeFull?: string | null, regionWithType?: string | null, settlement?: string | null, settlementFiasId?: string | null, settlementKladrId?: string | null, settlementType?: string | null, settlementTypeFull?: string | null, settlementWithType?: string | null, street?: string | null, streetFiasId?: string | null, streetKladrId?: string | null, streetType?: string | null, streetTypeFull?: string | null, streetWithType?: string | null, timezone?: string | null, unparsedParts?: string | null, value?: string | null } | null, quizTeam?: Array<{ __typename?: 'TeamType', name?: string | null, avatar?: string | null, city?: string | null, firstGame?: boolean | null, avatarUrl?: string | null }> | null, leagueLecturersEnrollment?: { __typename?: 'LeagueOfLecturersEnrollmentType', id: string, stage?: number | null, status?: EnrollmentStatusEnum | null, videocard?: string | null, lectureName?: string | null, lectureVideo?: string | null, agreementFile?: string | null, agreementFilePart2?: string | null, agreementFilePart3?: string | null, performanceTheme?: string | null, firstThemeOfSpeech?: string | null, secondThemeOfSpeech?: string | null, thirdThemeOfSpeech?: string | null, fourthThemeOfSpeech?: string | null, season?: { __typename?: 'LeagueOfLecturersSeasonType', id: string, title?: string | null, applicationStartsAt?: any | null, applicationFinishesAt?: any | null, seasonEndDate?: any | null } | null } | null, telegramUser?: { __typename?: 'TelegramUserType', tgUserId?: number | null, username?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null } | null, memberTicket?: { __typename?: 'MemberTicketType', status?: MemberTicketStatusEnum | null, ticketNumber?: string | null, educationalExperience?: MemberTicketEducationalExperienceEnum | null, discountCard?: MemberTicketDiscountCardEnum | null, discountCardFile?: string | null, denialDate?: any | null } | null, speakerRequests?: { __typename?: 'SpeakerRequestType', status?: SpeakerRequestStatusEnum | null, denialDate?: any | null } | null, userLikes?: Array<{ __typename?: 'LikesType', content?: { __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, created?: any | null, coverUrl?: string | null, promoted?: boolean | null, documentUrl?: string | null, videoUrl?: string | null, videoLength?: string | null, countView?: number | null, countLikes?: number | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, event?: { __typename?: 'EventType', name?: string | null } | null } | null }> | null, userFavorites?: Array<{ __typename?: 'FavoritesType', content?: { __typename?: 'ContentType', id: string, type?: ContentTypeEnum | null, slug?: string | null, title?: string | null, created?: any | null, coverUrl?: string | null, promoted?: boolean | null, documentUrl?: string | null, videoUrl?: string | null, videoLength?: string | null, countView?: number | null, countLikes?: number | null, contentLikeByUsername?: boolean | null, contentFavoriteByUsername?: boolean | null, describeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, themeTags?: Array<{ __typename?: 'TagType', name?: string | null } | null> | null, speakers?: Array<{ __typename?: 'SpeakerType', id: string, title?: string | null, description?: string | null, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, created?: string | null, vkAccount?: string | null, telegramAccount?: string | null } | null> | null, event?: { __typename?: 'EventType', name?: string | null } | null } | null }> | null, isLike?: Array<{ __typename?: 'LikesType', id: string } | null> | null, isFavorite?: Array<{ __typename?: 'FavoritesType', id: string } | null> | null, projects?: Array<{ __typename?: 'ProjectType', slug?: string | null } | null> | null } | null };
